(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('@babel/runtime/regenerator'), require('@babel/runtime/helpers/asyncToGenerator'), require('@babel/runtime/helpers/slicedToArray'), require('@babel/runtime/helpers/classCallCheck'), require('@babel/runtime/helpers/createClass'), require('@rsksmart/rbank-utils'), require('lodash')) :
  typeof define === 'function' && define.amd ? define(['@babel/runtime/regenerator', '@babel/runtime/helpers/asyncToGenerator', '@babel/runtime/helpers/slicedToArray', '@babel/runtime/helpers/classCallCheck', '@babel/runtime/helpers/createClass', '@rsksmart/rbank-utils', 'lodash'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global['rbank-market'] = factory(global._regeneratorRuntime, global._asyncToGenerator, global._slicedToArray, global._classCallCheck, global._createClass, global.rbankUtils, global._));
}(this, (function (_regeneratorRuntime, _asyncToGenerator, _slicedToArray, _classCallCheck, _createClass, rbankUtils, _) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var _regeneratorRuntime__default = /*#__PURE__*/_interopDefaultLegacy(_regeneratorRuntime);
  var _asyncToGenerator__default = /*#__PURE__*/_interopDefaultLegacy(_asyncToGenerator);
  var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
  var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
  var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
  var ___default = /*#__PURE__*/_interopDefaultLegacy(_);

  var contractName = "Market";
  var abi = [
  	{
  		inputs: [
  			{
  				internalType: "contract ERC20",
  				name: "_token",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_baseBorrowAnnualRate",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "_blocksPerYear",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "_utilizationRateFraction",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "constructor"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "user",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "Borrow",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "borrower",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "liquidator",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "address",
  				name: "collateralMarket",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "collateralAmount",
  				type: "uint256"
  			}
  		],
  		name: "LiquidateBorrow",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "user",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "PayBorrow",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "user",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "Redeem",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "user",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "Supply",
  		type: "event"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "FACTOR",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "accrualBlockNumber",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "baseBorrowRate",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "blocksPerYear",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "borrowIndex",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "controller",
  		outputs: [
  			{
  				internalType: "contract Controller",
  				name: "",
  				type: "address"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "deployBlock",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "owner",
  		outputs: [
  			{
  				internalType: "address",
  				name: "",
  				type: "address"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "supplyIndex",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "token",
  		outputs: [
  			{
  				internalType: "contract ERC20",
  				name: "",
  				type: "address"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "totalBorrows",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "totalSupply",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "utilizationRateFraction",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "getCash",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "cash",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "borrowed",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "reserves",
  				type: "uint256"
  			}
  		],
  		name: "utilizationRate",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "pure",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "cash",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "borrowed",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "reserves",
  				type: "uint256"
  			}
  		],
  		name: "getBorrowRate",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "cash",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "borrowed",
  				type: "uint256"
  			},
  			{
  				internalType: "uint256",
  				name: "reserves",
  				type: "uint256"
  			}
  		],
  		name: "getSupplyRate",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "borrowRatePerBlock",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "supplyRatePerBlock",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "user",
  				type: "address"
  			}
  		],
  		name: "supplyOf",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "user",
  				type: "address"
  			}
  		],
  		name: "borrowBy",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "user",
  				type: "address"
  			}
  		],
  		name: "updatedBorrowBy",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "user",
  				type: "address"
  			}
  		],
  		name: "updatedSupplyOf",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "contract Controller",
  				name: "_controller",
  				type: "address"
  			}
  		],
  		name: "setController",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "supply",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "redeem",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "borrow",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  		],
  		name: "accrueInterest",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "getUpdatedTotalBorrows",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "getUpdatedTotalSupply",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "payBorrow",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "borrower",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			},
  			{
  				internalType: "contract MarketInterface",
  				name: "collateralMarket",
  				type: "address"
  			}
  		],
  		name: "liquidateBorrow",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "sender",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "receiver",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "amount",
  				type: "uint256"
  			}
  		],
  		name: "transferTo",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	}
  ];
  var metadata = "{\"compiler\":{\"version\":\"0.5.16+commit.9c3226ce\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"contract ERC20\",\"name\":\"_token\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_baseBorrowAnnualRate\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_blocksPerYear\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_utilizationRateFraction\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"Borrow\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"borrower\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"liquidator\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"address\",\"name\":\"collateralMarket\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"collateralAmount\",\"type\":\"uint256\"}],\"name\":\"LiquidateBorrow\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"PayBorrow\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"Redeem\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"Supply\",\"type\":\"event\"},{\"constant\":true,\"inputs\":[],\"name\":\"FACTOR\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"accrualBlockNumber\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[],\"name\":\"accrueInterest\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"baseBorrowRate\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"blocksPerYear\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"borrow\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"}],\"name\":\"borrowBy\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"borrowIndex\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"borrowRatePerBlock\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"controller\",\"outputs\":[{\"internalType\":\"contract Controller\",\"name\":\"\",\"type\":\"address\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"deployBlock\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"cash\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"borrowed\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"reserves\",\"type\":\"uint256\"}],\"name\":\"getBorrowRate\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"getCash\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"cash\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"borrowed\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"reserves\",\"type\":\"uint256\"}],\"name\":\"getSupplyRate\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"getUpdatedTotalBorrows\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"getUpdatedTotalSupply\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"borrower\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"},{\"internalType\":\"contract MarketInterface\",\"name\":\"collateralMarket\",\"type\":\"address\"}],\"name\":\"liquidateBorrow\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"payBorrow\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"redeem\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"contract Controller\",\"name\":\"_controller\",\"type\":\"address\"}],\"name\":\"setController\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"supply\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"supplyIndex\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"}],\"name\":\"supplyOf\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"supplyRatePerBlock\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"token\",\"outputs\":[{\"internalType\":\"contract ERC20\",\"name\":\"\",\"type\":\"address\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"totalBorrows\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"totalSupply\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"sender\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"receiver\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"amount\",\"type\":\"uint256\"}],\"name\":\"transferTo\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"}],\"name\":\"updatedBorrowBy\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"user\",\"type\":\"address\"}],\"name\":\"updatedSupplyOf\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"cash\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"borrowed\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"reserves\",\"type\":\"uint256\"}],\"name\":\"utilizationRate\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"pure\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"utilizationRateFraction\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"}],\"devdoc\":{\"methods\":{}},\"userdoc\":{\"methods\":{}}},\"settings\":{\"compilationTarget\":{\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Market.sol\":\"Market\"},\"evmVersion\":\"istanbul\",\"libraries\":{},\"optimizer\":{\"enabled\":false,\"runs\":200},\"remappings\":[]},\"sources\":{\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol\":{\"keccak256\":\"0x7a986783350abcbf9337b2ecc2dbf6e501b66856963b2440b6dc4f6be2e1f19a\",\"urls\":[\"bzz-raw://a68c2bb147c6f511a2e053769fe0783aa04b28d994515e8cfb9a33b281d269af\",\"dweb:/ipfs/QmeCmC5XYdHfdNyNvR3wHrFwaLkm9a2czxDPYWMzasXK4p\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Market.sol\":{\"keccak256\":\"0x82a6efb5ee5fb31f9b51e2433eef8b645f62431c65dfd726eadb786e330d9889\",\"urls\":[\"bzz-raw://81c87d9a943bfce274761e101645f18ee065a4b69d86c80726c9fab472d01c98\",\"dweb:/ipfs/QmPrLBVo498tuKfAC2ixXA2m3ADvfn9sRxxJ2LJeobqLZ6\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/MarketInterface.sol\":{\"keccak256\":\"0x14c49e26afee92737bfb10d9da5b0e064b4bf2adedf3dbb6a5c73c1914ef98f0\",\"urls\":[\"bzz-raw://f3d76e3cc0c62c31030c4c09b0eec1274e61a3dc76c47cdff9882a6b7f77c5f7\",\"dweb:/ipfs/QmZyGzmFQjRn2UyYFWmPLimWBDgBkGVW8V1WxP5kPm3RMJ\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/ERC20.sol\":{\"keccak256\":\"0x02c6ac5bd8a7fd2f9f3cfd1994cc6863c3c976dc9cc0e6feaf6a35ab74a995c7\",\"urls\":[\"bzz-raw://dd007c7ab067c2cbcb28bd6df30a2309c8cb4a5d57d568635e22a77fbaa19db6\",\"dweb:/ipfs/QmSSixKxCuUxQvNY6i9cztvnUjUcSi7vs7dVrFLxSiH4dg\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/ERC20Basic.sol\":{\"keccak256\":\"0x608e6105b904166b430c78d9753cf47fda95c16a77cf32766b7788517fa30b83\",\"urls\":[\"bzz-raw://312dd66988716a0fa6d93869bea9a309c565050a181667af846ce62fb1528c14\",\"dweb:/ipfs/QmejTneFNrzGshLhJpHE2dTJVhGWvFkwgi1eHP2CAj6uqE\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/SafeMath.sol\":{\"keccak256\":\"0xa83f091bb99c1f412f78ceb5ca5a23f8adc2fdf0f20d730ac5de3ed99609d08a\",\"urls\":[\"bzz-raw://3d8d04982ebb23c75e529ae3fab2c0e53d7ffccf6b90308219f232f578bbc9b5\",\"dweb:/ipfs/QmeZ8TeKWfYHgZ1H5d5uWzjwVwFsC4E2sbBDxy96XWabJr\"]}},\"version\":1}";
  var bytecode = "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";
  var deployedBytecode = "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";
  var sourceMap = "118:11333:1:-;;;1240:550;8:9:-1;5:2;;;30:1;27;20:12;5:2;1240:550:1;;;;;;;;;;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;1240:550:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1402:1;1377:6;1371:25;;;:27;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;1371:27:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;1371:27:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1371:27:1;;;;;;;;;;;;;;;;:32;;1363:41;;;;;;1422:10;1414:5;;:18;;;;;;;;;;;;;;;;;;1450:6;1442:5;;:14;;;;;;;;;;;;;;;;;;870:4;1466:11;:20;;;;870:4;1496:11;:20;;;;1542:14;1526:13;:30;;;;1583:41;1609:14;1583:21;:25;;;;;;:41;;;;:::i;:::-;1566:14;:58;;;;1655:12;1634:18;:33;;;;1703:44;1732:14;1703:24;:28;;;;;;:44;;;;:::i;:::-;1677:23;:70;;;;1771:12;1757:11;:26;;;;1240:550;;;;118:11333;;714:290:8;772:7;996:1;992;:5;;;;;;985:12;;714:290;;;;:::o;118:11333:1:-;;;;;;;";
  var deployedSourceMap = "118:11333:1:-;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;118:11333:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2318:240;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2318:240:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;278:23;;;:::i;:::-;;;;;;;;;;;;;;;;;;;3300:421;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3300:421:1;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;4258:129;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;4258:129:1;;;;;;;;;;;;;;;;;:::i;:::-;;840:34;;;:::i;:::-;;;;;;;;;;;;;;;;;;;1981:100;;;:::i;:::-;;;;;;;;;;;;;;;;;;;404:24;;;:::i;:::-;;;;;;;;;;;;;;;;;;;2564:252;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2564:252:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;3078:104;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3078:104:1;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;338:30;;;:::i;:::-;;;;;;;;;;;;;;;;;;;2087:225;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2087:225:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;8692:247;;;:::i;:::-;;;;;;;;;;;;;;;;;;;192:20;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;4147:105;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;4147:105:1;;;;;;;;;;;;;;;;;;;:::i;:::-;;308:23;;;:::i;:::-;;;;;;;;;;;;;;;;;;;537:25;;;:::i;:::-;;;;;;;;;;;;;;;;;;;507:23;;;:::i;:::-;;;;;;;;;;;;;;;;;;;11274:175;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;11274:175:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;6985:310;;;:::i;:::-;;375:23;;;:::i;:::-;;;;;;;;;;;;;;;;;;;3188:106;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3188:106:1;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;2950:122;;;:::i;:::-;;;;;;;;;;;;;;;;;;;466:35;;;:::i;:::-;;;;;;;;;;;;;;;;;;;434:26;;;:::i;:::-;;;;;;;;;;;;;;;;;;;8945:243;;;:::i;:::-;;;;;;;;;;;;;;;;;;;6003:976;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6003:976:1;;;;;;;;;;;;;;;;;:::i;:::-;;4936:456;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;4936:456:1;;;;;;;;;;;;;;;;;:::i;:::-;;3727:414;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3727:414:1;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;9194:292;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;9194:292:1;;;;;;;;;;;;;;;;;:::i;:::-;;10467:801;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;10467:801:1;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;243:28;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;2822:122;;;:::i;:::-;;;;;;;;;;;;;;;;;;;219:18;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;2318:240;2403:4;2419:7;2429:41;2445:4;2451:8;2461;2429:15;:41::i;:::-;2419:51;;2488:63;2536:14;;2488:43;870:4;2488:31;2495:23;;2488:2;:6;;:31;;;;:::i;:::-;:35;;:43;;;;:::i;:::-;:47;;:63;;;;:::i;:::-;2481:70;;;2318:240;;;;;:::o;278:23::-;;;;:::o;3300:421::-;3360:4;3376:31;3410:7;:13;3418:4;3410:13;;;;;;;;;;;;;;;3376:47;;3460:1;3438:8;:18;;;:23;3434:49;;;3482:1;3475:8;;;;;3434:49;3494:20;3524:19;3590:40;3617:12;3590:26;:40::i;:::-;3554:76;;;;;;;;3648:66;3691:8;:22;;;3648:38;3671:14;3648:8;:18;;;:22;;:38;;;;:::i;:::-;:42;;:66;;;;:::i;:::-;3641:73;;;;;3300:421;;;;:::o;4258:129::-;4304:34;4319:10;4331:6;4304:14;:34::i;:::-;4361:10;4354:26;;;4373:6;4354:26;;;;;;;;;;;;;;;;;;4258:129;:::o;840:34::-;870:4;840:34;:::o;1981:100::-;2021:4;2044:5;;;;;;;;;;;:15;;;2068:4;2044:30;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;2044:30:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;2044:30:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2044:30:1;;;;;;;;;;;;;;;;2037:37;;1981:100;:::o;404:24::-;;;;:::o;2564:252::-;2649:4;2665:15;2683:39;2697:4;2703:8;2713;2683:13;:39::i;:::-;2665:57;;2740:69;870:4;2740:57;2786:10;2740:41;2756:4;2762:8;2772;2740:15;:41::i;:::-;:45;;:57;;;;:::i;:::-;:61;;:69;;;;:::i;:::-;2733:76;;;2564:252;;;;;:::o;3078:104::-;3131:4;3154:8;:14;3163:4;3154:14;;;;;;;;;;;;;;;:21;;;3147:28;;3078:104;;;:::o;338:30::-;;;;:::o;2087:225::-;2174:4;2206:1;2194:8;:13;2190:39;;;2228:1;2221:8;;;;2190:39;2247:58;2272:32;2295:8;2272:18;2281:8;2272:4;:8;;:18;;;;:::i;:::-;:22;;:32;;;;:::i;:::-;2247:20;870:4;2247:8;:12;;:20;;;;:::i;:::-;:24;;:58;;;;:::i;:::-;2240:65;;2087:225;;;;;;:::o;8692:247::-;8747:4;8763:20;8793:19;8859:40;8886:12;8859:26;:40::i;:::-;8823:76;;;;;;;;8917:15;8910:22;;;;8692:247;:::o;192:20::-;;;;;;;;;;;;;:::o;4147:105::-;1849:5;;;;;;;;;;;1835:19;;:10;:19;;;1827:28;;;;;;4234:11;4221:10;;:24;;;;;;;;;;;;;;;;;;4147:105;:::o;308:23::-;;;;:::o;537:25::-;;;;:::o;507:23::-;;;;:::o;11274:175::-;1945:10;;;;;;;;;;;1923:33;;:10;:33;;;1915:42;;;;;;11390:1;11381:6;:10;11373:19;;;;;;11402:40;11417:6;11425:8;11435:6;11402:14;:40::i;:::-;11274:175;;;:::o;6985:310::-;7028:23;7054:12;7028:38;;7107:46;7134:18;7107:26;:46::i;:::-;7078:12;;7092:11;;7077:76;;;;;;;;;;;;7192:46;7219:18;7192:26;:46::i;:::-;7164:11;;7177;;7163:75;;;;;;;;;;;;7270:18;7249;:39;;;;6985:310;:::o;375:23::-;;;;:::o;3188:106::-;3241:4;3264:7;:13;3272:4;3264:13;;;;;;;;;;;;;;;:23;;;3257:30;;3188:106;;;:::o;2950:122::-;3001:4;3024:41;3038:9;:7;:9::i;:::-;3049:12;;3063:1;3024:13;:41::i;:::-;3017:48;;2950:122;:::o;466:35::-;;;;:::o;434:26::-;;;;:::o;8945:243::-;8999:4;9015:19;9044;9109:40;9136:12;9109:26;:40::i;:::-;9074:75;;;;;;;;9167:14;9160:21;;;;8945:243;:::o;6003:976::-;6091:6;6057:5;;;;;;;;;;;:15;;;6081:4;6057:30;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6057:30:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6057:30:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6057:30:1;;;;;;;;;;;;;;;;:40;;6049:49;;;;;;6109:16;:14;:16::i;:::-;6136:37;6176:7;:19;6184:10;6176:19;;;;;;;;;;;;;;;6136:59;;6237:1;6210:14;:24;;;:28;6206:316;;;6254:13;6270:105;6350:14;:24;;;6270:75;6316:14;:28;;;6270:41;6299:11;;6270:14;:24;;;:28;;:41;;;;:::i;:::-;:45;;:75;;;;:::i;:::-;:79;;:105;;;;:::i;:::-;6254:121;;6417:38;6446:8;6417:14;:24;;;:28;;:38;;;;:::i;:::-;6390:14;:24;;:65;;;;6500:11;;6469:14;:28;;:42;;;;6206:316;;6586:51;6635:1;6586:44;6623:6;6586:10;;;;;;;;;;;:17;;;6612:4;6586:32;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6586:32:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6586:32:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6586:32:1;;;;;;;;;;;;;;;;:36;;:44;;;;:::i;:::-;:48;;:51;;;;:::i;:::-;6540:10;;;;;;;;;;;:30;;;6571:10;6540:42;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6540:42:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6540:42:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6540:42:1;;;;;;;;;;;;;;;;:97;;6532:138;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6689:5;;;;;;;;;;;:14;;;6704:10;6716:6;6689:34;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;6689:34:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;6689:34:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;6689:34:1;;;;;;;;;;;;;;;;6681:73;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6792:36;6821:6;6792:14;:24;;;:28;;:36;;;;:::i;:::-;6765:14;:24;;:63;;;;6869:11;;6838:14;:28;;:42;;;;6906:24;6923:6;6906:12;;:16;;:24;;;;:::i;:::-;6891:12;:39;;;;6953:10;6946:26;;;6965:6;6946:26;;;;;;;;;;;;;;;;;;6003:976;;:::o;4936:456::-;4982:46;4997:10;5009;5021:6;4982:14;:46::i;:::-;5039:24;5073;5153:10;;;;;;;;;;;:27;;;5181:10;5153:39;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5153:39:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;5153:39:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5153:39:1;;;;;;;;;;;;;;;;;;;;;;;;;5108:84;;;;;;;;5234:108;5320:10;;;;;;;;;;;:19;;;:21;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5320:21:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;5320:21:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5320:21:1;;;;;;;;;;;;;;;;5234:81;5258:56;5284:10;;;;;;;;;;;:27;;;:29;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5284:29:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;5284:29:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5284:29:1;;;;;;;;;;;;;;;;5258:10;;;;;;;;;;;:19;;;:21;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5258:21:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;5258:21:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5258:21:1;;;;;;;;;;;;;;;;:25;;:56;;;;:::i;:::-;5234:19;:23;;:81;;;;:::i;:::-;:85;;:108;;;;:::i;:::-;5211:19;:131;;5203:140;;;;;;5366:10;5359:26;;;5378:6;5359:26;;;;;;;;;;;;;;;;;;4936:456;;;:::o;3727:414::-;3787:4;3803:31;3837:8;:14;3846:4;3837:14;;;;;;;;;;;;;;;3803:48;;3885:1;3866:8;:15;;;:20;3862:46;;;3907:1;3900:8;;;;;3862:46;3919:19;3948;4013:40;4040:12;4013:26;:40::i;:::-;3978:75;;;;;;;;4071:63;4111:8;:22;;;4071:35;4091:14;4071:8;:15;;;:19;;:35;;;;:::i;:::-;:39;;:63;;;;:::i;:::-;4064:70;;;;;3727:414;;;;:::o;9194:292::-;9243:9;9262:15;9309:49;9327:10;9339;9351:6;9309:17;:49::i;:::-;9288:70;;;;;;;;9384:10;9374:27;;;9396:4;9374:27;;;;;;;;;;;;;;;;;;9429:1;9416:10;:14;9412:67;;;9456:10;9449:30;;;9468:10;9449:30;;;;;;;;;;;;;;;;;;9412:67;9194:292;;;:::o;10467:801::-;10591:1;10582:6;:10;10574:19;;;;;;10623:10;10611:22;;:8;:22;;;;10603:31;;;;;;10645:16;:14;:16::i;:::-;10671;:31;;;:33;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;10671:33:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;10671:33:1;;;;10715:9;10727:25;10743:8;10727:15;:25::i;:::-;10715:37;;10779:6;10771:4;:14;;10763:23;;;;;;10835:6;10804:5;;;;;;;;;;;:15;;;10820:10;10804:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;10804:27:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;10804:27:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;10804:27:1;;;;;;;;;;;;;;;;:37;;10796:46;;;;;;10853:21;10877:10;;;;;;;;;;;:30;;;10908:8;10918:10;10930:6;10938:16;10877:78;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;10877:78:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;10877:78:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;10877:78:1;;;;;;;;;;;;;;;;10853:102;;10966:9;10985:15;11032:47;11050:10;11062:8;11072:6;11032:17;:47::i;:::-;11011:68;;;;;;;;11127:10;11095:88;;11111:8;11095:88;;;11121:4;11147:16;11166;11095:88;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;11211:1;11198:10;:14;11194:67;;;11238:10;11231:30;;;11250:10;11231:30;;;;;;;;;;;;;;;;;;11194:67;10467:801;;;;;;;:::o;243:28::-;;;;;;;;;;;;;:::o;2822:122::-;2873:4;2896:41;2910:9;:7;:9::i;:::-;2921:12;;2935:1;2896:13;:41::i;:::-;2889:48;;2822:122;:::o;219:18::-;;;;;;;;;;;;;:::o;211:413:8:-;269:9;516:1;511;:6;507:45;;;540:1;533:8;;;;507:45;570:1;566;:5;562:9;;597:1;592;588;:5;;;;;;:10;581:18;;;;616:1;609:8;;211:413;;;;;:::o;714:290::-;772:7;996:1;992;:5;;;;;;985:12;;714:290;;;;:::o;1314:137::-;1372:9;1401:1;1397;:5;1393:9;;1424:1;1419;:6;;1412:14;;;;1443:1;1436:8;;1314:137;;;;:::o;7301:693:1:-;7381:20;7403:19;7456:18;;7438:14;:36;7434:88;;7496:12;;7510:11;;7488:34;;;;;;7434:88;7553:1;7537:12;;:17;7533:69;;;7576:12;;7590:11;;7568:34;;;;;;7533:69;7613:15;7648:18;;7631:14;:35;7613:53;;7677:25;7705:36;7730:10;7705:20;:18;:20::i;:::-;:24;;:36;;;;:::i;:::-;7677:64;;7751:24;7778:50;870:4;7778:38;7803:12;;7778:20;:24;;:38;;;;:::i;:::-;:42;;:50;;;;:::i;:::-;7751:77;;7856:66;7910:11;;7856:49;870:4;7856:37;7881:11;;7856:20;:24;;:37;;;;:::i;:::-;:41;;:49;;;;:::i;:::-;:53;;:66;;;;:::i;:::-;7839:83;;7950:37;7974:12;;7950:19;:23;;:37;;;;:::i;:::-;7932:55;;7301:693;;;;;;;:::o;4393:537::-;4516:5;;;;;;;;;;;:18;;;4535:8;4553:4;4560:6;4516:51;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;4516:51:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;4516:51:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;4516:51:1;;;;;;;;;;;;;;;;4508:80;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;4599:16;:14;:16::i;:::-;4626:37;4666:8;:18;4675:8;4666:18;;;;;;;;;;;;;;;4626:58;;4719:25;4735:8;4719:15;:25::i;:::-;4695:14;:21;;:49;;;;4782:37;4812:6;4782:8;:18;4791:8;4782:18;;;;;;;;;;;;;;;:25;;;:29;;:37;;;;:::i;:::-;4754:8;:18;4763:8;4754:18;;;;;;;;;;;;;;;:25;;:65;;;;4864:11;;4829:8;:18;4838:8;4829:18;;;;;;;;;;;;;;;:32;;:46;;;;4900:23;4916:6;4900:11;;:15;;:23;;;;:::i;:::-;4886:11;:37;;;;4393:537;;;:::o;1124:120:8:-;1182:7;1213:1;1208;:6;;1201:14;;;;1236:1;1232;:5;1225:12;;1124:120;;;;:::o;5398:599:1:-;5532:6;5498:5;;;;;;;;;;;:15;;;5522:4;5498:30;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5498:30:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;5498:30:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5498:30:1;;;;;;;;;;;;;;;;:40;;5490:49;;;;;;5550:16;:14;:16::i;:::-;5577:37;5617:8;:18;5626:8;5617:18;;;;;;;;;;;;;;;5577:58;;5670:25;5686:8;5670:15;:25::i;:::-;5646:14;:21;;:49;;;;5740:11;;5705:8;:18;5714:8;5705:18;;;;;;;;;;;;;;;:32;;:46;;;;5795:6;5770:14;:21;;;:31;;5762:40;;;;;;5821:5;;;;;;;;;;;:14;;;5836:8;5846:6;5821:32;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;5821:32:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;5821:32:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;5821:32:1;;;;;;;;;;;;;;;;5813:61;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5909:33;5935:6;5909:14;:21;;;:25;;:33;;;;:::i;:::-;5885:14;:21;;:57;;;;5967:23;5983:6;5967:11;;:15;;:23;;;;:::i;:::-;5953:11;:37;;;;5398:599;;;;:::o;8000:686::-;8080:19;8101;8154:18;;8136:14;:36;8132:87;;8194:11;;8207;;8186:33;;;;;;8132:87;8249:1;8234:11;;:16;8230:67;;;8272:11;;8285;;8264:33;;;;;;8230:67;8308:15;8343:18;;8326:14;:35;8308:53;;8372:25;8400:36;8425:10;8400:20;:18;:20::i;:::-;:24;;:36;;;;:::i;:::-;8372:64;;8446:24;8473:49;870:4;8473:37;8498:11;;8473:20;:24;;:37;;;;:::i;:::-;:41;;:49;;;;:::i;:::-;8446:76;;8550:66;8604:11;;8550:49;870:4;8550:37;8575:11;;8550:20;:24;;:37;;;;:::i;:::-;:41;;:49;;;;:::i;:::-;:53;;:66;;;;:::i;:::-;8533:83;;8643:36;8667:11;;8643:19;:23;;:36;;;;:::i;:::-;8626:53;;8000:686;;;;;;;:::o;9492:969::-;9583:9;9594:13;9619:16;:14;:16::i;:::-;9646:31;9680:7;:17;9688:8;9680:17;;;;;;;;;;;;;;;9646:51;;9737:1;9716:8;:18;;;:22;9708:31;;;;;;9750:13;9766:87;9834:8;:18;;;9766:63;9806:8;:22;;;9766:35;9789:11;;9766:8;:18;;;:22;;:35;;;;:::i;:::-;:39;;:63;;;;:::i;:::-;:67;;:87;;;;:::i;:::-;9750:103;;9885:32;9908:8;9885;:18;;;:22;;:32;;;;:::i;:::-;9864:8;:18;;:53;;;;9952:11;;9927:8;:22;;:36;;;;9974:15;10025:6;10004:8;:18;;;:27;10000:142;;;10060:30;10071:8;:18;;;10060:6;:10;;:30;;;;:::i;:::-;10047:43;;10113:8;:18;;;10104:27;;10000:142;10160:5;;;;;;;;;;;:18;;;10179:5;10194:4;10201:6;10160:48;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;10160:48:1;;;;8:9:-1;5:2;;;45:16;42:1;39;24:38;77:16;74:1;67:27;5:2;10160:48:1;;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;10160:48:1;;;;;;;;;;;;;;;;10152:77;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10261:30;10284:6;10261:8;:18;;;:22;;:30;;;;:::i;:::-;10240:8;:18;;:51;;;;10316:24;10333:6;10316:12;;:16;;:24;;;;:::i;:::-;10301:12;:39;;;;10368:1;10355:10;:14;10351:65;;;10383:33;10398:5;10405:10;10383:14;:33::i;:::-;10351:65;10435:6;10443:10;10427:27;;;;;;;9492:969;;;;;;:::o";
  var source = "pragma solidity >=0.5.0 <0.6.0;\n\nimport \"./test/ERC20.sol\";\nimport \"./Controller.sol\";\nimport \"./test/SafeMath.sol\";\n\ncontract Market is MarketInterface {\n    using SafeMath for uint256;\n\n    address public owner;\n\n    ERC20 public token;\n    Controller public controller;\n\n    uint public totalSupply;\n\n    uint public supplyIndex;\n\n    uint public accrualBlockNumber;\n\n    uint public borrowIndex;\n    uint public totalBorrows;\n    uint public baseBorrowRate;\n    uint public utilizationRateFraction;\n    uint public deployBlock;\n\n    uint public blocksPerYear;\n\n    struct SupplySnapshot {\n        uint supply;\n        uint interestIndex;\n    }\n\n    struct BorrowSnapshot {\n        uint principal;\n        uint interestIndex;\n    }\n\n    mapping (address => SupplySnapshot) supplies;\n    mapping (address => BorrowSnapshot) borrows;\n\n    uint public constant FACTOR = 1e18;\n\n    event Supply(address indexed user, uint amount);\n    event Redeem(address indexed user, uint amount);\n    event Borrow(address indexed user, uint amount);\n    event PayBorrow(address indexed user, uint amount);\n    event LiquidateBorrow(address indexed borrower, uint amount, address indexed liquidator, address collateralMarket, uint collateralAmount);\n\n    constructor(ERC20 _token, uint _baseBorrowAnnualRate, uint _blocksPerYear, uint _utilizationRateFraction) public {\n        require(ERC20(_token).totalSupply() >= 0);\n        owner = msg.sender;\n        token = _token;\n        borrowIndex = FACTOR;\n        supplyIndex = FACTOR;\n        blocksPerYear = _blocksPerYear;\n        baseBorrowRate = _baseBorrowAnnualRate.div(_blocksPerYear);\n        accrualBlockNumber = block.number;\n        utilizationRateFraction = _utilizationRateFraction.div(_blocksPerYear);\n        deployBlock = block.number;\n    }\n\n    modifier onlyOwner() {\n        require(msg.sender == owner);\n        _;\n    }\n\n    modifier onlyController() {\n        require(msg.sender == address(controller));\n        _;\n    }\n\n    function getCash() public view returns (uint) {\n        return token.balanceOf(address(this));\n    }\n\n    function utilizationRate(uint cash, uint borrowed, uint reserves) public pure returns (uint) {\n        if (borrowed == 0)\n            return 0;\n\n        return borrowed.mul(FACTOR).div(cash.add(borrowed).sub(reserves));\n    }\n\n    function getBorrowRate(uint cash, uint borrowed, uint reserves) public view returns (uint) {\n        uint ur = utilizationRate(cash, borrowed, reserves);\n\n        return ur.mul(utilizationRateFraction).div(FACTOR).add(baseBorrowRate);\n    }\n\n    function getSupplyRate(uint cash, uint borrowed, uint reserves) public view returns (uint) {\n        uint borrowRate = getBorrowRate(cash, borrowed, reserves);\n\n        return utilizationRate(cash, borrowed, reserves).mul(borrowRate).div(FACTOR);\n    }\n\n    function borrowRatePerBlock() public view returns (uint) {\n        return getBorrowRate(getCash(), totalBorrows, 0);\n    }\n\n    function supplyRatePerBlock() public view returns (uint) {\n        return getSupplyRate(getCash(), totalBorrows, 0);\n    }\n\n    function supplyOf(address user) public view returns (uint) {\n        return supplies[user].supply;\n    }\n\n    function borrowBy(address user) public view returns (uint) {\n        return borrows[user].principal;\n    }\n\n    function updatedBorrowBy(address user) public view returns (uint) {\n        BorrowSnapshot storage snapshot = borrows[user];\n\n        if (snapshot.principal == 0)\n            return 0;\n\n        uint newTotalBorrows;\n        uint newBorrowIndex;\n\n        (newTotalBorrows, newBorrowIndex) = calculateBorrowDataAtBlock(block.number);\n\n        return snapshot.principal.mul(newBorrowIndex).div(snapshot.interestIndex);\n    }\n\n    function updatedSupplyOf(address user) public view returns (uint) {\n        SupplySnapshot storage snapshot = supplies[user];\n\n        if (snapshot.supply == 0)\n            return 0;\n\n        uint newTotalSupply;\n        uint newSupplyIndex;\n\n        (newTotalSupply, newSupplyIndex) = calculateSupplyDataAtBlock(block.number);\n\n        return snapshot.supply.mul(newSupplyIndex).div(snapshot.interestIndex);\n    }\n\n    function setController(Controller _controller) public onlyOwner {\n        controller = _controller;\n    }\n\n    function supply(uint amount) public {\n        supplyInternal(msg.sender, amount);\n\n        emit Supply(msg.sender, amount);\n    }\n\n    function supplyInternal(address supplier, uint amount) internal {\n        // TODO check msg.sender != this\n        require(token.transferFrom(supplier, address(this), amount), \"No enough tokens\");\n\n        accrueInterest();\n\n        SupplySnapshot storage supplySnapshot = supplies[supplier];\n\n        supplySnapshot.supply = updatedSupplyOf(supplier);\n        supplies[supplier].supply = supplies[supplier].supply.add(amount);\n        supplies[supplier].interestIndex = supplyIndex;\n\n        totalSupply = totalSupply.add(amount);\n    }\n\n    function redeem(uint amount) public {\n        redeemInternal(msg.sender, msg.sender, amount);\n\n        uint supplierSupplyValue;\n        uint supplierBorrowValue;\n\n        (supplierSupplyValue, supplierBorrowValue) = controller.getAccountValues(msg.sender);\n\n        require(supplierSupplyValue >= supplierBorrowValue.mul(controller.MANTISSA().add(controller.collateralFactor())).div(controller.MANTISSA()));\n\n        emit Redeem(msg.sender, amount);\n    }\n\n    function redeemInternal(address supplier, address receiver, uint amount) internal {\n        require(token.balanceOf(address(this)) >= amount);\n\n        accrueInterest();\n\n        SupplySnapshot storage supplySnapshot = supplies[supplier];\n\n        supplySnapshot.supply = updatedSupplyOf(supplier);\n        supplies[supplier].interestIndex = supplyIndex;\n\n        require(supplySnapshot.supply >= amount);\n\n        require(token.transfer(receiver, amount), \"No enough tokens\");\n\n        supplySnapshot.supply = supplySnapshot.supply.sub(amount);\n\n        totalSupply = totalSupply.sub(amount);\n    }\n\n    function borrow(uint amount) public {\n        require(token.balanceOf(address(this)) >= amount);\n\n        accrueInterest();\n\n        BorrowSnapshot storage borrowSnapshot = borrows[msg.sender];\n\n        if (borrowSnapshot.principal > 0) {\n            uint interest = borrowSnapshot.principal.mul(borrowIndex).div(borrowSnapshot.interestIndex).sub(borrowSnapshot.principal);\n\n            borrowSnapshot.principal = borrowSnapshot.principal.add(interest);\n            borrowSnapshot.interestIndex = borrowIndex;\n        }\n\n        require(controller.getAccountLiquidity(msg.sender) >= controller.prices(address(this)).mul(amount).mul(2), \"Not enough account liquidity\");\n\n        require(token.transfer(msg.sender, amount), \"No enough tokens to borrow\");\n\n        borrowSnapshot.principal = borrowSnapshot.principal.add(amount);\n        borrowSnapshot.interestIndex = borrowIndex;\n\n        totalBorrows = totalBorrows.add(amount);\n\n        emit Borrow(msg.sender, amount);\n    }\n\n    function accrueInterest() public {\n        uint currentBlockNumber = block.number;\n\n        (totalBorrows, borrowIndex) = calculateBorrowDataAtBlock(currentBlockNumber);\n        (totalSupply, supplyIndex) = calculateSupplyDataAtBlock(currentBlockNumber);\n\n        accrualBlockNumber = currentBlockNumber;\n    }\n\n    function calculateBorrowDataAtBlock(uint newBlockNumber) internal view returns (uint newTotalBorrows, uint newBorrowIndex) {\n        if (newBlockNumber <= accrualBlockNumber)\n            return (totalBorrows, borrowIndex);\n\n        if (totalBorrows == 0)\n            return (totalBorrows, borrowIndex);\n\n        uint blockDelta = newBlockNumber - accrualBlockNumber;\n\n        uint simpleInterestFactor = borrowRatePerBlock().mul(blockDelta);\n        uint interestAccumulated = simpleInterestFactor.mul(totalBorrows).div(FACTOR);\n\n        newBorrowIndex = simpleInterestFactor.mul(borrowIndex).div(FACTOR).add(borrowIndex);\n        newTotalBorrows = interestAccumulated.add(totalBorrows);\n    }\n\n    function calculateSupplyDataAtBlock(uint newBlockNumber) internal view returns (uint newTotalSupply, uint newSupplyIndex) {\n        if (newBlockNumber <= accrualBlockNumber)\n            return (totalSupply, supplyIndex);\n\n        if (totalSupply == 0)\n            return (totalSupply, supplyIndex);\n\n        uint blockDelta = newBlockNumber - accrualBlockNumber;\n\n        uint simpleInterestFactor = supplyRatePerBlock().mul(blockDelta);\n        uint interestAccumulated = simpleInterestFactor.mul(totalSupply).div(FACTOR);\n\n        newSupplyIndex = simpleInterestFactor.mul(supplyIndex).div(FACTOR).add(supplyIndex);\n        newTotalSupply = interestAccumulated.add(totalSupply);\n    }\n\n    function getUpdatedTotalBorrows() public view returns (uint) {\n        uint newTotalBorrows;\n        uint newBorrowIndex;\n\n        (newTotalBorrows, newBorrowIndex) = calculateBorrowDataAtBlock(block.number);\n\n        return newTotalBorrows;\n    }\n\n    function getUpdatedTotalSupply() public view returns (uint) {\n        uint newTotalSupply;\n        uint newSupplyIndex;\n\n        (newTotalSupply, newSupplyIndex) = calculateSupplyDataAtBlock(block.number);\n\n        return newTotalSupply;\n    }\n\n    function payBorrow(uint amount) public {\n        uint paid;\n        uint additional;\n\n        (paid, additional) = payBorrowInternal(msg.sender, msg.sender, amount);\n\n        emit PayBorrow(msg.sender, paid);\n\n        if (additional > 0)\n            emit Supply(msg.sender, additional);\n    }\n\n    function payBorrowInternal(address payer, address borrower, uint amount) internal returns (uint paid, uint supplied) {\n        accrueInterest();\n\n        BorrowSnapshot storage snapshot = borrows[borrower];\n\n        require(snapshot.principal > 0);\n\n        uint interest = snapshot.principal.mul(borrowIndex).div(snapshot.interestIndex).sub(snapshot.principal);\n\n        snapshot.principal = snapshot.principal.add(interest);\n        snapshot.interestIndex = borrowIndex;\n\n        uint additional;\n\n        if (snapshot.principal < amount) {\n            additional = amount.sub(snapshot.principal);\n            amount = snapshot.principal;\n        }\n\n        require(token.transferFrom(payer, address(this), amount), \"No enough tokens\");\n\n        snapshot.principal = snapshot.principal.sub(amount);\n        totalBorrows = totalBorrows.sub(amount);\n\n        if (additional > 0)\n            supplyInternal(payer, additional);\n\n        return (amount, additional);\n    }\n\n    function liquidateBorrow(address borrower, uint amount, MarketInterface collateralMarket) public {\n        require(amount > 0);\n        require(borrower != msg.sender);\n\n        accrueInterest();\n        collateralMarket.accrueInterest();\n\n        uint debt = updatedBorrowBy(borrower);\n\n        require(debt >= amount);\n        require(token.balanceOf(msg.sender) >= amount);\n\n        uint collateralAmount = controller.liquidateCollateral(borrower, msg.sender, amount, collateralMarket);\n\n        uint paid;\n        uint additional;\n\n        (paid, additional) = payBorrowInternal(msg.sender, borrower, amount);\n\n        emit LiquidateBorrow(borrower, paid, msg.sender, address(collateralMarket), collateralAmount);\n\n        if (additional > 0)\n            emit Supply(msg.sender, additional);\n    }\n\n    function transferTo(address sender, address receiver, uint amount) public onlyController {\n        require(amount > 0);\n        redeemInternal(sender, receiver, amount);\n    }\n}\n\n";
  var sourcePath = "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Market.sol";
  var ast = {
  	absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Market.sol",
  	exportedSymbols: {
  		Market: [
  			1776
  		]
  	},
  	id: 1777,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 481,
  			literals: [
  				"solidity",
  				">=",
  				"0.5",
  				".0",
  				"<",
  				"0.6",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:31:1"
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/ERC20.sol",
  			file: "./test/ERC20.sol",
  			id: 482,
  			nodeType: "ImportDirective",
  			scope: 1777,
  			sourceUnit: 1971,
  			src: "33:26:1",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol",
  			file: "./Controller.sol",
  			id: 483,
  			nodeType: "ImportDirective",
  			scope: 1777,
  			sourceUnit: 480,
  			src: "60:26:1",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/SafeMath.sol",
  			file: "./test/SafeMath.sol",
  			id: 484,
  			nodeType: "ImportDirective",
  			scope: 1777,
  			sourceUnit: 2170,
  			src: "87:29:1",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 485,
  						name: "MarketInterface",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1824,
  						src: "137:15:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_MarketInterface_$1824",
  							typeString: "contract MarketInterface"
  						}
  					},
  					id: 486,
  					nodeType: "InheritanceSpecifier",
  					src: "137:15:1"
  				}
  			],
  			contractDependencies: [
  				1824
  			],
  			contractKind: "contract",
  			documentation: null,
  			fullyImplemented: true,
  			id: 1776,
  			linearizedBaseContracts: [
  				1776,
  				1824
  			],
  			name: "Market",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 489,
  					libraryName: {
  						contractScope: null,
  						id: 487,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2169,
  						src: "165:8:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$2169",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "159:27:1",
  					typeName: {
  						id: 488,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "178:7:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					constant: false,
  					id: 491,
  					name: "owner",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "192:20:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_address",
  						typeString: "address"
  					},
  					typeName: {
  						id: 490,
  						name: "address",
  						nodeType: "ElementaryTypeName",
  						src: "192:7:1",
  						stateMutability: "nonpayable",
  						typeDescriptions: {
  							typeIdentifier: "t_address",
  							typeString: "address"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 493,
  					name: "token",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "219:18:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_contract$_ERC20_$1970",
  						typeString: "contract ERC20"
  					},
  					typeName: {
  						contractScope: null,
  						id: 492,
  						name: "ERC20",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1970,
  						src: "219:5:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_ERC20_$1970",
  							typeString: "contract ERC20"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 495,
  					name: "controller",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "243:28:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_contract$_Controller_$479",
  						typeString: "contract Controller"
  					},
  					typeName: {
  						contractScope: null,
  						id: 494,
  						name: "Controller",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 479,
  						src: "243:10:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_Controller_$479",
  							typeString: "contract Controller"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 497,
  					name: "totalSupply",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "278:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 496,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "278:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 499,
  					name: "supplyIndex",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "308:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 498,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "308:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 501,
  					name: "accrualBlockNumber",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "338:30:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 500,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "338:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 503,
  					name: "borrowIndex",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "375:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 502,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "375:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 505,
  					name: "totalBorrows",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "404:24:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 504,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "404:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 507,
  					name: "baseBorrowRate",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "434:26:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 506,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "434:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 509,
  					name: "utilizationRateFraction",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "466:35:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 508,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "466:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 511,
  					name: "deployBlock",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "507:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 510,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "507:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 513,
  					name: "blocksPerYear",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "537:25:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 512,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "537:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					canonicalName: "Market.SupplySnapshot",
  					id: 518,
  					members: [
  						{
  							constant: false,
  							id: 515,
  							name: "supply",
  							nodeType: "VariableDeclaration",
  							scope: 518,
  							src: "601:11:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 514,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "601:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						},
  						{
  							constant: false,
  							id: 517,
  							name: "interestIndex",
  							nodeType: "VariableDeclaration",
  							scope: 518,
  							src: "622:18:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 516,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "622:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						}
  					],
  					name: "SupplySnapshot",
  					nodeType: "StructDefinition",
  					scope: 1776,
  					src: "569:78:1",
  					visibility: "public"
  				},
  				{
  					canonicalName: "Market.BorrowSnapshot",
  					id: 523,
  					members: [
  						{
  							constant: false,
  							id: 520,
  							name: "principal",
  							nodeType: "VariableDeclaration",
  							scope: 523,
  							src: "685:14:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 519,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "685:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						},
  						{
  							constant: false,
  							id: 522,
  							name: "interestIndex",
  							nodeType: "VariableDeclaration",
  							scope: 523,
  							src: "709:18:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 521,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "709:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						}
  					],
  					name: "BorrowSnapshot",
  					nodeType: "StructDefinition",
  					scope: 1776,
  					src: "653:81:1",
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 527,
  					name: "supplies",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "740:44:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  						typeString: "mapping(address => struct Market.SupplySnapshot)"
  					},
  					typeName: {
  						id: 526,
  						keyType: {
  							id: 524,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "749:7:1",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "740:35:1",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  							typeString: "mapping(address => struct Market.SupplySnapshot)"
  						},
  						valueType: {
  							contractScope: null,
  							id: 525,
  							name: "SupplySnapshot",
  							nodeType: "UserDefinedTypeName",
  							referencedDeclaration: 518,
  							src: "760:14:1",
  							typeDescriptions: {
  								typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  								typeString: "struct Market.SupplySnapshot"
  							}
  						}
  					},
  					value: null,
  					visibility: "internal"
  				},
  				{
  					constant: false,
  					id: 531,
  					name: "borrows",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "790:43:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  						typeString: "mapping(address => struct Market.BorrowSnapshot)"
  					},
  					typeName: {
  						id: 530,
  						keyType: {
  							id: 528,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "799:7:1",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "790:35:1",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  							typeString: "mapping(address => struct Market.BorrowSnapshot)"
  						},
  						valueType: {
  							contractScope: null,
  							id: 529,
  							name: "BorrowSnapshot",
  							nodeType: "UserDefinedTypeName",
  							referencedDeclaration: 523,
  							src: "810:14:1",
  							typeDescriptions: {
  								typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  								typeString: "struct Market.BorrowSnapshot"
  							}
  						}
  					},
  					value: null,
  					visibility: "internal"
  				},
  				{
  					constant: true,
  					id: 534,
  					name: "FACTOR",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "840:34:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 532,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "840:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "31653138",
  						id: 533,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "870:4:1",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_1000000000000000000_by_1",
  							typeString: "int_const 1000000000000000000"
  						},
  						value: "1e18"
  					},
  					visibility: "public"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 540,
  					name: "Supply",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 539,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 536,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 540,
  								src: "894:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 535,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "894:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 538,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 540,
  								src: "916:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 537,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "916:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "893:35:1"
  					},
  					src: "881:48:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 546,
  					name: "Redeem",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 545,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 542,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 546,
  								src: "947:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 541,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "947:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 544,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 546,
  								src: "969:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 543,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "969:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "946:35:1"
  					},
  					src: "934:48:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 552,
  					name: "Borrow",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 551,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 548,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 552,
  								src: "1000:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 547,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1000:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 550,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 552,
  								src: "1022:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 549,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1022:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "999:35:1"
  					},
  					src: "987:48:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 558,
  					name: "PayBorrow",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 557,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 554,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 558,
  								src: "1056:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 553,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1056:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 556,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 558,
  								src: "1078:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 555,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1078:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1055:35:1"
  					},
  					src: "1040:51:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 570,
  					name: "LiquidateBorrow",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 569,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 560,
  								indexed: true,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1118:24:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 559,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1118:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 562,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1144:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 561,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1144:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 564,
  								indexed: true,
  								name: "liquidator",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1157:26:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 563,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1157:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 566,
  								indexed: false,
  								name: "collateralMarket",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1185:24:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 565,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1185:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 568,
  								indexed: false,
  								name: "collateralAmount",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1211:21:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 567,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1211:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1117:116:1"
  					},
  					src: "1096:138:1"
  				},
  				{
  					body: {
  						id: 636,
  						nodeType: "Block",
  						src: "1353:437:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 588,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  												],
  												expression: {
  													argumentTypes: [
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 583,
  																name: "_token",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 572,
  																src: "1377:6:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_ERC20_$1970",
  																	typeString: "contract ERC20"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_contract$_ERC20_$1970",
  																	typeString: "contract ERC20"
  																}
  															],
  															id: 582,
  															name: "ERC20",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1970,
  															src: "1371:5:1",
  															typeDescriptions: {
  																typeIdentifier: "t_type$_t_contract$_ERC20_$1970_$",
  																typeString: "type(contract ERC20)"
  															}
  														},
  														id: 584,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "typeConversion",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "1371:13:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 585,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "totalSupply",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1977,
  													src: "1371:25:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  														typeString: "function () view external returns (uint256)"
  													}
  												},
  												id: 586,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1371:27:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 587,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "1402:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "1371:32:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 581,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1363:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 589,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1363:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 590,
  								nodeType: "ExpressionStatement",
  								src: "1363:41:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 594,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 591,
  										name: "owner",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 491,
  										src: "1414:5:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 592,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "1422:3:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 593,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1422:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "1414:18:1",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 595,
  								nodeType: "ExpressionStatement",
  								src: "1414:18:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 598,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 596,
  										name: "token",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 493,
  										src: "1442:5:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_ERC20_$1970",
  											typeString: "contract ERC20"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 597,
  										name: "_token",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 572,
  										src: "1450:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_ERC20_$1970",
  											typeString: "contract ERC20"
  										}
  									},
  									src: "1442:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_ERC20_$1970",
  										typeString: "contract ERC20"
  									}
  								},
  								id: 599,
  								nodeType: "ExpressionStatement",
  								src: "1442:14:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 602,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 600,
  										name: "borrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 503,
  										src: "1466:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 601,
  										name: "FACTOR",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 534,
  										src: "1480:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1466:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 603,
  								nodeType: "ExpressionStatement",
  								src: "1466:20:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 606,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 604,
  										name: "supplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 499,
  										src: "1496:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 605,
  										name: "FACTOR",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 534,
  										src: "1510:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1496:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 607,
  								nodeType: "ExpressionStatement",
  								src: "1496:20:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 610,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 608,
  										name: "blocksPerYear",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 513,
  										src: "1526:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 609,
  										name: "_blocksPerYear",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 576,
  										src: "1542:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1526:30:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 611,
  								nodeType: "ExpressionStatement",
  								src: "1526:30:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 617,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 612,
  										name: "baseBorrowRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 507,
  										src: "1566:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 615,
  												name: "_blocksPerYear",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 576,
  												src: "1609:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 613,
  												name: "_baseBorrowAnnualRate",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 574,
  												src: "1583:21:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 614,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "1583:25:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 616,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1583:41:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1566:58:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 618,
  								nodeType: "ExpressionStatement",
  								src: "1566:58:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 622,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 619,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "1634:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 620,
  											name: "block",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2421,
  											src: "1655:5:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_block",
  												typeString: "block"
  											}
  										},
  										id: 621,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "number",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1655:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1634:33:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 623,
  								nodeType: "ExpressionStatement",
  								src: "1634:33:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 629,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 624,
  										name: "utilizationRateFraction",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 509,
  										src: "1677:23:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 627,
  												name: "_blocksPerYear",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 576,
  												src: "1732:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 625,
  												name: "_utilizationRateFraction",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 578,
  												src: "1703:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 626,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "1703:28:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 628,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1703:44:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1677:70:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 630,
  								nodeType: "ExpressionStatement",
  								src: "1677:70:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 634,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 631,
  										name: "deployBlock",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 511,
  										src: "1757:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 632,
  											name: "block",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2421,
  											src: "1771:5:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_block",
  												typeString: "block"
  											}
  										},
  										id: 633,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "number",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1771:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1757:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 635,
  								nodeType: "ExpressionStatement",
  								src: "1757:26:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 637,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 579,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 572,
  								name: "_token",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1252:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_ERC20_$1970",
  									typeString: "contract ERC20"
  								},
  								typeName: {
  									contractScope: null,
  									id: 571,
  									name: "ERC20",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1970,
  									src: "1252:5:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_ERC20_$1970",
  										typeString: "contract ERC20"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 574,
  								name: "_baseBorrowAnnualRate",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1266:26:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 573,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1266:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 576,
  								name: "_blocksPerYear",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1294:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 575,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1294:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 578,
  								name: "_utilizationRateFraction",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1315:29:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 577,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1315:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1251:94:1"
  					},
  					returnParameters: {
  						id: 580,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1353:0:1"
  					},
  					scope: 1776,
  					src: "1240:550:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 647,
  						nodeType: "Block",
  						src: "1817:56:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 643,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 640,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "1835:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 641,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "1835:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												id: 642,
  												name: "owner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 491,
  												src: "1849:5:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "1835:19:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 639,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1827:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 644,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1827:28:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 645,
  								nodeType: "ExpressionStatement",
  								src: "1827:28:1"
  							},
  							{
  								id: 646,
  								nodeType: "PlaceholderStatement",
  								src: "1865:1:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 648,
  					name: "onlyOwner",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 638,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1814:2:1"
  					},
  					src: "1796:77:1",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 660,
  						nodeType: "Block",
  						src: "1905:70:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 656,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 651,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "1923:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 652,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "1923:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 654,
  														name: "controller",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 495,
  														src: "1945:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_Controller_$479",
  															typeString: "contract Controller"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_contract$_Controller_$479",
  															typeString: "contract Controller"
  														}
  													],
  													id: 653,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "1937:7:1",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: "address"
  												},
  												id: 655,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1937:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "1923:33:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 650,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1915:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 657,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1915:42:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 658,
  								nodeType: "ExpressionStatement",
  								src: "1915:42:1"
  							},
  							{
  								id: 659,
  								nodeType: "PlaceholderStatement",
  								src: "1967:1:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 661,
  					name: "onlyController",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 649,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1902:2:1"
  					},
  					src: "1879:96:1",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 673,
  						nodeType: "Block",
  						src: "2027:54:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 669,
  													name: "this",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2455,
  													src: "2068:4:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_Market_$1776",
  														typeString: "contract Market"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_Market_$1776",
  														typeString: "contract Market"
  													}
  												],
  												id: 668,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "2060:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 670,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2060:13:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 666,
  											name: "token",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 493,
  											src: "2044:5:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_ERC20_$1970",
  												typeString: "contract ERC20"
  											}
  										},
  										id: 667,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "balanceOf",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1984,
  										src: "2044:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) view external returns (uint256)"
  										}
  									},
  									id: 671,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2044:30:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 665,
  								id: 672,
  								nodeType: "Return",
  								src: "2037:37:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 674,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getCash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 662,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1997:2:1"
  					},
  					returnParameters: {
  						id: 665,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 664,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 674,
  								src: "2021:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 663,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2021:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2020:6:1"
  					},
  					scope: 1776,
  					src: "1981:100:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 705,
  						nodeType: "Block",
  						src: "2180:132:1",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 687,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 685,
  										name: "borrowed",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 678,
  										src: "2194:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 686,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2206:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "2194:13:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 690,
  								nodeType: "IfStatement",
  								src: "2190:39:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 688,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2228:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 684,
  									id: 689,
  									nodeType: "Return",
  									src: "2221:8:1"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 701,
  													name: "reserves",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 680,
  													src: "2295:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 698,
  															name: "borrowed",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 678,
  															src: "2281:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 696,
  															name: "cash",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 676,
  															src: "2272:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 697,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "2272:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 699,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2272:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 700,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sub",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2144,
  												src: "2272:22:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 702,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2272:32:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 693,
  													name: "FACTOR",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 534,
  													src: "2260:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 691,
  													name: "borrowed",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 678,
  													src: "2247:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 692,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "2247:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 694,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2247:20:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 695,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "2247:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 703,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2247:58:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 684,
  								id: 704,
  								nodeType: "Return",
  								src: "2240:65:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 706,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "utilizationRate",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 681,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 676,
  								name: "cash",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2112:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 675,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2112:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 678,
  								name: "borrowed",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2123:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 677,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2123:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 680,
  								name: "reserves",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2138:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 679,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2138:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2111:41:1"
  					},
  					returnParameters: {
  						id: 684,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 683,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2174:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 682,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2174:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2173:6:1"
  					},
  					scope: 1776,
  					src: "2087:225:1",
  					stateMutability: "pure",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 736,
  						nodeType: "Block",
  						src: "2409:149:1",
  						statements: [
  							{
  								assignments: [
  									718
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 718,
  										name: "ur",
  										nodeType: "VariableDeclaration",
  										scope: 736,
  										src: "2419:7:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 717,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2419:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 724,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 720,
  											name: "cash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 708,
  											src: "2445:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 721,
  											name: "borrowed",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 710,
  											src: "2451:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 722,
  											name: "reserves",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 712,
  											src: "2461:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 719,
  										name: "utilizationRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 706,
  										src: "2429:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 723,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2429:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "2419:51:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 733,
  											name: "baseBorrowRate",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 507,
  											src: "2536:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 730,
  													name: "FACTOR",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 534,
  													src: "2524:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 727,
  															name: "utilizationRateFraction",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 509,
  															src: "2495:23:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 725,
  															name: "ur",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 718,
  															src: "2488:2:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 726,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2110,
  														src: "2488:6:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 728,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2488:31:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 729,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "div",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2124,
  												src: "2488:35:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 731,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2488:43:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 732,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "add",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2168,
  										src: "2488:47:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 734,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2488:63:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 716,
  								id: 735,
  								nodeType: "Return",
  								src: "2481:70:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 737,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getBorrowRate",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 713,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 708,
  								name: "cash",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2341:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 707,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2341:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 710,
  								name: "borrowed",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2352:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 709,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2352:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 712,
  								name: "reserves",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2367:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 711,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2367:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2340:41:1"
  					},
  					returnParameters: {
  						id: 716,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 715,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2403:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 714,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2403:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2402:6:1"
  					},
  					scope: 1776,
  					src: "2318:240:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 768,
  						nodeType: "Block",
  						src: "2655:161:1",
  						statements: [
  							{
  								assignments: [
  									749
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 749,
  										name: "borrowRate",
  										nodeType: "VariableDeclaration",
  										scope: 768,
  										src: "2665:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 748,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2665:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 755,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 751,
  											name: "cash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 739,
  											src: "2697:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 752,
  											name: "borrowed",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 741,
  											src: "2703:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 753,
  											name: "reserves",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 743,
  											src: "2713:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 750,
  										name: "getBorrowRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 737,
  										src: "2683:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 754,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2683:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "2665:57:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 765,
  											name: "FACTOR",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 534,
  											src: "2802:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 762,
  													name: "borrowRate",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 749,
  													src: "2786:10:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 757,
  															name: "cash",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 739,
  															src: "2756:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 758,
  															name: "borrowed",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 741,
  															src: "2762:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 759,
  															name: "reserves",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 743,
  															src: "2772:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														id: 756,
  														name: "utilizationRate",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 706,
  														src: "2740:15:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  															typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 760,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2740:41:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 761,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "2740:45:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 763,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2740:57:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 764,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "2740:61:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 766,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2740:69:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 747,
  								id: 767,
  								nodeType: "Return",
  								src: "2733:76:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 769,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getSupplyRate",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 744,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 739,
  								name: "cash",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2587:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 738,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2587:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 741,
  								name: "borrowed",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2598:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 740,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2598:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 743,
  								name: "reserves",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2613:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 742,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2613:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2586:41:1"
  					},
  					returnParameters: {
  						id: 747,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 746,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2649:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 745,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2649:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2648:6:1"
  					},
  					scope: 1776,
  					src: "2564:252:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 781,
  						nodeType: "Block",
  						src: "2879:65:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 775,
  												name: "getCash",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 674,
  												src: "2910:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 776,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2910:9:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 777,
  											name: "totalBorrows",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 505,
  											src: "2921:12:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "30",
  											id: 778,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "2935:1:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											}
  										],
  										id: 774,
  										name: "getBorrowRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 737,
  										src: "2896:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 779,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2896:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 773,
  								id: 780,
  								nodeType: "Return",
  								src: "2889:48:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 782,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "borrowRatePerBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 770,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2849:2:1"
  					},
  					returnParameters: {
  						id: 773,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 772,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 782,
  								src: "2873:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 771,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2873:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2872:6:1"
  					},
  					scope: 1776,
  					src: "2822:122:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 794,
  						nodeType: "Block",
  						src: "3007:65:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 788,
  												name: "getCash",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 674,
  												src: "3038:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 789,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3038:9:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 790,
  											name: "totalBorrows",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 505,
  											src: "3049:12:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "30",
  											id: 791,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "3063:1:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											}
  										],
  										id: 787,
  										name: "getSupplyRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 769,
  										src: "3024:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 792,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3024:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 786,
  								id: 793,
  								nodeType: "Return",
  								src: "3017:48:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 795,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supplyRatePerBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 783,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2977:2:1"
  					},
  					returnParameters: {
  						id: 786,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 785,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 795,
  								src: "3001:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 784,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3001:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3000:6:1"
  					},
  					scope: 1776,
  					src: "2950:122:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 807,
  						nodeType: "Block",
  						src: "3137:45:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 802,
  											name: "supplies",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 527,
  											src: "3154:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  												typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  											}
  										},
  										id: 804,
  										indexExpression: {
  											argumentTypes: null,
  											id: 803,
  											name: "user",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 797,
  											src: "3163:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "IndexAccess",
  										src: "3154:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  											typeString: "struct Market.SupplySnapshot storage ref"
  										}
  									},
  									id: 805,
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "supply",
  									nodeType: "MemberAccess",
  									referencedDeclaration: 515,
  									src: "3154:21:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 801,
  								id: 806,
  								nodeType: "Return",
  								src: "3147:28:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 808,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supplyOf",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 798,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 797,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 808,
  								src: "3096:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 796,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3096:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3095:14:1"
  					},
  					returnParameters: {
  						id: 801,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 800,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 808,
  								src: "3131:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 799,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3131:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3130:6:1"
  					},
  					scope: 1776,
  					src: "3078:104:1",
  					stateMutability: "view",
  					superFunction: 1790,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 820,
  						nodeType: "Block",
  						src: "3247:47:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 815,
  											name: "borrows",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 531,
  											src: "3264:7:1",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  												typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  											}
  										},
  										id: 817,
  										indexExpression: {
  											argumentTypes: null,
  											id: 816,
  											name: "user",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 810,
  											src: "3272:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "IndexAccess",
  										src: "3264:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  											typeString: "struct Market.BorrowSnapshot storage ref"
  										}
  									},
  									id: 818,
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "principal",
  									nodeType: "MemberAccess",
  									referencedDeclaration: 520,
  									src: "3264:23:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 814,
  								id: 819,
  								nodeType: "Return",
  								src: "3257:30:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 821,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "borrowBy",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 811,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 810,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 821,
  								src: "3206:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 809,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3206:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3205:14:1"
  					},
  					returnParameters: {
  						id: 814,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 813,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 821,
  								src: "3241:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 812,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3241:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3240:6:1"
  					},
  					scope: 1776,
  					src: "3188:106:1",
  					stateMutability: "view",
  					superFunction: 1797,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 866,
  						nodeType: "Block",
  						src: "3366:355:1",
  						statements: [
  							{
  								assignments: [
  									829
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 829,
  										name: "snapshot",
  										nodeType: "VariableDeclaration",
  										scope: 866,
  										src: "3376:31:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  											typeString: "struct Market.BorrowSnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 828,
  											name: "BorrowSnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 523,
  											src: "3376:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 833,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 830,
  										name: "borrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 531,
  										src: "3410:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  											typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  										}
  									},
  									id: 832,
  									indexExpression: {
  										argumentTypes: null,
  										id: 831,
  										name: "user",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 823,
  										src: "3418:4:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3410:13:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  										typeString: "struct Market.BorrowSnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3376:47:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 837,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 834,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 829,
  											src: "3438:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 835,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "3438:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 836,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3460:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "3438:23:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 840,
  								nodeType: "IfStatement",
  								src: "3434:49:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 838,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3482:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 827,
  									id: 839,
  									nodeType: "Return",
  									src: "3475:8:1"
  								}
  							},
  							{
  								assignments: [
  									842
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 842,
  										name: "newTotalBorrows",
  										nodeType: "VariableDeclaration",
  										scope: 866,
  										src: "3494:20:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 841,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3494:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 843,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3494:20:1"
  							},
  							{
  								assignments: [
  									845
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 845,
  										name: "newBorrowIndex",
  										nodeType: "VariableDeclaration",
  										scope: 866,
  										src: "3524:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 844,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3524:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 846,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3524:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 854,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 847,
  												name: "newTotalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 842,
  												src: "3555:15:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 848,
  												name: "newBorrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 845,
  												src: "3572:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 849,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "3554:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 851,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "3617:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 852,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "3617:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 850,
  											name: "calculateBorrowDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1367,
  											src: "3590:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 853,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3590:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "3554:76:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 855,
  								nodeType: "ExpressionStatement",
  								src: "3554:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 862,
  												name: "snapshot",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 829,
  												src: "3691:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  													typeString: "struct Market.BorrowSnapshot storage pointer"
  												}
  											},
  											id: 863,
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "interestIndex",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 522,
  											src: "3691:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 859,
  													name: "newBorrowIndex",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 845,
  													src: "3671:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 856,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 829,
  														src: "3648:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 857,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "principal",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 520,
  													src: "3648:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 858,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "3648:22:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 860,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3648:38:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 861,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "3648:42:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 864,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3648:66:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 827,
  								id: 865,
  								nodeType: "Return",
  								src: "3641:73:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 867,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "updatedBorrowBy",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 824,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 823,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 867,
  								src: "3325:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 822,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3325:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3324:14:1"
  					},
  					returnParameters: {
  						id: 827,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 826,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 867,
  								src: "3360:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 825,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3360:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3359:6:1"
  					},
  					scope: 1776,
  					src: "3300:421:1",
  					stateMutability: "view",
  					superFunction: 1811,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 912,
  						nodeType: "Block",
  						src: "3793:348:1",
  						statements: [
  							{
  								assignments: [
  									875
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 875,
  										name: "snapshot",
  										nodeType: "VariableDeclaration",
  										scope: 912,
  										src: "3803:31:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  											typeString: "struct Market.SupplySnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 874,
  											name: "SupplySnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 518,
  											src: "3803:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 879,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 876,
  										name: "supplies",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 527,
  										src: "3837:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  											typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  										}
  									},
  									id: 878,
  									indexExpression: {
  										argumentTypes: null,
  										id: 877,
  										name: "user",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 869,
  										src: "3846:4:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3837:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  										typeString: "struct Market.SupplySnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3803:48:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 883,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 880,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 875,
  											src: "3866:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 881,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "3866:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 882,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3885:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "3866:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 886,
  								nodeType: "IfStatement",
  								src: "3862:46:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 884,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3907:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 873,
  									id: 885,
  									nodeType: "Return",
  									src: "3900:8:1"
  								}
  							},
  							{
  								assignments: [
  									888
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 888,
  										name: "newTotalSupply",
  										nodeType: "VariableDeclaration",
  										scope: 912,
  										src: "3919:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 887,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3919:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 889,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3919:19:1"
  							},
  							{
  								assignments: [
  									891
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 891,
  										name: "newSupplyIndex",
  										nodeType: "VariableDeclaration",
  										scope: 912,
  										src: "3948:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 890,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3948:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 892,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3948:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 900,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 893,
  												name: "newTotalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 888,
  												src: "3979:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 894,
  												name: "newSupplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 891,
  												src: "3995:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 895,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "3978:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 897,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "4040:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 898,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "4040:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 896,
  											name: "calculateSupplyDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1437,
  											src: "4013:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 899,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4013:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "3978:75:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 901,
  								nodeType: "ExpressionStatement",
  								src: "3978:75:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 908,
  												name: "snapshot",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 875,
  												src: "4111:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  													typeString: "struct Market.SupplySnapshot storage pointer"
  												}
  											},
  											id: 909,
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "interestIndex",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 517,
  											src: "4111:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 905,
  													name: "newSupplyIndex",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 891,
  													src: "4091:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 902,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 875,
  														src: "4071:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  															typeString: "struct Market.SupplySnapshot storage pointer"
  														}
  													},
  													id: 903,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "supply",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 515,
  													src: "4071:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 904,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "4071:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 906,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "4071:35:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 907,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "4071:39:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 910,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4071:63:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 873,
  								id: 911,
  								nodeType: "Return",
  								src: "4064:70:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 913,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "updatedSupplyOf",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 870,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 869,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 913,
  								src: "3752:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 868,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3752:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3751:14:1"
  					},
  					returnParameters: {
  						id: 873,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 872,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 913,
  								src: "3787:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 871,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3787:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3786:6:1"
  					},
  					scope: 1776,
  					src: "3727:414:1",
  					stateMutability: "view",
  					superFunction: 1804,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 924,
  						nodeType: "Block",
  						src: "4211:41:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 922,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 920,
  										name: "controller",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 495,
  										src: "4221:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_Controller_$479",
  											typeString: "contract Controller"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 921,
  										name: "_controller",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 915,
  										src: "4234:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_Controller_$479",
  											typeString: "contract Controller"
  										}
  									},
  									src: "4221:24:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_Controller_$479",
  										typeString: "contract Controller"
  									}
  								},
  								id: 923,
  								nodeType: "ExpressionStatement",
  								src: "4221:24:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 925,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 918,
  							modifierName: {
  								argumentTypes: null,
  								id: 917,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 648,
  								src: "4201:9:1",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "4201:9:1"
  						}
  					],
  					name: "setController",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 916,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 915,
  								name: "_controller",
  								nodeType: "VariableDeclaration",
  								scope: 925,
  								src: "4170:22:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_Controller_$479",
  									typeString: "contract Controller"
  								},
  								typeName: {
  									contractScope: null,
  									id: 914,
  									name: "Controller",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 479,
  									src: "4170:10:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_Controller_$479",
  										typeString: "contract Controller"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4169:24:1"
  					},
  					returnParameters: {
  						id: 919,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4211:0:1"
  					},
  					scope: 1776,
  					src: "4147:105:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 942,
  						nodeType: "Block",
  						src: "4294:93:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 931,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "4319:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 932,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "4319:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 933,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 927,
  											src: "4331:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 930,
  										name: "supplyInternal",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1007,
  										src: "4304:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 934,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4304:34:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 935,
  								nodeType: "ExpressionStatement",
  								src: "4304:34:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 937,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "4361:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 938,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "4361:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 939,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 927,
  											src: "4373:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 936,
  										name: "Supply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 540,
  										src: "4354:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 940,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4354:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 941,
  								nodeType: "EmitStatement",
  								src: "4349:31:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 943,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supply",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 928,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 927,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 943,
  								src: "4274:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 926,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "4274:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4273:13:1"
  					},
  					returnParameters: {
  						id: 929,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4294:0:1"
  					},
  					scope: 1776,
  					src: "4258:129:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1006,
  						nodeType: "Block",
  						src: "4457:473:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 953,
  													name: "supplier",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 945,
  													src: "4535:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 955,
  															name: "this",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2455,
  															src: "4553:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														],
  														id: 954,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "4545:7:1",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_address_$",
  															typeString: "type(address)"
  														},
  														typeName: "address"
  													},
  													id: 956,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "4545:13:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 957,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 947,
  													src: "4560:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 951,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "4516:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 952,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transferFrom",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1952,
  												src: "4516:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,address,uint256) external returns (bool)"
  												}
  											},
  											id: 958,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "4516:51:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e73",
  											id: 959,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "4569:18:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											},
  											value: "No enough tokens"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											}
  										],
  										id: 950,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "4508:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 960,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4508:80:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 961,
  								nodeType: "ExpressionStatement",
  								src: "4508:80:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 962,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "4599:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 963,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4599:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 964,
  								nodeType: "ExpressionStatement",
  								src: "4599:16:1"
  							},
  							{
  								assignments: [
  									966
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 966,
  										name: "supplySnapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1006,
  										src: "4626:37:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  											typeString: "struct Market.SupplySnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 965,
  											name: "SupplySnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 518,
  											src: "4626:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 970,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 967,
  										name: "supplies",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 527,
  										src: "4666:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  											typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  										}
  									},
  									id: 969,
  									indexExpression: {
  										argumentTypes: null,
  										id: 968,
  										name: "supplier",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 945,
  										src: "4675:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "4666:18:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  										typeString: "struct Market.SupplySnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "4626:58:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 977,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 971,
  											name: "supplySnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 966,
  											src: "4695:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 973,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "4695:21:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 975,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 945,
  												src: "4735:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 974,
  											name: "updatedSupplyOf",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 913,
  											src: "4719:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$",
  												typeString: "function (address) view returns (uint256)"
  											}
  										},
  										id: 976,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4719:25:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4695:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 978,
  								nodeType: "ExpressionStatement",
  								src: "4695:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 990,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 979,
  												name: "supplies",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 527,
  												src: "4754:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  													typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  												}
  											},
  											id: 981,
  											indexExpression: {
  												argumentTypes: null,
  												id: 980,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 945,
  												src: "4763:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "4754:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  												typeString: "struct Market.SupplySnapshot storage ref"
  											}
  										},
  										id: 982,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "4754:25:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 988,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 947,
  												src: "4812:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													baseExpression: {
  														argumentTypes: null,
  														id: 983,
  														name: "supplies",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 527,
  														src: "4782:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  															typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  														}
  													},
  													id: 985,
  													indexExpression: {
  														argumentTypes: null,
  														id: 984,
  														name: "supplier",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 945,
  														src: "4791:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "4782:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  														typeString: "struct Market.SupplySnapshot storage ref"
  													}
  												},
  												id: 986,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "supply",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 515,
  												src: "4782:25:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 987,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "4782:29:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 989,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4782:37:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4754:65:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 991,
  								nodeType: "ExpressionStatement",
  								src: "4754:65:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 997,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 992,
  												name: "supplies",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 527,
  												src: "4829:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  													typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  												}
  											},
  											id: 994,
  											indexExpression: {
  												argumentTypes: null,
  												id: 993,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 945,
  												src: "4838:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "4829:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  												typeString: "struct Market.SupplySnapshot storage ref"
  											}
  										},
  										id: 995,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 517,
  										src: "4829:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 996,
  										name: "supplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 499,
  										src: "4864:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4829:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 998,
  								nodeType: "ExpressionStatement",
  								src: "4829:46:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1004,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 999,
  										name: "totalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 497,
  										src: "4886:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1002,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 947,
  												src: "4916:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1000,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "4900:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1001,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "4900:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1003,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4900:23:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4886:37:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1005,
  								nodeType: "ExpressionStatement",
  								src: "4886:37:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1007,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supplyInternal",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 948,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 945,
  								name: "supplier",
  								nodeType: "VariableDeclaration",
  								scope: 1007,
  								src: "4417:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 944,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "4417:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 947,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1007,
  								src: "4435:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 946,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "4435:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4416:31:1"
  					},
  					returnParameters: {
  						id: 949,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4457:0:1"
  					},
  					scope: 1776,
  					src: "4393:537:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1063,
  						nodeType: "Block",
  						src: "4972:420:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1013,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "4997:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1014,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "4997:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1015,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "5009:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1016,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "5009:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1017,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1009,
  											src: "5021:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1012,
  										name: "redeemInternal",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1142,
  										src: "4982:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 1018,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4982:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1019,
  								nodeType: "ExpressionStatement",
  								src: "4982:46:1"
  							},
  							{
  								assignments: [
  									1021
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1021,
  										name: "supplierSupplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 1063,
  										src: "5039:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1020,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "5039:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1022,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "5039:24:1"
  							},
  							{
  								assignments: [
  									1024
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1024,
  										name: "supplierBorrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 1063,
  										src: "5073:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1023,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "5073:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1025,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "5073:24:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1034,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1026,
  												name: "supplierSupplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1021,
  												src: "5109:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1027,
  												name: "supplierBorrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1024,
  												src: "5130:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1028,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "5108:42:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1031,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "5181:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1032,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "5181:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1029,
  												name: "controller",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 495,
  												src: "5153:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_Controller_$479",
  													typeString: "contract Controller"
  												}
  											},
  											id: 1030,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "getAccountValues",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 360,
  											src: "5153:27:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view external returns (uint256,uint256)"
  											}
  										},
  										id: 1033,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5153:39:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "5108:84:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1035,
  								nodeType: "ExpressionStatement",
  								src: "5108:84:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1054,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1037,
  												name: "supplierSupplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1021,
  												src: "5211:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  														],
  														expression: {
  															argumentTypes: [
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1050,
  																name: "controller",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 495,
  																src: "5320:10:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_Controller_$479",
  																	typeString: "contract Controller"
  																}
  															},
  															id: 1051,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "MANTISSA",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 30,
  															src: "5320:19:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  																typeString: "function () view external returns (uint256)"
  															}
  														},
  														id: 1052,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "5320:21:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		"arguments": [
  																		],
  																		expression: {
  																			argumentTypes: [
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				id: 1044,
  																				name: "controller",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 495,
  																				src: "5284:10:1",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_Controller_$479",
  																					typeString: "contract Controller"
  																				}
  																			},
  																			id: 1045,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "collateralFactor",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 25,
  																			src: "5284:27:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  																				typeString: "function () view external returns (uint256)"
  																			}
  																		},
  																		id: 1046,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "5284:29:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: null,
  																		"arguments": [
  																		],
  																		expression: {
  																			argumentTypes: [
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				id: 1040,
  																				name: "controller",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 495,
  																				src: "5258:10:1",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_Controller_$479",
  																					typeString: "contract Controller"
  																				}
  																			},
  																			id: 1041,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "MANTISSA",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 30,
  																			src: "5258:19:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  																				typeString: "function () view external returns (uint256)"
  																			}
  																		},
  																		id: 1042,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "5258:21:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1043,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "add",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 2168,
  																	src: "5258:25:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1047,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "5258:56:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1038,
  																name: "supplierBorrowValue",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1024,
  																src: "5234:19:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1039,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "5234:23:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1048,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "5234:81:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1049,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "div",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2124,
  													src: "5234:85:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1053,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "5234:108:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "5211:131:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1036,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "5203:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1055,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5203:140:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1056,
  								nodeType: "ExpressionStatement",
  								src: "5203:140:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1058,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "5366:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1059,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "5366:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1060,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1009,
  											src: "5378:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1057,
  										name: "Redeem",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 546,
  										src: "5359:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1061,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5359:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1062,
  								nodeType: "EmitStatement",
  								src: "5354:31:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1064,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "redeem",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1010,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1009,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1064,
  								src: "4952:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1008,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "4952:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4951:13:1"
  					},
  					returnParameters: {
  						id: 1011,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4972:0:1"
  					},
  					scope: 1776,
  					src: "4936:456:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1141,
  						nodeType: "Block",
  						src: "5480:517:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1081,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1077,
  																name: "this",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2455,
  																src: "5522:4:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															],
  															id: 1076,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															lValueRequested: false,
  															nodeType: "ElementaryTypeNameExpression",
  															src: "5514:7:1",
  															typeDescriptions: {
  																typeIdentifier: "t_type$_t_address_$",
  																typeString: "type(address)"
  															},
  															typeName: "address"
  														},
  														id: 1078,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "typeConversion",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "5514:13:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1074,
  														name: "token",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 493,
  														src: "5498:5:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 1075,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "balanceOf",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1984,
  													src: "5498:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1079,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "5498:30:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1080,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5532:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "5498:40:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1073,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "5490:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1082,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5490:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1083,
  								nodeType: "ExpressionStatement",
  								src: "5490:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1084,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "5550:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1085,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5550:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1086,
  								nodeType: "ExpressionStatement",
  								src: "5550:16:1"
  							},
  							{
  								assignments: [
  									1088
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1088,
  										name: "supplySnapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1141,
  										src: "5577:37:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  											typeString: "struct Market.SupplySnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 1087,
  											name: "SupplySnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 518,
  											src: "5577:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1092,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 1089,
  										name: "supplies",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 527,
  										src: "5617:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  											typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  										}
  									},
  									id: 1091,
  									indexExpression: {
  										argumentTypes: null,
  										id: 1090,
  										name: "supplier",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1066,
  										src: "5626:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "5617:18:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  										typeString: "struct Market.SupplySnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5577:58:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1099,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1093,
  											name: "supplySnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1088,
  											src: "5646:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 1095,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "5646:21:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1097,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1066,
  												src: "5686:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 1096,
  											name: "updatedSupplyOf",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 913,
  											src: "5670:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$",
  												typeString: "function (address) view returns (uint256)"
  											}
  										},
  										id: 1098,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5670:25:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5646:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1100,
  								nodeType: "ExpressionStatement",
  								src: "5646:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1106,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 1101,
  												name: "supplies",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 527,
  												src: "5705:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  													typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  												}
  											},
  											id: 1103,
  											indexExpression: {
  												argumentTypes: null,
  												id: 1102,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1066,
  												src: "5714:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "5705:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  												typeString: "struct Market.SupplySnapshot storage ref"
  											}
  										},
  										id: 1104,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 517,
  										src: "5705:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1105,
  										name: "supplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 499,
  										src: "5740:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5705:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1107,
  								nodeType: "ExpressionStatement",
  								src: "5705:46:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1112,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1109,
  													name: "supplySnapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1088,
  													src: "5770:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  														typeString: "struct Market.SupplySnapshot storage pointer"
  													}
  												},
  												id: 1110,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "supply",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 515,
  												src: "5770:21:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1111,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5795:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "5770:31:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1108,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "5762:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1113,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5762:40:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1114,
  								nodeType: "ExpressionStatement",
  								src: "5762:40:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1118,
  													name: "receiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1068,
  													src: "5836:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 1119,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1070,
  													src: "5846:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1116,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "5821:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 1117,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transfer",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1993,
  												src: "5821:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,uint256) external returns (bool)"
  												}
  											},
  											id: 1120,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "5821:32:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e73",
  											id: 1121,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "5855:18:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											},
  											value: "No enough tokens"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											}
  										],
  										id: 1115,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "5813:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1122,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5813:61:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1123,
  								nodeType: "ExpressionStatement",
  								src: "5813:61:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1132,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1124,
  											name: "supplySnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1088,
  											src: "5885:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 1126,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "5885:21:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1130,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5935:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1127,
  													name: "supplySnapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1088,
  													src: "5909:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  														typeString: "struct Market.SupplySnapshot storage pointer"
  													}
  												},
  												id: 1128,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "supply",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 515,
  												src: "5909:21:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1129,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "5909:25:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1131,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5909:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5885:57:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1133,
  								nodeType: "ExpressionStatement",
  								src: "5885:57:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1139,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1134,
  										name: "totalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 497,
  										src: "5953:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1137,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5983:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1135,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "5967:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1136,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "5967:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1138,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5967:23:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5953:37:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1140,
  								nodeType: "ExpressionStatement",
  								src: "5953:37:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1142,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "redeemInternal",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1071,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1066,
  								name: "supplier",
  								nodeType: "VariableDeclaration",
  								scope: 1142,
  								src: "5422:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1065,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5422:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1068,
  								name: "receiver",
  								nodeType: "VariableDeclaration",
  								scope: 1142,
  								src: "5440:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1067,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5440:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1070,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1142,
  								src: "5458:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1069,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "5458:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "5421:49:1"
  					},
  					returnParameters: {
  						id: 1072,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "5480:0:1"
  					},
  					scope: 1776,
  					src: "5398:599:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1267,
  						nodeType: "Block",
  						src: "6039:940:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1155,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1151,
  																name: "this",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2455,
  																src: "6081:4:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															],
  															id: 1150,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															lValueRequested: false,
  															nodeType: "ElementaryTypeNameExpression",
  															src: "6073:7:1",
  															typeDescriptions: {
  																typeIdentifier: "t_type$_t_address_$",
  																typeString: "type(address)"
  															},
  															typeName: "address"
  														},
  														id: 1152,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "typeConversion",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6073:13:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1148,
  														name: "token",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 493,
  														src: "6057:5:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 1149,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "balanceOf",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1984,
  													src: "6057:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1153,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6057:30:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1154,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1144,
  												src: "6091:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6057:40:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1147,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "6049:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1156,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6049:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1157,
  								nodeType: "ExpressionStatement",
  								src: "6049:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1158,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "6109:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1159,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6109:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1160,
  								nodeType: "ExpressionStatement",
  								src: "6109:16:1"
  							},
  							{
  								assignments: [
  									1162
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1162,
  										name: "borrowSnapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1267,
  										src: "6136:37:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  											typeString: "struct Market.BorrowSnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 1161,
  											name: "BorrowSnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 523,
  											src: "6136:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1167,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 1163,
  										name: "borrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 531,
  										src: "6176:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  											typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  										}
  									},
  									id: 1166,
  									indexExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1164,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "6184:3:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 1165,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "6184:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "6176:19:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  										typeString: "struct Market.BorrowSnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "6136:59:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1171,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1168,
  											name: "borrowSnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1162,
  											src: "6210:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1169,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "6210:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1170,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "6237:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "6210:28:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1205,
  								nodeType: "IfStatement",
  								src: "6206:316:1",
  								trueBody: {
  									id: 1204,
  									nodeType: "Block",
  									src: "6240:282:1",
  									statements: [
  										{
  											assignments: [
  												1173
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 1173,
  													name: "interest",
  													nodeType: "VariableDeclaration",
  													scope: 1204,
  													src: "6254:13:1",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													typeName: {
  														id: 1172,
  														name: "uint",
  														nodeType: "ElementaryTypeName",
  														src: "6254:4:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													value: null,
  													visibility: "internal"
  												}
  											],
  											id: 1187,
  											initialValue: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														expression: {
  															argumentTypes: null,
  															id: 1184,
  															name: "borrowSnapshot",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1162,
  															src: "6350:14:1",
  															typeDescriptions: {
  																typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																typeString: "struct Market.BorrowSnapshot storage pointer"
  															}
  														},
  														id: 1185,
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "principal",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 520,
  														src: "6350:24:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																expression: {
  																	argumentTypes: null,
  																	id: 1180,
  																	name: "borrowSnapshot",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1162,
  																	src: "6316:14:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																		typeString: "struct Market.BorrowSnapshot storage pointer"
  																	}
  																},
  																id: 1181,
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "interestIndex",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 522,
  																src: "6316:28:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		id: 1177,
  																		name: "borrowIndex",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 503,
  																		src: "6299:11:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 1174,
  																			name: "borrowSnapshot",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 1162,
  																			src: "6270:14:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																				typeString: "struct Market.BorrowSnapshot storage pointer"
  																			}
  																		},
  																		id: 1175,
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "principal",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: 520,
  																		src: "6270:24:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1176,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "mul",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 2110,
  																	src: "6270:28:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1178,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "6270:41:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1179,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "div",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2124,
  															src: "6270:45:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1182,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6270:75:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1183,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sub",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2144,
  													src: "6270:79:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1186,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6270:105:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "6254:121:1"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1196,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1188,
  														name: "borrowSnapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1162,
  														src: "6390:14:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1190,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "principal",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 520,
  													src: "6390:24:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 1194,
  															name: "interest",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1173,
  															src: "6446:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															expression: {
  																argumentTypes: null,
  																id: 1191,
  																name: "borrowSnapshot",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1162,
  																src: "6417:14:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																	typeString: "struct Market.BorrowSnapshot storage pointer"
  																}
  															},
  															id: 1192,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "principal",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 520,
  															src: "6417:24:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1193,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "6417:28:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1195,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6417:38:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6390:65:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1197,
  											nodeType: "ExpressionStatement",
  											src: "6390:65:1"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1202,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1198,
  														name: "borrowSnapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1162,
  														src: "6469:14:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1200,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "interestIndex",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 522,
  													src: "6469:28:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													id: 1201,
  													name: "borrowIndex",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 503,
  													src: "6500:11:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6469:42:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1203,
  											nodeType: "ExpressionStatement",
  											src: "6469:42:1"
  										}
  									]
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1224,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														expression: {
  															argumentTypes: null,
  															id: 1209,
  															name: "msg",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2431,
  															src: "6571:3:1",
  															typeDescriptions: {
  																typeIdentifier: "t_magic_message",
  																typeString: "msg"
  															}
  														},
  														id: 1210,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sender",
  														nodeType: "MemberAccess",
  														referencedDeclaration: null,
  														src: "6571:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1207,
  														name: "controller",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 495,
  														src: "6540:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_Controller_$479",
  															typeString: "contract Controller"
  														}
  													},
  													id: 1208,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "getAccountLiquidity",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 223,
  													src: "6540:30:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1211,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6540:42:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "32",
  														id: 1222,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "6635:1:1",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_2_by_1",
  															typeString: "int_const 2"
  														},
  														value: "2"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_2_by_1",
  															typeString: "int_const 2"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1219,
  																name: "amount",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1144,
  																src: "6623:6:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 1215,
  																				name: "this",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 2455,
  																				src: "6612:4:1",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_Market_$1776",
  																					typeString: "contract Market"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_contract$_Market_$1776",
  																					typeString: "contract Market"
  																				}
  																			],
  																			id: 1214,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "6604:7:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_address_$",
  																				typeString: "type(address)"
  																			},
  																			typeName: "address"
  																		},
  																		id: 1216,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "6604:13:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: null,
  																		id: 1212,
  																		name: "controller",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 495,
  																		src: "6586:10:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_contract$_Controller_$479",
  																			typeString: "contract Controller"
  																		}
  																	},
  																	id: 1213,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "prices",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 20,
  																	src: "6586:17:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  																		typeString: "function (address) view external returns (uint256)"
  																	}
  																},
  																id: 1217,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "6586:32:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1218,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "6586:36:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1220,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6586:44:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1221,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "mul",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2110,
  													src: "6586:48:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1223,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6586:51:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6540:97:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f7420656e6f756768206163636f756e74206c6971756964697479",
  											id: 1225,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6639:30:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_3481438806bd731c49f94f7a13dfbf51889c04dace9a72cea8773a6e5ca00f2f",
  												typeString: "literal_string \"Not enough account liquidity\""
  											},
  											value: "Not enough account liquidity"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_3481438806bd731c49f94f7a13dfbf51889c04dace9a72cea8773a6e5ca00f2f",
  												typeString: "literal_string \"Not enough account liquidity\""
  											}
  										],
  										id: 1206,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "6532:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1226,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6532:138:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1227,
  								nodeType: "ExpressionStatement",
  								src: "6532:138:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1231,
  														name: "msg",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2431,
  														src: "6704:3:1",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_message",
  															typeString: "msg"
  														}
  													},
  													id: 1232,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sender",
  													nodeType: "MemberAccess",
  													referencedDeclaration: null,
  													src: "6704:10:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 1233,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1144,
  													src: "6716:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1229,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "6689:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 1230,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transfer",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1993,
  												src: "6689:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,uint256) external returns (bool)"
  												}
  											},
  											id: 1234,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6689:34:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e7320746f20626f72726f77",
  											id: 1235,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6725:28:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_98e8ecbef10c54a0048df6c3e9cfdd8708815736fd05d576aaaa593cbd493129",
  												typeString: "literal_string \"No enough tokens to borrow\""
  											},
  											value: "No enough tokens to borrow"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_98e8ecbef10c54a0048df6c3e9cfdd8708815736fd05d576aaaa593cbd493129",
  												typeString: "literal_string \"No enough tokens to borrow\""
  											}
  										],
  										id: 1228,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "6681:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1236,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6681:73:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1237,
  								nodeType: "ExpressionStatement",
  								src: "6681:73:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1246,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1238,
  											name: "borrowSnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1162,
  											src: "6765:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1240,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "6765:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1244,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1144,
  												src: "6821:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1241,
  													name: "borrowSnapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1162,
  													src: "6792:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1242,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "6792:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1243,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "6792:28:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1245,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "6792:36:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "6765:63:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1247,
  								nodeType: "ExpressionStatement",
  								src: "6765:63:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1252,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1248,
  											name: "borrowSnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1162,
  											src: "6838:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1250,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 522,
  										src: "6838:28:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1251,
  										name: "borrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 503,
  										src: "6869:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "6838:42:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1253,
  								nodeType: "ExpressionStatement",
  								src: "6838:42:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1259,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1254,
  										name: "totalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 505,
  										src: "6891:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1257,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1144,
  												src: "6923:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1255,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "6906:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1256,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "6906:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1258,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "6906:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "6891:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1260,
  								nodeType: "ExpressionStatement",
  								src: "6891:39:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1262,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "6953:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1263,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "6953:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1264,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1144,
  											src: "6965:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1261,
  										name: "Borrow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 552,
  										src: "6946:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1265,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6946:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1266,
  								nodeType: "EmitStatement",
  								src: "6941:31:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1268,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "borrow",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1145,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1144,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1268,
  								src: "6019:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1143,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "6019:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "6018:13:1"
  					},
  					returnParameters: {
  						id: 1146,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "6039:0:1"
  					},
  					scope: 1776,
  					src: "6003:976:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1296,
  						nodeType: "Block",
  						src: "7018:277:1",
  						statements: [
  							{
  								assignments: [
  									1272
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1272,
  										name: "currentBlockNumber",
  										nodeType: "VariableDeclaration",
  										scope: 1296,
  										src: "7028:23:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1271,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7028:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1275,
  								initialValue: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										id: 1273,
  										name: "block",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2421,
  										src: "7054:5:1",
  										typeDescriptions: {
  											typeIdentifier: "t_magic_block",
  											typeString: "block"
  										}
  									},
  									id: 1274,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "number",
  									nodeType: "MemberAccess",
  									referencedDeclaration: null,
  									src: "7054:12:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7028:38:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1282,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1276,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7078:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1277,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7092:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1278,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "7077:27:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1280,
  												name: "currentBlockNumber",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1272,
  												src: "7134:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1279,
  											name: "calculateBorrowDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1367,
  											src: "7107:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1281,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7107:46:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "7077:76:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1283,
  								nodeType: "ExpressionStatement",
  								src: "7077:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1290,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1284,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "7164:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1285,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "7177:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1286,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "7163:26:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1288,
  												name: "currentBlockNumber",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1272,
  												src: "7219:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1287,
  											name: "calculateSupplyDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1437,
  											src: "7192:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1289,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7192:46:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "7163:75:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1291,
  								nodeType: "ExpressionStatement",
  								src: "7163:75:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1294,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1292,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "7249:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1293,
  										name: "currentBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1272,
  										src: "7270:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7249:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1295,
  								nodeType: "ExpressionStatement",
  								src: "7249:39:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1297,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "accrueInterest",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1269,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "7008:2:1"
  					},
  					returnParameters: {
  						id: 1270,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "7018:0:1"
  					},
  					scope: 1776,
  					src: "6985:310:1",
  					stateMutability: "nonpayable",
  					superFunction: 1814,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1366,
  						nodeType: "Block",
  						src: "7424:570:1",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1308,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1306,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1299,
  										src: "7438:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<=",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1307,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "7456:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7438:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1313,
  								nodeType: "IfStatement",
  								src: "7434:88:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1309,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7496:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1310,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7510:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1311,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "7495:27:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1305,
  									id: 1312,
  									nodeType: "Return",
  									src: "7488:34:1"
  								}
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1316,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1314,
  										name: "totalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 505,
  										src: "7537:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1315,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "7553:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "7537:17:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1321,
  								nodeType: "IfStatement",
  								src: "7533:69:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1317,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7576:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1318,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7590:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1319,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "7575:27:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1305,
  									id: 1320,
  									nodeType: "Return",
  									src: "7568:34:1"
  								}
  							},
  							{
  								assignments: [
  									1323
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1323,
  										name: "blockDelta",
  										nodeType: "VariableDeclaration",
  										scope: 1366,
  										src: "7613:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1322,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7613:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1327,
  								initialValue: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1326,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1324,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1299,
  										src: "7631:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "-",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1325,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "7648:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7631:35:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7613:53:1"
  							},
  							{
  								assignments: [
  									1329
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1329,
  										name: "simpleInterestFactor",
  										nodeType: "VariableDeclaration",
  										scope: 1366,
  										src: "7677:25:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1328,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7677:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1335,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1333,
  											name: "blockDelta",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1323,
  											src: "7730:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 1330,
  												name: "borrowRatePerBlock",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 782,
  												src: "7705:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 1331,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "7705:20:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1332,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "mul",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2110,
  										src: "7705:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1334,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7705:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7677:64:1"
  							},
  							{
  								assignments: [
  									1337
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1337,
  										name: "interestAccumulated",
  										nodeType: "VariableDeclaration",
  										scope: 1366,
  										src: "7751:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1336,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7751:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1345,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1343,
  											name: "FACTOR",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 534,
  											src: "7821:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1340,
  													name: "totalBorrows",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 505,
  													src: "7803:12:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1338,
  													name: "simpleInterestFactor",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1329,
  													src: "7778:20:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 1339,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "7778:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 1341,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "7778:38:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1342,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "7778:42:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1344,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7778:50:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7751:77:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1357,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1346,
  										name: "newBorrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1304,
  										src: "7839:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1355,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7910:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 1352,
  														name: "FACTOR",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 534,
  														src: "7898:6:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1349,
  																name: "borrowIndex",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 503,
  																src: "7881:11:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1347,
  																name: "simpleInterestFactor",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1329,
  																src: "7856:20:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1348,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "7856:24:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1350,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "7856:37:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1351,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "div",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2124,
  													src: "7856:41:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1353,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "7856:49:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1354,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "7856:53:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1356,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7856:66:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7839:83:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1358,
  								nodeType: "ExpressionStatement",
  								src: "7839:83:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1364,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1359,
  										name: "newTotalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1302,
  										src: "7932:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1362,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7974:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1360,
  												name: "interestAccumulated",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1337,
  												src: "7950:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1361,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "7950:23:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1363,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7950:37:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7932:55:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1365,
  								nodeType: "ExpressionStatement",
  								src: "7932:55:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1367,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "calculateBorrowDataAtBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1300,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1299,
  								name: "newBlockNumber",
  								nodeType: "VariableDeclaration",
  								scope: 1367,
  								src: "7337:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1298,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "7337:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7336:21:1"
  					},
  					returnParameters: {
  						id: 1305,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1302,
  								name: "newTotalBorrows",
  								nodeType: "VariableDeclaration",
  								scope: 1367,
  								src: "7381:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1301,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "7381:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1304,
  								name: "newBorrowIndex",
  								nodeType: "VariableDeclaration",
  								scope: 1367,
  								src: "7403:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1303,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "7403:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7380:43:1"
  					},
  					scope: 1776,
  					src: "7301:693:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1436,
  						nodeType: "Block",
  						src: "8122:564:1",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1378,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1376,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1369,
  										src: "8136:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<=",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1377,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "8154:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8136:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1383,
  								nodeType: "IfStatement",
  								src: "8132:87:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1379,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "8194:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1380,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "8207:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1381,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "8193:26:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1375,
  									id: 1382,
  									nodeType: "Return",
  									src: "8186:33:1"
  								}
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1386,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1384,
  										name: "totalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 497,
  										src: "8234:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1385,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "8249:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "8234:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1391,
  								nodeType: "IfStatement",
  								src: "8230:67:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1387,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "8272:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1388,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "8285:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1389,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "8271:26:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1375,
  									id: 1390,
  									nodeType: "Return",
  									src: "8264:33:1"
  								}
  							},
  							{
  								assignments: [
  									1393
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1393,
  										name: "blockDelta",
  										nodeType: "VariableDeclaration",
  										scope: 1436,
  										src: "8308:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1392,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8308:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1397,
  								initialValue: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1396,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1394,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1369,
  										src: "8326:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "-",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1395,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "8343:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8326:35:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "8308:53:1"
  							},
  							{
  								assignments: [
  									1399
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1399,
  										name: "simpleInterestFactor",
  										nodeType: "VariableDeclaration",
  										scope: 1436,
  										src: "8372:25:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1398,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8372:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1405,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1403,
  											name: "blockDelta",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1393,
  											src: "8425:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 1400,
  												name: "supplyRatePerBlock",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 795,
  												src: "8400:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 1401,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "8400:20:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1402,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "mul",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2110,
  										src: "8400:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1404,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "8400:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "8372:64:1"
  							},
  							{
  								assignments: [
  									1407
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1407,
  										name: "interestAccumulated",
  										nodeType: "VariableDeclaration",
  										scope: 1436,
  										src: "8446:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1406,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8446:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1415,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1413,
  											name: "FACTOR",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 534,
  											src: "8515:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1410,
  													name: "totalSupply",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 497,
  													src: "8498:11:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1408,
  													name: "simpleInterestFactor",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1399,
  													src: "8473:20:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 1409,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "8473:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 1411,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "8473:37:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1412,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "8473:41:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1414,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "8473:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "8446:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1427,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1416,
  										name: "newSupplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1374,
  										src: "8533:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1425,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "8604:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 1422,
  														name: "FACTOR",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 534,
  														src: "8592:6:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1419,
  																name: "supplyIndex",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 499,
  																src: "8575:11:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1417,
  																name: "simpleInterestFactor",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1399,
  																src: "8550:20:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1418,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "8550:24:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1420,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "8550:37:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1421,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "div",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2124,
  													src: "8550:41:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1423,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "8550:49:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1424,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "8550:53:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1426,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "8550:66:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8533:83:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1428,
  								nodeType: "ExpressionStatement",
  								src: "8533:83:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1434,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1429,
  										name: "newTotalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1372,
  										src: "8626:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1432,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "8667:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1430,
  												name: "interestAccumulated",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1407,
  												src: "8643:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1431,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "8643:23:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1433,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "8643:36:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8626:53:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1435,
  								nodeType: "ExpressionStatement",
  								src: "8626:53:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1437,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "calculateSupplyDataAtBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1370,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1369,
  								name: "newBlockNumber",
  								nodeType: "VariableDeclaration",
  								scope: 1437,
  								src: "8036:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1368,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8036:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8035:21:1"
  					},
  					returnParameters: {
  						id: 1375,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1372,
  								name: "newTotalSupply",
  								nodeType: "VariableDeclaration",
  								scope: 1437,
  								src: "8080:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1371,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8080:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1374,
  								name: "newSupplyIndex",
  								nodeType: "VariableDeclaration",
  								scope: 1437,
  								src: "8101:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1373,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8101:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8079:42:1"
  					},
  					scope: 1776,
  					src: "8000:686:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1459,
  						nodeType: "Block",
  						src: "8753:186:1",
  						statements: [
  							{
  								assignments: [
  									1443
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1443,
  										name: "newTotalBorrows",
  										nodeType: "VariableDeclaration",
  										scope: 1459,
  										src: "8763:20:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1442,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8763:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1444,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "8763:20:1"
  							},
  							{
  								assignments: [
  									1446
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1446,
  										name: "newBorrowIndex",
  										nodeType: "VariableDeclaration",
  										scope: 1459,
  										src: "8793:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1445,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8793:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1447,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "8793:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1455,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1448,
  												name: "newTotalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1443,
  												src: "8824:15:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1449,
  												name: "newBorrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1446,
  												src: "8841:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1450,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "8823:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1452,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "8886:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 1453,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "8886:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1451,
  											name: "calculateBorrowDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1367,
  											src: "8859:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1454,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "8859:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "8823:76:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1456,
  								nodeType: "ExpressionStatement",
  								src: "8823:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1457,
  									name: "newTotalBorrows",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 1443,
  									src: "8917:15:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1441,
  								id: 1458,
  								nodeType: "Return",
  								src: "8910:22:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1460,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getUpdatedTotalBorrows",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1438,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "8723:2:1"
  					},
  					returnParameters: {
  						id: 1441,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1440,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1460,
  								src: "8747:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1439,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8747:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8746:6:1"
  					},
  					scope: 1776,
  					src: "8692:247:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1482,
  						nodeType: "Block",
  						src: "9005:183:1",
  						statements: [
  							{
  								assignments: [
  									1466
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1466,
  										name: "newTotalSupply",
  										nodeType: "VariableDeclaration",
  										scope: 1482,
  										src: "9015:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1465,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9015:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1467,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9015:19:1"
  							},
  							{
  								assignments: [
  									1469
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1469,
  										name: "newSupplyIndex",
  										nodeType: "VariableDeclaration",
  										scope: 1482,
  										src: "9044:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1468,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9044:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1470,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9044:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1478,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1471,
  												name: "newTotalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1466,
  												src: "9075:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1472,
  												name: "newSupplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1469,
  												src: "9091:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1473,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "9074:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1475,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "9136:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 1476,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9136:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1474,
  											name: "calculateSupplyDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1437,
  											src: "9109:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1477,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9109:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "9074:75:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1479,
  								nodeType: "ExpressionStatement",
  								src: "9074:75:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1480,
  									name: "newTotalSupply",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 1466,
  									src: "9167:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1464,
  								id: 1481,
  								nodeType: "Return",
  								src: "9160:21:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1483,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getUpdatedTotalSupply",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1461,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "8975:2:1"
  					},
  					returnParameters: {
  						id: 1464,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1463,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1483,
  								src: "8999:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1462,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8999:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8998:6:1"
  					},
  					scope: 1776,
  					src: "8945:243:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1522,
  						nodeType: "Block",
  						src: "9233:253:1",
  						statements: [
  							{
  								assignments: [
  									1489
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1489,
  										name: "paid",
  										nodeType: "VariableDeclaration",
  										scope: 1522,
  										src: "9243:9:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1488,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9243:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1490,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9243:9:1"
  							},
  							{
  								assignments: [
  									1492
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1492,
  										name: "additional",
  										nodeType: "VariableDeclaration",
  										scope: 1522,
  										src: "9262:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1491,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9262:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1493,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9262:15:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1504,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1494,
  												name: "paid",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1489,
  												src: "9289:4:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1495,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1492,
  												src: "9295:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1496,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "9288:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1498,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "9327:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1499,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9327:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1500,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "9339:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1501,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9339:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1502,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1485,
  												src: "9351:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1497,
  											name: "payBorrowInternal",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1649,
  											src: "9309:17:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address,address,uint256) returns (uint256,uint256)"
  											}
  										},
  										id: 1503,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9309:49:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "9288:70:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1505,
  								nodeType: "ExpressionStatement",
  								src: "9288:70:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1507,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "9384:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1508,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "9384:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1509,
  											name: "paid",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1489,
  											src: "9396:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1506,
  										name: "PayBorrow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 558,
  										src: "9374:9:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1510,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9374:27:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1511,
  								nodeType: "EmitStatement",
  								src: "9369:32:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1514,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1512,
  										name: "additional",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1492,
  										src: "9416:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1513,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "9429:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "9416:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1521,
  								nodeType: "IfStatement",
  								src: "9412:67:1",
  								trueBody: {
  									eventCall: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1516,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "9456:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1517,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9456:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1518,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1492,
  												src: "9468:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1515,
  											name: "Supply",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 540,
  											src: "9449:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  												typeString: "function (address,uint256)"
  											}
  										},
  										id: 1519,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9449:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 1520,
  									nodeType: "EmitStatement",
  									src: "9444:35:1"
  								}
  							}
  						]
  					},
  					documentation: null,
  					id: 1523,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "payBorrow",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1486,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1485,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1523,
  								src: "9213:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1484,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9213:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "9212:13:1"
  					},
  					returnParameters: {
  						id: 1487,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "9233:0:1"
  					},
  					scope: 1776,
  					src: "9194:292:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1648,
  						nodeType: "Block",
  						src: "9609:852:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1536,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "9619:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1537,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9619:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1538,
  								nodeType: "ExpressionStatement",
  								src: "9619:16:1"
  							},
  							{
  								assignments: [
  									1540
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1540,
  										name: "snapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1648,
  										src: "9646:31:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  											typeString: "struct Market.BorrowSnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 1539,
  											name: "BorrowSnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 523,
  											src: "9646:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1544,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 1541,
  										name: "borrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 531,
  										src: "9680:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  											typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  										}
  									},
  									id: 1543,
  									indexExpression: {
  										argumentTypes: null,
  										id: 1542,
  										name: "borrower",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1527,
  										src: "9688:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "9680:17:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  										typeString: "struct Market.BorrowSnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9646:51:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1549,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1546,
  													name: "snapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1540,
  													src: "9716:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1547,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "9716:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 1548,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9737:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "9716:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1545,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "9708:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1550,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9708:31:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1551,
  								nodeType: "ExpressionStatement",
  								src: "9708:31:1"
  							},
  							{
  								assignments: [
  									1553
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1553,
  										name: "interest",
  										nodeType: "VariableDeclaration",
  										scope: 1648,
  										src: "9750:13:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1552,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9750:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1567,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1564,
  												name: "snapshot",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1540,
  												src: "9834:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  													typeString: "struct Market.BorrowSnapshot storage pointer"
  												}
  											},
  											id: 1565,
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "principal",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 520,
  											src: "9834:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1560,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1540,
  														src: "9806:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1561,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "interestIndex",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 522,
  													src: "9806:22:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 1557,
  															name: "borrowIndex",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 503,
  															src: "9789:11:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															expression: {
  																argumentTypes: null,
  																id: 1554,
  																name: "snapshot",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1540,
  																src: "9766:8:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																	typeString: "struct Market.BorrowSnapshot storage pointer"
  																}
  															},
  															id: 1555,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "principal",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 520,
  															src: "9766:18:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1556,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2110,
  														src: "9766:22:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1558,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "9766:35:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 1559,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "div",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2124,
  												src: "9766:39:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 1562,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "9766:63:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1563,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sub",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2144,
  										src: "9766:67:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1566,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9766:87:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9750:103:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1576,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1568,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "9864:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1570,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "9864:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1574,
  												name: "interest",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1553,
  												src: "9908:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1571,
  													name: "snapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1540,
  													src: "9885:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1572,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "9885:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1573,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "9885:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1575,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9885:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "9864:53:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1577,
  								nodeType: "ExpressionStatement",
  								src: "9864:53:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1582,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1578,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "9927:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1580,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 522,
  										src: "9927:22:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1581,
  										name: "borrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 503,
  										src: "9952:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "9927:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1583,
  								nodeType: "ExpressionStatement",
  								src: "9927:36:1"
  							},
  							{
  								assignments: [
  									1585
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1585,
  										name: "additional",
  										nodeType: "VariableDeclaration",
  										scope: 1648,
  										src: "9974:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1584,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9974:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1586,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9974:15:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1590,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1587,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "10004:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1588,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "10004:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1589,
  										name: "amount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1529,
  										src: "10025:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "10004:27:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1605,
  								nodeType: "IfStatement",
  								src: "10000:142:1",
  								trueBody: {
  									id: 1604,
  									nodeType: "Block",
  									src: "10033:109:1",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1597,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 1591,
  													name: "additional",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1585,
  													src: "10047:10:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															expression: {
  																argumentTypes: null,
  																id: 1594,
  																name: "snapshot",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1540,
  																src: "10071:8:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																	typeString: "struct Market.BorrowSnapshot storage pointer"
  																}
  															},
  															id: 1595,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "principal",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 520,
  															src: "10071:18:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 1592,
  															name: "amount",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1529,
  															src: "10060:6:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1593,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sub",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2144,
  														src: "10060:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1596,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "10060:30:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "10047:43:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1598,
  											nodeType: "ExpressionStatement",
  											src: "10047:43:1"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1602,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 1599,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1529,
  													src: "10104:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1600,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1540,
  														src: "10113:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1601,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "principal",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 520,
  													src: "10113:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "10104:27:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1603,
  											nodeType: "ExpressionStatement",
  											src: "10104:27:1"
  										}
  									]
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1609,
  													name: "payer",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1525,
  													src: "10179:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 1611,
  															name: "this",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2455,
  															src: "10194:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														],
  														id: 1610,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "10186:7:1",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_address_$",
  															typeString: "type(address)"
  														},
  														typeName: "address"
  													},
  													id: 1612,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "10186:13:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 1613,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1529,
  													src: "10201:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1607,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "10160:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 1608,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transferFrom",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1952,
  												src: "10160:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,address,uint256) external returns (bool)"
  												}
  											},
  											id: 1614,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "10160:48:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e73",
  											id: 1615,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "10210:18:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											},
  											value: "No enough tokens"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											}
  										],
  										id: 1606,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "10152:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1616,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10152:77:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1617,
  								nodeType: "ExpressionStatement",
  								src: "10152:77:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1626,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1618,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "10240:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1620,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "10240:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1624,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1529,
  												src: "10284:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1621,
  													name: "snapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1540,
  													src: "10261:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1622,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "10261:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1623,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "10261:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1625,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "10261:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "10240:51:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1627,
  								nodeType: "ExpressionStatement",
  								src: "10240:51:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1633,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1628,
  										name: "totalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 505,
  										src: "10301:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1631,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1529,
  												src: "10333:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1629,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "10316:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1630,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "10316:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1632,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "10316:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "10301:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1634,
  								nodeType: "ExpressionStatement",
  								src: "10301:39:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1637,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1635,
  										name: "additional",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1585,
  										src: "10355:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1636,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "10368:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "10355:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1643,
  								nodeType: "IfStatement",
  								src: "10351:65:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1639,
  												name: "payer",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1525,
  												src: "10398:5:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1640,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1585,
  												src: "10405:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1638,
  											name: "supplyInternal",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1007,
  											src: "10383:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  												typeString: "function (address,uint256)"
  											}
  										},
  										id: 1641,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "10383:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 1642,
  									nodeType: "ExpressionStatement",
  									src: "10383:33:1"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									components: [
  										{
  											argumentTypes: null,
  											id: 1644,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1529,
  											src: "10435:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1645,
  											name: "additional",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1585,
  											src: "10443:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									id: 1646,
  									isConstant: false,
  									isInlineArray: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "TupleExpression",
  									src: "10434:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  										typeString: "tuple(uint256,uint256)"
  									}
  								},
  								functionReturnParameters: 1535,
  								id: 1647,
  								nodeType: "Return",
  								src: "10427:27:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1649,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "payBorrowInternal",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1530,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1525,
  								name: "payer",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9519:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1524,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "9519:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1527,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9534:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1526,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "9534:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1529,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9552:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1528,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9552:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "9518:46:1"
  					},
  					returnParameters: {
  						id: 1535,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1532,
  								name: "paid",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9583:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1531,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9583:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1534,
  								name: "supplied",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9594:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1533,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9594:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "9582:26:1"
  					},
  					scope: 1776,
  					src: "9492:969:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1750,
  						nodeType: "Block",
  						src: "10564:704:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1661,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1659,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "10582:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 1660,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "10591:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "10582:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1658,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10574:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1662,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10574:19:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1663,
  								nodeType: "ExpressionStatement",
  								src: "10574:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 1668,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1665,
  												name: "borrower",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1651,
  												src: "10611:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1666,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "10623:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1667,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "10623:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "10611:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1664,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10603:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1669,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10603:31:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1670,
  								nodeType: "ExpressionStatement",
  								src: "10603:31:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1671,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "10645:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1672,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10645:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1673,
  								nodeType: "ExpressionStatement",
  								src: "10645:16:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											argumentTypes: null,
  											id: 1674,
  											name: "collateralMarket",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1655,
  											src: "10671:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										},
  										id: 1676,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "accrueInterest",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1814,
  										src: "10671:31:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_nonpayable$__$returns$__$",
  											typeString: "function () external"
  										}
  									},
  									id: 1677,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10671:33:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1678,
  								nodeType: "ExpressionStatement",
  								src: "10671:33:1"
  							},
  							{
  								assignments: [
  									1680
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1680,
  										name: "debt",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10715:9:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1679,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10715:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1684,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1682,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1651,
  											src: "10743:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										id: 1681,
  										name: "updatedBorrowBy",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 867,
  										src: "10727:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) view returns (uint256)"
  										}
  									},
  									id: 1683,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10727:25:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10715:37:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1688,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1686,
  												name: "debt",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1680,
  												src: "10771:4:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1687,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "10779:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "10771:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1685,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10763:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1689,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10763:23:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1690,
  								nodeType: "ExpressionStatement",
  								src: "10763:23:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1698,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														expression: {
  															argumentTypes: null,
  															id: 1694,
  															name: "msg",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2431,
  															src: "10820:3:1",
  															typeDescriptions: {
  																typeIdentifier: "t_magic_message",
  																typeString: "msg"
  															}
  														},
  														id: 1695,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sender",
  														nodeType: "MemberAccess",
  														referencedDeclaration: null,
  														src: "10820:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1692,
  														name: "token",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 493,
  														src: "10804:5:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 1693,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "balanceOf",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1984,
  													src: "10804:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1696,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "10804:27:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1697,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "10835:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "10804:37:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1691,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10796:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1699,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10796:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1700,
  								nodeType: "ExpressionStatement",
  								src: "10796:46:1"
  							},
  							{
  								assignments: [
  									1702
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1702,
  										name: "collateralAmount",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10853:21:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1701,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10853:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1711,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1705,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1651,
  											src: "10908:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1706,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "10918:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1707,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "10918:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1708,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1653,
  											src: "10930:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1709,
  											name: "collateralMarket",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1655,
  											src: "10938:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 1703,
  											name: "controller",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 495,
  											src: "10877:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_Controller_$479",
  												typeString: "contract Controller"
  											}
  										},
  										id: 1704,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "liquidateCollateral",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 478,
  										src: "10877:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$_t_contract$_MarketInterface_$1824_$returns$_t_uint256_$",
  											typeString: "function (address,address,uint256,contract MarketInterface) external returns (uint256)"
  										}
  									},
  									id: 1710,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10877:78:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10853:102:1"
  							},
  							{
  								assignments: [
  									1713
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1713,
  										name: "paid",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10966:9:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1712,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10966:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1714,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "10966:9:1"
  							},
  							{
  								assignments: [
  									1716
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1716,
  										name: "additional",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10985:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1715,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10985:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1717,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "10985:15:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1727,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1718,
  												name: "paid",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1713,
  												src: "11012:4:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1719,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1716,
  												src: "11018:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1720,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "11011:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1722,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "11050:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1723,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "11050:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1724,
  												name: "borrower",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1651,
  												src: "11062:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1725,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "11072:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1721,
  											name: "payBorrowInternal",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1649,
  											src: "11032:17:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address,address,uint256) returns (uint256,uint256)"
  											}
  										},
  										id: 1726,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "11032:47:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "11011:68:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1728,
  								nodeType: "ExpressionStatement",
  								src: "11011:68:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1730,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1651,
  											src: "11111:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1731,
  											name: "paid",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1713,
  											src: "11121:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1732,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "11127:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1733,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "11127:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1735,
  													name: "collateralMarket",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1655,
  													src: "11147:16:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_MarketInterface_$1824",
  														typeString: "contract MarketInterface"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_MarketInterface_$1824",
  														typeString: "contract MarketInterface"
  													}
  												],
  												id: 1734,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "11139:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 1736,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "11139:25:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1737,
  											name: "collateralAmount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1702,
  											src: "11166:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1729,
  										name: "LiquidateBorrow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 570,
  										src: "11095:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256,address,address,uint256)"
  										}
  									},
  									id: 1738,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "11095:88:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1739,
  								nodeType: "EmitStatement",
  								src: "11090:93:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1742,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1740,
  										name: "additional",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1716,
  										src: "11198:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1741,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "11211:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "11198:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1749,
  								nodeType: "IfStatement",
  								src: "11194:67:1",
  								trueBody: {
  									eventCall: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1744,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "11238:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1745,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "11238:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1746,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1716,
  												src: "11250:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1743,
  											name: "Supply",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 540,
  											src: "11231:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  												typeString: "function (address,uint256)"
  											}
  										},
  										id: 1747,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "11231:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 1748,
  									nodeType: "EmitStatement",
  									src: "11226:35:1"
  								}
  							}
  						]
  					},
  					documentation: null,
  					id: 1751,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "liquidateBorrow",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1656,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1651,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 1751,
  								src: "10492:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1650,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "10492:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1653,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1751,
  								src: "10510:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1652,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "10510:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1655,
  								name: "collateralMarket",
  								nodeType: "VariableDeclaration",
  								scope: 1751,
  								src: "10523:32:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_MarketInterface_$1824",
  									typeString: "contract MarketInterface"
  								},
  								typeName: {
  									contractScope: null,
  									id: 1654,
  									name: "MarketInterface",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1824,
  									src: "10523:15:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_MarketInterface_$1824",
  										typeString: "contract MarketInterface"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "10491:65:1"
  					},
  					returnParameters: {
  						id: 1657,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "10564:0:1"
  					},
  					scope: 1776,
  					src: "10467:801:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1774,
  						nodeType: "Block",
  						src: "11363:86:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1765,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1763,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1757,
  												src: "11381:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 1764,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "11390:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "11381:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1762,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "11373:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1766,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "11373:19:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1767,
  								nodeType: "ExpressionStatement",
  								src: "11373:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1769,
  											name: "sender",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1753,
  											src: "11417:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1770,
  											name: "receiver",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1755,
  											src: "11425:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1771,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1757,
  											src: "11435:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1768,
  										name: "redeemInternal",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1142,
  										src: "11402:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 1772,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "11402:40:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1773,
  								nodeType: "ExpressionStatement",
  								src: "11402:40:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1775,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 1760,
  							modifierName: {
  								argumentTypes: null,
  								id: 1759,
  								name: "onlyController",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 661,
  								src: "11348:14:1",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "11348:14:1"
  						}
  					],
  					name: "transferTo",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1758,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1753,
  								name: "sender",
  								nodeType: "VariableDeclaration",
  								scope: 1775,
  								src: "11294:14:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1752,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "11294:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1755,
  								name: "receiver",
  								nodeType: "VariableDeclaration",
  								scope: 1775,
  								src: "11310:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1754,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "11310:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1757,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1775,
  								src: "11328:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1756,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "11328:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "11293:47:1"
  					},
  					returnParameters: {
  						id: 1761,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "11363:0:1"
  					},
  					scope: 1776,
  					src: "11274:175:1",
  					stateMutability: "nonpayable",
  					superFunction: 1823,
  					visibility: "public"
  				}
  			],
  			scope: 1777,
  			src: "118:11333:1"
  		}
  	],
  	src: "0:11453:1"
  };
  var legacyAST = {
  	absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Market.sol",
  	exportedSymbols: {
  		Market: [
  			1776
  		]
  	},
  	id: 1777,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 481,
  			literals: [
  				"solidity",
  				">=",
  				"0.5",
  				".0",
  				"<",
  				"0.6",
  				".0"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:31:1"
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/ERC20.sol",
  			file: "./test/ERC20.sol",
  			id: 482,
  			nodeType: "ImportDirective",
  			scope: 1777,
  			sourceUnit: 1971,
  			src: "33:26:1",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/Controller.sol",
  			file: "./Controller.sol",
  			id: 483,
  			nodeType: "ImportDirective",
  			scope: 1777,
  			sourceUnit: 480,
  			src: "60:26:1",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/SafeMath.sol",
  			file: "./test/SafeMath.sol",
  			id: 484,
  			nodeType: "ImportDirective",
  			scope: 1777,
  			sourceUnit: 2170,
  			src: "87:29:1",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 485,
  						name: "MarketInterface",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1824,
  						src: "137:15:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_MarketInterface_$1824",
  							typeString: "contract MarketInterface"
  						}
  					},
  					id: 486,
  					nodeType: "InheritanceSpecifier",
  					src: "137:15:1"
  				}
  			],
  			contractDependencies: [
  				1824
  			],
  			contractKind: "contract",
  			documentation: null,
  			fullyImplemented: true,
  			id: 1776,
  			linearizedBaseContracts: [
  				1776,
  				1824
  			],
  			name: "Market",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					id: 489,
  					libraryName: {
  						contractScope: null,
  						id: 487,
  						name: "SafeMath",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2169,
  						src: "165:8:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_SafeMath_$2169",
  							typeString: "library SafeMath"
  						}
  					},
  					nodeType: "UsingForDirective",
  					src: "159:27:1",
  					typeName: {
  						id: 488,
  						name: "uint256",
  						nodeType: "ElementaryTypeName",
  						src: "178:7:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					}
  				},
  				{
  					constant: false,
  					id: 491,
  					name: "owner",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "192:20:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_address",
  						typeString: "address"
  					},
  					typeName: {
  						id: 490,
  						name: "address",
  						nodeType: "ElementaryTypeName",
  						src: "192:7:1",
  						stateMutability: "nonpayable",
  						typeDescriptions: {
  							typeIdentifier: "t_address",
  							typeString: "address"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 493,
  					name: "token",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "219:18:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_contract$_ERC20_$1970",
  						typeString: "contract ERC20"
  					},
  					typeName: {
  						contractScope: null,
  						id: 492,
  						name: "ERC20",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 1970,
  						src: "219:5:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_ERC20_$1970",
  							typeString: "contract ERC20"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 495,
  					name: "controller",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "243:28:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_contract$_Controller_$479",
  						typeString: "contract Controller"
  					},
  					typeName: {
  						contractScope: null,
  						id: 494,
  						name: "Controller",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 479,
  						src: "243:10:1",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_Controller_$479",
  							typeString: "contract Controller"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 497,
  					name: "totalSupply",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "278:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 496,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "278:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 499,
  					name: "supplyIndex",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "308:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 498,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "308:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 501,
  					name: "accrualBlockNumber",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "338:30:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 500,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "338:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 503,
  					name: "borrowIndex",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "375:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 502,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "375:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 505,
  					name: "totalBorrows",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "404:24:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 504,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "404:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 507,
  					name: "baseBorrowRate",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "434:26:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 506,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "434:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 509,
  					name: "utilizationRateFraction",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "466:35:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 508,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "466:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 511,
  					name: "deployBlock",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "507:23:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 510,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "507:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 513,
  					name: "blocksPerYear",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "537:25:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 512,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "537:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					canonicalName: "Market.SupplySnapshot",
  					id: 518,
  					members: [
  						{
  							constant: false,
  							id: 515,
  							name: "supply",
  							nodeType: "VariableDeclaration",
  							scope: 518,
  							src: "601:11:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 514,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "601:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						},
  						{
  							constant: false,
  							id: 517,
  							name: "interestIndex",
  							nodeType: "VariableDeclaration",
  							scope: 518,
  							src: "622:18:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 516,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "622:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						}
  					],
  					name: "SupplySnapshot",
  					nodeType: "StructDefinition",
  					scope: 1776,
  					src: "569:78:1",
  					visibility: "public"
  				},
  				{
  					canonicalName: "Market.BorrowSnapshot",
  					id: 523,
  					members: [
  						{
  							constant: false,
  							id: 520,
  							name: "principal",
  							nodeType: "VariableDeclaration",
  							scope: 523,
  							src: "685:14:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 519,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "685:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						},
  						{
  							constant: false,
  							id: 522,
  							name: "interestIndex",
  							nodeType: "VariableDeclaration",
  							scope: 523,
  							src: "709:18:1",
  							stateVariable: false,
  							storageLocation: "default",
  							typeDescriptions: {
  								typeIdentifier: "t_uint256",
  								typeString: "uint256"
  							},
  							typeName: {
  								id: 521,
  								name: "uint",
  								nodeType: "ElementaryTypeName",
  								src: "709:4:1",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								}
  							},
  							value: null,
  							visibility: "internal"
  						}
  					],
  					name: "BorrowSnapshot",
  					nodeType: "StructDefinition",
  					scope: 1776,
  					src: "653:81:1",
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 527,
  					name: "supplies",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "740:44:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  						typeString: "mapping(address => struct Market.SupplySnapshot)"
  					},
  					typeName: {
  						id: 526,
  						keyType: {
  							id: 524,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "749:7:1",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "740:35:1",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  							typeString: "mapping(address => struct Market.SupplySnapshot)"
  						},
  						valueType: {
  							contractScope: null,
  							id: 525,
  							name: "SupplySnapshot",
  							nodeType: "UserDefinedTypeName",
  							referencedDeclaration: 518,
  							src: "760:14:1",
  							typeDescriptions: {
  								typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  								typeString: "struct Market.SupplySnapshot"
  							}
  						}
  					},
  					value: null,
  					visibility: "internal"
  				},
  				{
  					constant: false,
  					id: 531,
  					name: "borrows",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "790:43:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  						typeString: "mapping(address => struct Market.BorrowSnapshot)"
  					},
  					typeName: {
  						id: 530,
  						keyType: {
  							id: 528,
  							name: "address",
  							nodeType: "ElementaryTypeName",
  							src: "799:7:1",
  							typeDescriptions: {
  								typeIdentifier: "t_address",
  								typeString: "address"
  							}
  						},
  						nodeType: "Mapping",
  						src: "790:35:1",
  						typeDescriptions: {
  							typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  							typeString: "mapping(address => struct Market.BorrowSnapshot)"
  						},
  						valueType: {
  							contractScope: null,
  							id: 529,
  							name: "BorrowSnapshot",
  							nodeType: "UserDefinedTypeName",
  							referencedDeclaration: 523,
  							src: "810:14:1",
  							typeDescriptions: {
  								typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  								typeString: "struct Market.BorrowSnapshot"
  							}
  						}
  					},
  					value: null,
  					visibility: "internal"
  				},
  				{
  					constant: true,
  					id: 534,
  					name: "FACTOR",
  					nodeType: "VariableDeclaration",
  					scope: 1776,
  					src: "840:34:1",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint256",
  						typeString: "uint256"
  					},
  					typeName: {
  						id: 532,
  						name: "uint",
  						nodeType: "ElementaryTypeName",
  						src: "840:4:1",
  						typeDescriptions: {
  							typeIdentifier: "t_uint256",
  							typeString: "uint256"
  						}
  					},
  					value: {
  						argumentTypes: null,
  						hexValue: "31653138",
  						id: 533,
  						isConstant: false,
  						isLValue: false,
  						isPure: true,
  						kind: "number",
  						lValueRequested: false,
  						nodeType: "Literal",
  						src: "870:4:1",
  						subdenomination: null,
  						typeDescriptions: {
  							typeIdentifier: "t_rational_1000000000000000000_by_1",
  							typeString: "int_const 1000000000000000000"
  						},
  						value: "1e18"
  					},
  					visibility: "public"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 540,
  					name: "Supply",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 539,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 536,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 540,
  								src: "894:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 535,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "894:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 538,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 540,
  								src: "916:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 537,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "916:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "893:35:1"
  					},
  					src: "881:48:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 546,
  					name: "Redeem",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 545,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 542,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 546,
  								src: "947:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 541,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "947:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 544,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 546,
  								src: "969:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 543,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "969:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "946:35:1"
  					},
  					src: "934:48:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 552,
  					name: "Borrow",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 551,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 548,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 552,
  								src: "1000:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 547,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1000:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 550,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 552,
  								src: "1022:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 549,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1022:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "999:35:1"
  					},
  					src: "987:48:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 558,
  					name: "PayBorrow",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 557,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 554,
  								indexed: true,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 558,
  								src: "1056:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 553,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1056:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 556,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 558,
  								src: "1078:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 555,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1078:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1055:35:1"
  					},
  					src: "1040:51:1"
  				},
  				{
  					anonymous: false,
  					documentation: null,
  					id: 570,
  					name: "LiquidateBorrow",
  					nodeType: "EventDefinition",
  					parameters: {
  						id: 569,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 560,
  								indexed: true,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1118:24:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 559,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1118:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 562,
  								indexed: false,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1144:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 561,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1144:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 564,
  								indexed: true,
  								name: "liquidator",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1157:26:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 563,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1157:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 566,
  								indexed: false,
  								name: "collateralMarket",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1185:24:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 565,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "1185:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 568,
  								indexed: false,
  								name: "collateralAmount",
  								nodeType: "VariableDeclaration",
  								scope: 570,
  								src: "1211:21:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 567,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1211:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1117:116:1"
  					},
  					src: "1096:138:1"
  				},
  				{
  					body: {
  						id: 636,
  						nodeType: "Block",
  						src: "1353:437:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 588,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  												],
  												expression: {
  													argumentTypes: [
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 583,
  																name: "_token",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 572,
  																src: "1377:6:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_ERC20_$1970",
  																	typeString: "contract ERC20"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_contract$_ERC20_$1970",
  																	typeString: "contract ERC20"
  																}
  															],
  															id: 582,
  															name: "ERC20",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1970,
  															src: "1371:5:1",
  															typeDescriptions: {
  																typeIdentifier: "t_type$_t_contract$_ERC20_$1970_$",
  																typeString: "type(contract ERC20)"
  															}
  														},
  														id: 584,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "typeConversion",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "1371:13:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 585,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "totalSupply",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1977,
  													src: "1371:25:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  														typeString: "function () view external returns (uint256)"
  													}
  												},
  												id: 586,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1371:27:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 587,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "1402:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "1371:32:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 581,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1363:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 589,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1363:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 590,
  								nodeType: "ExpressionStatement",
  								src: "1363:41:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 594,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 591,
  										name: "owner",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 491,
  										src: "1414:5:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 592,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "1422:3:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 593,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1422:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									src: "1414:18:1",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								id: 595,
  								nodeType: "ExpressionStatement",
  								src: "1414:18:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 598,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 596,
  										name: "token",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 493,
  										src: "1442:5:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_ERC20_$1970",
  											typeString: "contract ERC20"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 597,
  										name: "_token",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 572,
  										src: "1450:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_ERC20_$1970",
  											typeString: "contract ERC20"
  										}
  									},
  									src: "1442:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_ERC20_$1970",
  										typeString: "contract ERC20"
  									}
  								},
  								id: 599,
  								nodeType: "ExpressionStatement",
  								src: "1442:14:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 602,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 600,
  										name: "borrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 503,
  										src: "1466:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 601,
  										name: "FACTOR",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 534,
  										src: "1480:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1466:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 603,
  								nodeType: "ExpressionStatement",
  								src: "1466:20:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 606,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 604,
  										name: "supplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 499,
  										src: "1496:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 605,
  										name: "FACTOR",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 534,
  										src: "1510:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1496:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 607,
  								nodeType: "ExpressionStatement",
  								src: "1496:20:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 610,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 608,
  										name: "blocksPerYear",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 513,
  										src: "1526:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 609,
  										name: "_blocksPerYear",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 576,
  										src: "1542:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1526:30:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 611,
  								nodeType: "ExpressionStatement",
  								src: "1526:30:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 617,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 612,
  										name: "baseBorrowRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 507,
  										src: "1566:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 615,
  												name: "_blocksPerYear",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 576,
  												src: "1609:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 613,
  												name: "_baseBorrowAnnualRate",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 574,
  												src: "1583:21:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 614,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "1583:25:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 616,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1583:41:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1566:58:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 618,
  								nodeType: "ExpressionStatement",
  								src: "1566:58:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 622,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 619,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "1634:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 620,
  											name: "block",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2421,
  											src: "1655:5:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_block",
  												typeString: "block"
  											}
  										},
  										id: 621,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "number",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1655:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1634:33:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 623,
  								nodeType: "ExpressionStatement",
  								src: "1634:33:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 629,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 624,
  										name: "utilizationRateFraction",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 509,
  										src: "1677:23:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 627,
  												name: "_blocksPerYear",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 576,
  												src: "1732:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 625,
  												name: "_utilizationRateFraction",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 578,
  												src: "1703:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 626,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "div",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2124,
  											src: "1703:28:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 628,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "1703:44:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1677:70:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 630,
  								nodeType: "ExpressionStatement",
  								src: "1677:70:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 634,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 631,
  										name: "deployBlock",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 511,
  										src: "1757:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 632,
  											name: "block",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2421,
  											src: "1771:5:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_block",
  												typeString: "block"
  											}
  										},
  										id: 633,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "number",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "1771:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "1757:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 635,
  								nodeType: "ExpressionStatement",
  								src: "1757:26:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 637,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 579,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 572,
  								name: "_token",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1252:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_ERC20_$1970",
  									typeString: "contract ERC20"
  								},
  								typeName: {
  									contractScope: null,
  									id: 571,
  									name: "ERC20",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1970,
  									src: "1252:5:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_ERC20_$1970",
  										typeString: "contract ERC20"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 574,
  								name: "_baseBorrowAnnualRate",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1266:26:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 573,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1266:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 576,
  								name: "_blocksPerYear",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1294:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 575,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1294:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 578,
  								name: "_utilizationRateFraction",
  								nodeType: "VariableDeclaration",
  								scope: 637,
  								src: "1315:29:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 577,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "1315:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "1251:94:1"
  					},
  					returnParameters: {
  						id: 580,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1353:0:1"
  					},
  					scope: 1776,
  					src: "1240:550:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 647,
  						nodeType: "Block",
  						src: "1817:56:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 643,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 640,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "1835:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 641,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "1835:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												id: 642,
  												name: "owner",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 491,
  												src: "1849:5:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "1835:19:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 639,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1827:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 644,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1827:28:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 645,
  								nodeType: "ExpressionStatement",
  								src: "1827:28:1"
  							},
  							{
  								id: 646,
  								nodeType: "PlaceholderStatement",
  								src: "1865:1:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 648,
  					name: "onlyOwner",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 638,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1814:2:1"
  					},
  					src: "1796:77:1",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 660,
  						nodeType: "Block",
  						src: "1905:70:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 656,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 651,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "1923:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 652,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "1923:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "==",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 654,
  														name: "controller",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 495,
  														src: "1945:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_Controller_$479",
  															typeString: "contract Controller"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_contract$_Controller_$479",
  															typeString: "contract Controller"
  														}
  													],
  													id: 653,
  													isConstant: false,
  													isLValue: false,
  													isPure: true,
  													lValueRequested: false,
  													nodeType: "ElementaryTypeNameExpression",
  													src: "1937:7:1",
  													typeDescriptions: {
  														typeIdentifier: "t_type$_t_address_$",
  														typeString: "type(address)"
  													},
  													typeName: "address"
  												},
  												id: 655,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "typeConversion",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "1937:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											src: "1923:33:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 650,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "1915:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 657,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "1915:42:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 658,
  								nodeType: "ExpressionStatement",
  								src: "1915:42:1"
  							},
  							{
  								id: 659,
  								nodeType: "PlaceholderStatement",
  								src: "1967:1:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 661,
  					name: "onlyController",
  					nodeType: "ModifierDefinition",
  					parameters: {
  						id: 649,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1902:2:1"
  					},
  					src: "1879:96:1",
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 673,
  						nodeType: "Block",
  						src: "2027:54:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 669,
  													name: "this",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2455,
  													src: "2068:4:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_Market_$1776",
  														typeString: "contract Market"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_Market_$1776",
  														typeString: "contract Market"
  													}
  												],
  												id: 668,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "2060:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 670,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2060:13:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 666,
  											name: "token",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 493,
  											src: "2044:5:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_ERC20_$1970",
  												typeString: "contract ERC20"
  											}
  										},
  										id: 667,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "balanceOf",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1984,
  										src: "2044:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) view external returns (uint256)"
  										}
  									},
  									id: 671,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2044:30:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 665,
  								id: 672,
  								nodeType: "Return",
  								src: "2037:37:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 674,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getCash",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 662,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "1997:2:1"
  					},
  					returnParameters: {
  						id: 665,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 664,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 674,
  								src: "2021:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 663,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2021:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2020:6:1"
  					},
  					scope: 1776,
  					src: "1981:100:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 705,
  						nodeType: "Block",
  						src: "2180:132:1",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 687,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 685,
  										name: "borrowed",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 678,
  										src: "2194:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 686,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2206:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "2194:13:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 690,
  								nodeType: "IfStatement",
  								src: "2190:39:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 688,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "2228:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 684,
  									id: 689,
  									nodeType: "Return",
  									src: "2221:8:1"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 701,
  													name: "reserves",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 680,
  													src: "2295:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 698,
  															name: "borrowed",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 678,
  															src: "2281:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 696,
  															name: "cash",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 676,
  															src: "2272:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 697,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "2272:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 699,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2272:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 700,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sub",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2144,
  												src: "2272:22:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 702,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2272:32:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 693,
  													name: "FACTOR",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 534,
  													src: "2260:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 691,
  													name: "borrowed",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 678,
  													src: "2247:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 692,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "2247:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 694,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2247:20:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 695,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "2247:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 703,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2247:58:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 684,
  								id: 704,
  								nodeType: "Return",
  								src: "2240:65:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 706,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "utilizationRate",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 681,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 676,
  								name: "cash",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2112:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 675,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2112:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 678,
  								name: "borrowed",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2123:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 677,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2123:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 680,
  								name: "reserves",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2138:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 679,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2138:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2111:41:1"
  					},
  					returnParameters: {
  						id: 684,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 683,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 706,
  								src: "2174:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 682,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2174:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2173:6:1"
  					},
  					scope: 1776,
  					src: "2087:225:1",
  					stateMutability: "pure",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 736,
  						nodeType: "Block",
  						src: "2409:149:1",
  						statements: [
  							{
  								assignments: [
  									718
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 718,
  										name: "ur",
  										nodeType: "VariableDeclaration",
  										scope: 736,
  										src: "2419:7:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 717,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2419:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 724,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 720,
  											name: "cash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 708,
  											src: "2445:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 721,
  											name: "borrowed",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 710,
  											src: "2451:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 722,
  											name: "reserves",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 712,
  											src: "2461:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 719,
  										name: "utilizationRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 706,
  										src: "2429:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 723,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2429:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "2419:51:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 733,
  											name: "baseBorrowRate",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 507,
  											src: "2536:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 730,
  													name: "FACTOR",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 534,
  													src: "2524:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 727,
  															name: "utilizationRateFraction",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 509,
  															src: "2495:23:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 725,
  															name: "ur",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 718,
  															src: "2488:2:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 726,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2110,
  														src: "2488:6:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 728,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2488:31:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 729,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "div",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2124,
  												src: "2488:35:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 731,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2488:43:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 732,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "add",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2168,
  										src: "2488:47:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 734,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2488:63:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 716,
  								id: 735,
  								nodeType: "Return",
  								src: "2481:70:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 737,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getBorrowRate",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 713,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 708,
  								name: "cash",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2341:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 707,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2341:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 710,
  								name: "borrowed",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2352:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 709,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2352:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 712,
  								name: "reserves",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2367:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 711,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2367:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2340:41:1"
  					},
  					returnParameters: {
  						id: 716,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 715,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 737,
  								src: "2403:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 714,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2403:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2402:6:1"
  					},
  					scope: 1776,
  					src: "2318:240:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 768,
  						nodeType: "Block",
  						src: "2655:161:1",
  						statements: [
  							{
  								assignments: [
  									749
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 749,
  										name: "borrowRate",
  										nodeType: "VariableDeclaration",
  										scope: 768,
  										src: "2665:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 748,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "2665:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 755,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 751,
  											name: "cash",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 739,
  											src: "2697:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 752,
  											name: "borrowed",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 741,
  											src: "2703:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 753,
  											name: "reserves",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 743,
  											src: "2713:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 750,
  										name: "getBorrowRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 737,
  										src: "2683:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 754,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2683:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "2665:57:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 765,
  											name: "FACTOR",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 534,
  											src: "2802:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 762,
  													name: "borrowRate",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 749,
  													src: "2786:10:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 757,
  															name: "cash",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 739,
  															src: "2756:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 758,
  															name: "borrowed",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 741,
  															src: "2762:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														{
  															argumentTypes: null,
  															id: 759,
  															name: "reserves",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 743,
  															src: "2772:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															},
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														id: 756,
  														name: "utilizationRate",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 706,
  														src: "2740:15:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  															typeString: "function (uint256,uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 760,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "2740:41:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 761,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "2740:45:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 763,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2740:57:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 764,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "2740:61:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 766,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2740:69:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 747,
  								id: 767,
  								nodeType: "Return",
  								src: "2733:76:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 769,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getSupplyRate",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 744,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 739,
  								name: "cash",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2587:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 738,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2587:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 741,
  								name: "borrowed",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2598:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 740,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2598:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 743,
  								name: "reserves",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2613:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 742,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2613:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2586:41:1"
  					},
  					returnParameters: {
  						id: 747,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 746,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 769,
  								src: "2649:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 745,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2649:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2648:6:1"
  					},
  					scope: 1776,
  					src: "2564:252:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 781,
  						nodeType: "Block",
  						src: "2879:65:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 775,
  												name: "getCash",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 674,
  												src: "2910:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 776,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "2910:9:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 777,
  											name: "totalBorrows",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 505,
  											src: "2921:12:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "30",
  											id: 778,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "2935:1:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											}
  										],
  										id: 774,
  										name: "getBorrowRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 737,
  										src: "2896:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 779,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "2896:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 773,
  								id: 780,
  								nodeType: "Return",
  								src: "2889:48:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 782,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "borrowRatePerBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 770,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2849:2:1"
  					},
  					returnParameters: {
  						id: 773,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 772,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 782,
  								src: "2873:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 771,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "2873:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "2872:6:1"
  					},
  					scope: 1776,
  					src: "2822:122:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 794,
  						nodeType: "Block",
  						src: "3007:65:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 788,
  												name: "getCash",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 674,
  												src: "3038:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 789,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3038:9:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 790,
  											name: "totalBorrows",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 505,
  											src: "3049:12:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "30",
  											id: 791,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "number",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "3063:1:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											},
  											value: "0"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_rational_0_by_1",
  												typeString: "int_const 0"
  											}
  										],
  										id: 787,
  										name: "getSupplyRate",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 769,
  										src: "3024:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_uint256_$_t_uint256_$_t_uint256_$returns$_t_uint256_$",
  											typeString: "function (uint256,uint256,uint256) view returns (uint256)"
  										}
  									},
  									id: 792,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3024:41:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 786,
  								id: 793,
  								nodeType: "Return",
  								src: "3017:48:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 795,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supplyRatePerBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 783,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "2977:2:1"
  					},
  					returnParameters: {
  						id: 786,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 785,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 795,
  								src: "3001:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 784,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3001:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3000:6:1"
  					},
  					scope: 1776,
  					src: "2950:122:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 807,
  						nodeType: "Block",
  						src: "3137:45:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 802,
  											name: "supplies",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 527,
  											src: "3154:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  												typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  											}
  										},
  										id: 804,
  										indexExpression: {
  											argumentTypes: null,
  											id: 803,
  											name: "user",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 797,
  											src: "3163:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "IndexAccess",
  										src: "3154:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  											typeString: "struct Market.SupplySnapshot storage ref"
  										}
  									},
  									id: 805,
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "supply",
  									nodeType: "MemberAccess",
  									referencedDeclaration: 515,
  									src: "3154:21:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 801,
  								id: 806,
  								nodeType: "Return",
  								src: "3147:28:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 808,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supplyOf",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 798,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 797,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 808,
  								src: "3096:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 796,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3096:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3095:14:1"
  					},
  					returnParameters: {
  						id: 801,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 800,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 808,
  								src: "3131:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 799,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3131:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3130:6:1"
  					},
  					scope: 1776,
  					src: "3078:104:1",
  					stateMutability: "view",
  					superFunction: 1790,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 820,
  						nodeType: "Block",
  						src: "3247:47:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 815,
  											name: "borrows",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 531,
  											src: "3264:7:1",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  												typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  											}
  										},
  										id: 817,
  										indexExpression: {
  											argumentTypes: null,
  											id: 816,
  											name: "user",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 810,
  											src: "3272:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "IndexAccess",
  										src: "3264:13:1",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  											typeString: "struct Market.BorrowSnapshot storage ref"
  										}
  									},
  									id: 818,
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "principal",
  									nodeType: "MemberAccess",
  									referencedDeclaration: 520,
  									src: "3264:23:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 814,
  								id: 819,
  								nodeType: "Return",
  								src: "3257:30:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 821,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "borrowBy",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 811,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 810,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 821,
  								src: "3206:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 809,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3206:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3205:14:1"
  					},
  					returnParameters: {
  						id: 814,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 813,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 821,
  								src: "3241:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 812,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3241:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3240:6:1"
  					},
  					scope: 1776,
  					src: "3188:106:1",
  					stateMutability: "view",
  					superFunction: 1797,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 866,
  						nodeType: "Block",
  						src: "3366:355:1",
  						statements: [
  							{
  								assignments: [
  									829
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 829,
  										name: "snapshot",
  										nodeType: "VariableDeclaration",
  										scope: 866,
  										src: "3376:31:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  											typeString: "struct Market.BorrowSnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 828,
  											name: "BorrowSnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 523,
  											src: "3376:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 833,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 830,
  										name: "borrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 531,
  										src: "3410:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  											typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  										}
  									},
  									id: 832,
  									indexExpression: {
  										argumentTypes: null,
  										id: 831,
  										name: "user",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 823,
  										src: "3418:4:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3410:13:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  										typeString: "struct Market.BorrowSnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3376:47:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 837,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 834,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 829,
  											src: "3438:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 835,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "3438:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 836,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3460:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "3438:23:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 840,
  								nodeType: "IfStatement",
  								src: "3434:49:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 838,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3482:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 827,
  									id: 839,
  									nodeType: "Return",
  									src: "3475:8:1"
  								}
  							},
  							{
  								assignments: [
  									842
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 842,
  										name: "newTotalBorrows",
  										nodeType: "VariableDeclaration",
  										scope: 866,
  										src: "3494:20:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 841,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3494:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 843,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3494:20:1"
  							},
  							{
  								assignments: [
  									845
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 845,
  										name: "newBorrowIndex",
  										nodeType: "VariableDeclaration",
  										scope: 866,
  										src: "3524:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 844,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3524:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 846,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3524:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 854,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 847,
  												name: "newTotalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 842,
  												src: "3555:15:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 848,
  												name: "newBorrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 845,
  												src: "3572:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 849,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "3554:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 851,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "3617:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 852,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "3617:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 850,
  											name: "calculateBorrowDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1367,
  											src: "3590:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 853,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "3590:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "3554:76:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 855,
  								nodeType: "ExpressionStatement",
  								src: "3554:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 862,
  												name: "snapshot",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 829,
  												src: "3691:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  													typeString: "struct Market.BorrowSnapshot storage pointer"
  												}
  											},
  											id: 863,
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "interestIndex",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 522,
  											src: "3691:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 859,
  													name: "newBorrowIndex",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 845,
  													src: "3671:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 856,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 829,
  														src: "3648:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 857,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "principal",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 520,
  													src: "3648:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 858,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "3648:22:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 860,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "3648:38:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 861,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "3648:42:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 864,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "3648:66:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 827,
  								id: 865,
  								nodeType: "Return",
  								src: "3641:73:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 867,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "updatedBorrowBy",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 824,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 823,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 867,
  								src: "3325:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 822,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3325:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3324:14:1"
  					},
  					returnParameters: {
  						id: 827,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 826,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 867,
  								src: "3360:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 825,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3360:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3359:6:1"
  					},
  					scope: 1776,
  					src: "3300:421:1",
  					stateMutability: "view",
  					superFunction: 1811,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 912,
  						nodeType: "Block",
  						src: "3793:348:1",
  						statements: [
  							{
  								assignments: [
  									875
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 875,
  										name: "snapshot",
  										nodeType: "VariableDeclaration",
  										scope: 912,
  										src: "3803:31:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  											typeString: "struct Market.SupplySnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 874,
  											name: "SupplySnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 518,
  											src: "3803:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 879,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 876,
  										name: "supplies",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 527,
  										src: "3837:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  											typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  										}
  									},
  									id: 878,
  									indexExpression: {
  										argumentTypes: null,
  										id: 877,
  										name: "user",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 869,
  										src: "3846:4:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "3837:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  										typeString: "struct Market.SupplySnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "3803:48:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 883,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 880,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 875,
  											src: "3866:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 881,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "3866:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 882,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3885:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "3866:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 886,
  								nodeType: "IfStatement",
  								src: "3862:46:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 884,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "3907:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									functionReturnParameters: 873,
  									id: 885,
  									nodeType: "Return",
  									src: "3900:8:1"
  								}
  							},
  							{
  								assignments: [
  									888
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 888,
  										name: "newTotalSupply",
  										nodeType: "VariableDeclaration",
  										scope: 912,
  										src: "3919:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 887,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3919:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 889,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3919:19:1"
  							},
  							{
  								assignments: [
  									891
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 891,
  										name: "newSupplyIndex",
  										nodeType: "VariableDeclaration",
  										scope: 912,
  										src: "3948:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 890,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "3948:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 892,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "3948:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 900,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 893,
  												name: "newTotalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 888,
  												src: "3979:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 894,
  												name: "newSupplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 891,
  												src: "3995:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 895,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "3978:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 897,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "4040:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 898,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "4040:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 896,
  											name: "calculateSupplyDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1437,
  											src: "4013:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 899,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4013:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "3978:75:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 901,
  								nodeType: "ExpressionStatement",
  								src: "3978:75:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 908,
  												name: "snapshot",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 875,
  												src: "4111:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  													typeString: "struct Market.SupplySnapshot storage pointer"
  												}
  											},
  											id: 909,
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "interestIndex",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 517,
  											src: "4111:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 905,
  													name: "newSupplyIndex",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 891,
  													src: "4091:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 902,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 875,
  														src: "4071:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  															typeString: "struct Market.SupplySnapshot storage pointer"
  														}
  													},
  													id: 903,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "supply",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 515,
  													src: "4071:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 904,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "4071:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 906,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "4071:35:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 907,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "4071:39:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 910,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4071:63:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 873,
  								id: 911,
  								nodeType: "Return",
  								src: "4064:70:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 913,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "updatedSupplyOf",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 870,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 869,
  								name: "user",
  								nodeType: "VariableDeclaration",
  								scope: 913,
  								src: "3752:12:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 868,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "3752:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3751:14:1"
  					},
  					returnParameters: {
  						id: 873,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 872,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 913,
  								src: "3787:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 871,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "3787:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "3786:6:1"
  					},
  					scope: 1776,
  					src: "3727:414:1",
  					stateMutability: "view",
  					superFunction: 1804,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 924,
  						nodeType: "Block",
  						src: "4211:41:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 922,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 920,
  										name: "controller",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 495,
  										src: "4221:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_Controller_$479",
  											typeString: "contract Controller"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 921,
  										name: "_controller",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 915,
  										src: "4234:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_contract$_Controller_$479",
  											typeString: "contract Controller"
  										}
  									},
  									src: "4221:24:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_Controller_$479",
  										typeString: "contract Controller"
  									}
  								},
  								id: 923,
  								nodeType: "ExpressionStatement",
  								src: "4221:24:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 925,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 918,
  							modifierName: {
  								argumentTypes: null,
  								id: 917,
  								name: "onlyOwner",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 648,
  								src: "4201:9:1",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "4201:9:1"
  						}
  					],
  					name: "setController",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 916,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 915,
  								name: "_controller",
  								nodeType: "VariableDeclaration",
  								scope: 925,
  								src: "4170:22:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_Controller_$479",
  									typeString: "contract Controller"
  								},
  								typeName: {
  									contractScope: null,
  									id: 914,
  									name: "Controller",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 479,
  									src: "4170:10:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_Controller_$479",
  										typeString: "contract Controller"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4169:24:1"
  					},
  					returnParameters: {
  						id: 919,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4211:0:1"
  					},
  					scope: 1776,
  					src: "4147:105:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 942,
  						nodeType: "Block",
  						src: "4294:93:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 931,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "4319:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 932,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "4319:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 933,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 927,
  											src: "4331:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 930,
  										name: "supplyInternal",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1007,
  										src: "4304:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 934,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4304:34:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 935,
  								nodeType: "ExpressionStatement",
  								src: "4304:34:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 937,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "4361:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 938,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "4361:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 939,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 927,
  											src: "4373:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 936,
  										name: "Supply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 540,
  										src: "4354:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 940,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4354:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 941,
  								nodeType: "EmitStatement",
  								src: "4349:31:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 943,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supply",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 928,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 927,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 943,
  								src: "4274:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 926,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "4274:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4273:13:1"
  					},
  					returnParameters: {
  						id: 929,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4294:0:1"
  					},
  					scope: 1776,
  					src: "4258:129:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1006,
  						nodeType: "Block",
  						src: "4457:473:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 953,
  													name: "supplier",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 945,
  													src: "4535:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 955,
  															name: "this",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2455,
  															src: "4553:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														],
  														id: 954,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "4545:7:1",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_address_$",
  															typeString: "type(address)"
  														},
  														typeName: "address"
  													},
  													id: 956,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "4545:13:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 957,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 947,
  													src: "4560:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 951,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "4516:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 952,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transferFrom",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1952,
  												src: "4516:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,address,uint256) external returns (bool)"
  												}
  											},
  											id: 958,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "4516:51:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e73",
  											id: 959,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "4569:18:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											},
  											value: "No enough tokens"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											}
  										],
  										id: 950,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "4508:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 960,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4508:80:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 961,
  								nodeType: "ExpressionStatement",
  								src: "4508:80:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 962,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "4599:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 963,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4599:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 964,
  								nodeType: "ExpressionStatement",
  								src: "4599:16:1"
  							},
  							{
  								assignments: [
  									966
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 966,
  										name: "supplySnapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1006,
  										src: "4626:37:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  											typeString: "struct Market.SupplySnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 965,
  											name: "SupplySnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 518,
  											src: "4626:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 970,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 967,
  										name: "supplies",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 527,
  										src: "4666:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  											typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  										}
  									},
  									id: 969,
  									indexExpression: {
  										argumentTypes: null,
  										id: 968,
  										name: "supplier",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 945,
  										src: "4675:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "4666:18:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  										typeString: "struct Market.SupplySnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "4626:58:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 977,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 971,
  											name: "supplySnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 966,
  											src: "4695:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 973,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "4695:21:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 975,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 945,
  												src: "4735:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 974,
  											name: "updatedSupplyOf",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 913,
  											src: "4719:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$",
  												typeString: "function (address) view returns (uint256)"
  											}
  										},
  										id: 976,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4719:25:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4695:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 978,
  								nodeType: "ExpressionStatement",
  								src: "4695:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 990,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 979,
  												name: "supplies",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 527,
  												src: "4754:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  													typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  												}
  											},
  											id: 981,
  											indexExpression: {
  												argumentTypes: null,
  												id: 980,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 945,
  												src: "4763:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "4754:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  												typeString: "struct Market.SupplySnapshot storage ref"
  											}
  										},
  										id: 982,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "4754:25:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 988,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 947,
  												src: "4812:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													baseExpression: {
  														argumentTypes: null,
  														id: 983,
  														name: "supplies",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 527,
  														src: "4782:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  															typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  														}
  													},
  													id: 985,
  													indexExpression: {
  														argumentTypes: null,
  														id: 984,
  														name: "supplier",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 945,
  														src: "4791:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													},
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													nodeType: "IndexAccess",
  													src: "4782:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  														typeString: "struct Market.SupplySnapshot storage ref"
  													}
  												},
  												id: 986,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "supply",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 515,
  												src: "4782:25:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 987,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "4782:29:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 989,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4782:37:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4754:65:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 991,
  								nodeType: "ExpressionStatement",
  								src: "4754:65:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 997,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 992,
  												name: "supplies",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 527,
  												src: "4829:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  													typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  												}
  											},
  											id: 994,
  											indexExpression: {
  												argumentTypes: null,
  												id: 993,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 945,
  												src: "4838:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "4829:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  												typeString: "struct Market.SupplySnapshot storage ref"
  											}
  										},
  										id: 995,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 517,
  										src: "4829:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 996,
  										name: "supplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 499,
  										src: "4864:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4829:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 998,
  								nodeType: "ExpressionStatement",
  								src: "4829:46:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1004,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 999,
  										name: "totalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 497,
  										src: "4886:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1002,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 947,
  												src: "4916:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1000,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "4900:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1001,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "4900:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1003,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "4900:23:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "4886:37:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1005,
  								nodeType: "ExpressionStatement",
  								src: "4886:37:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1007,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "supplyInternal",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 948,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 945,
  								name: "supplier",
  								nodeType: "VariableDeclaration",
  								scope: 1007,
  								src: "4417:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 944,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "4417:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 947,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1007,
  								src: "4435:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 946,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "4435:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4416:31:1"
  					},
  					returnParameters: {
  						id: 949,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4457:0:1"
  					},
  					scope: 1776,
  					src: "4393:537:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1063,
  						nodeType: "Block",
  						src: "4972:420:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1013,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "4997:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1014,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "4997:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1015,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "5009:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1016,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "5009:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1017,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1009,
  											src: "5021:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1012,
  										name: "redeemInternal",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1142,
  										src: "4982:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 1018,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "4982:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1019,
  								nodeType: "ExpressionStatement",
  								src: "4982:46:1"
  							},
  							{
  								assignments: [
  									1021
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1021,
  										name: "supplierSupplyValue",
  										nodeType: "VariableDeclaration",
  										scope: 1063,
  										src: "5039:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1020,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "5039:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1022,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "5039:24:1"
  							},
  							{
  								assignments: [
  									1024
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1024,
  										name: "supplierBorrowValue",
  										nodeType: "VariableDeclaration",
  										scope: 1063,
  										src: "5073:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1023,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "5073:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1025,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "5073:24:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1034,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1026,
  												name: "supplierSupplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1021,
  												src: "5109:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1027,
  												name: "supplierBorrowValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1024,
  												src: "5130:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1028,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "5108:42:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1031,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "5181:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1032,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "5181:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1029,
  												name: "controller",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 495,
  												src: "5153:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_contract$_Controller_$479",
  													typeString: "contract Controller"
  												}
  											},
  											id: 1030,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "getAccountValues",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 360,
  											src: "5153:27:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address) view external returns (uint256,uint256)"
  											}
  										},
  										id: 1033,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5153:39:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "5108:84:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1035,
  								nodeType: "ExpressionStatement",
  								src: "5108:84:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1054,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1037,
  												name: "supplierSupplyValue",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1021,
  												src: "5211:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  														],
  														expression: {
  															argumentTypes: [
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1050,
  																name: "controller",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 495,
  																src: "5320:10:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_Controller_$479",
  																	typeString: "contract Controller"
  																}
  															},
  															id: 1051,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "MANTISSA",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 30,
  															src: "5320:19:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  																typeString: "function () view external returns (uint256)"
  															}
  														},
  														id: 1052,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "5320:21:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		"arguments": [
  																		],
  																		expression: {
  																			argumentTypes: [
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				id: 1044,
  																				name: "controller",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 495,
  																				src: "5284:10:1",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_Controller_$479",
  																					typeString: "contract Controller"
  																				}
  																			},
  																			id: 1045,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "collateralFactor",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 25,
  																			src: "5284:27:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  																				typeString: "function () view external returns (uint256)"
  																			}
  																		},
  																		id: 1046,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "5284:29:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: null,
  																		"arguments": [
  																		],
  																		expression: {
  																			argumentTypes: [
  																			],
  																			expression: {
  																				argumentTypes: null,
  																				id: 1040,
  																				name: "controller",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 495,
  																				src: "5258:10:1",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_Controller_$479",
  																					typeString: "contract Controller"
  																				}
  																			},
  																			id: 1041,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: false,
  																			lValueRequested: false,
  																			memberName: "MANTISSA",
  																			nodeType: "MemberAccess",
  																			referencedDeclaration: 30,
  																			src: "5258:19:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_function_external_view$__$returns$_t_uint256_$",
  																				typeString: "function () view external returns (uint256)"
  																			}
  																		},
  																		id: 1042,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "functionCall",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "5258:21:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1043,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "add",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 2168,
  																	src: "5258:25:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1047,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "5258:56:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1038,
  																name: "supplierBorrowValue",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1024,
  																src: "5234:19:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1039,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "5234:23:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1048,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "5234:81:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1049,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "div",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2124,
  													src: "5234:85:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1053,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "5234:108:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "5211:131:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1036,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "5203:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1055,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5203:140:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1056,
  								nodeType: "ExpressionStatement",
  								src: "5203:140:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1058,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "5366:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1059,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "5366:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1060,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1009,
  											src: "5378:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1057,
  										name: "Redeem",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 546,
  										src: "5359:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1061,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5359:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1062,
  								nodeType: "EmitStatement",
  								src: "5354:31:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1064,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "redeem",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1010,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1009,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1064,
  								src: "4952:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1008,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "4952:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "4951:13:1"
  					},
  					returnParameters: {
  						id: 1011,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "4972:0:1"
  					},
  					scope: 1776,
  					src: "4936:456:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1141,
  						nodeType: "Block",
  						src: "5480:517:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1081,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1077,
  																name: "this",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2455,
  																src: "5522:4:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															],
  															id: 1076,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															lValueRequested: false,
  															nodeType: "ElementaryTypeNameExpression",
  															src: "5514:7:1",
  															typeDescriptions: {
  																typeIdentifier: "t_type$_t_address_$",
  																typeString: "type(address)"
  															},
  															typeName: "address"
  														},
  														id: 1078,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "typeConversion",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "5514:13:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1074,
  														name: "token",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 493,
  														src: "5498:5:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 1075,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "balanceOf",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1984,
  													src: "5498:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1079,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "5498:30:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1080,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5532:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "5498:40:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1073,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "5490:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1082,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5490:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1083,
  								nodeType: "ExpressionStatement",
  								src: "5490:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1084,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "5550:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1085,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5550:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1086,
  								nodeType: "ExpressionStatement",
  								src: "5550:16:1"
  							},
  							{
  								assignments: [
  									1088
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1088,
  										name: "supplySnapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1141,
  										src: "5577:37:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  											typeString: "struct Market.SupplySnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 1087,
  											name: "SupplySnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 518,
  											src: "5577:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1092,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 1089,
  										name: "supplies",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 527,
  										src: "5617:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  											typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  										}
  									},
  									id: 1091,
  									indexExpression: {
  										argumentTypes: null,
  										id: 1090,
  										name: "supplier",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1066,
  										src: "5626:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "5617:18:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  										typeString: "struct Market.SupplySnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "5577:58:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1099,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1093,
  											name: "supplySnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1088,
  											src: "5646:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 1095,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "5646:21:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1097,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1066,
  												src: "5686:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											],
  											id: 1096,
  											name: "updatedSupplyOf",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 913,
  											src: "5670:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$",
  												typeString: "function (address) view returns (uint256)"
  											}
  										},
  										id: 1098,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5670:25:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5646:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1100,
  								nodeType: "ExpressionStatement",
  								src: "5646:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1106,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											baseExpression: {
  												argumentTypes: null,
  												id: 1101,
  												name: "supplies",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 527,
  												src: "5705:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_mapping$_t_address_$_t_struct$_SupplySnapshot_$518_storage_$",
  													typeString: "mapping(address => struct Market.SupplySnapshot storage ref)"
  												}
  											},
  											id: 1103,
  											indexExpression: {
  												argumentTypes: null,
  												id: 1102,
  												name: "supplier",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1066,
  												src: "5714:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											nodeType: "IndexAccess",
  											src: "5705:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage",
  												typeString: "struct Market.SupplySnapshot storage ref"
  											}
  										},
  										id: 1104,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 517,
  										src: "5705:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1105,
  										name: "supplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 499,
  										src: "5740:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5705:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1107,
  								nodeType: "ExpressionStatement",
  								src: "5705:46:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1112,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1109,
  													name: "supplySnapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1088,
  													src: "5770:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  														typeString: "struct Market.SupplySnapshot storage pointer"
  													}
  												},
  												id: 1110,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "supply",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 515,
  												src: "5770:21:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1111,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5795:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "5770:31:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1108,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "5762:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1113,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5762:40:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1114,
  								nodeType: "ExpressionStatement",
  								src: "5762:40:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1118,
  													name: "receiver",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1068,
  													src: "5836:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 1119,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1070,
  													src: "5846:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1116,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "5821:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 1117,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transfer",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1993,
  												src: "5821:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,uint256) external returns (bool)"
  												}
  											},
  											id: 1120,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "5821:32:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e73",
  											id: 1121,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "5855:18:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											},
  											value: "No enough tokens"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											}
  										],
  										id: 1115,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "5813:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1122,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "5813:61:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1123,
  								nodeType: "ExpressionStatement",
  								src: "5813:61:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1132,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1124,
  											name: "supplySnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1088,
  											src: "5885:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  												typeString: "struct Market.SupplySnapshot storage pointer"
  											}
  										},
  										id: 1126,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "supply",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 515,
  										src: "5885:21:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1130,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5935:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1127,
  													name: "supplySnapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1088,
  													src: "5909:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_SupplySnapshot_$518_storage_ptr",
  														typeString: "struct Market.SupplySnapshot storage pointer"
  													}
  												},
  												id: 1128,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "supply",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 515,
  												src: "5909:21:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1129,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "5909:25:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1131,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5909:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5885:57:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1133,
  								nodeType: "ExpressionStatement",
  								src: "5885:57:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1139,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1134,
  										name: "totalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 497,
  										src: "5953:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1137,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1070,
  												src: "5983:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1135,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "5967:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1136,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "5967:15:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1138,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "5967:23:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "5953:37:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1140,
  								nodeType: "ExpressionStatement",
  								src: "5953:37:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1142,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "redeemInternal",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1071,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1066,
  								name: "supplier",
  								nodeType: "VariableDeclaration",
  								scope: 1142,
  								src: "5422:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1065,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5422:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1068,
  								name: "receiver",
  								nodeType: "VariableDeclaration",
  								scope: 1142,
  								src: "5440:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1067,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "5440:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1070,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1142,
  								src: "5458:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1069,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "5458:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "5421:49:1"
  					},
  					returnParameters: {
  						id: 1072,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "5480:0:1"
  					},
  					scope: 1776,
  					src: "5398:599:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1267,
  						nodeType: "Block",
  						src: "6039:940:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1155,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1151,
  																name: "this",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 2455,
  																src: "6081:4:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_contract$_Market_$1776",
  																	typeString: "contract Market"
  																}
  															],
  															id: 1150,
  															isConstant: false,
  															isLValue: false,
  															isPure: true,
  															lValueRequested: false,
  															nodeType: "ElementaryTypeNameExpression",
  															src: "6073:7:1",
  															typeDescriptions: {
  																typeIdentifier: "t_type$_t_address_$",
  																typeString: "type(address)"
  															},
  															typeName: "address"
  														},
  														id: 1152,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "typeConversion",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6073:13:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address",
  															typeString: "address"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1148,
  														name: "token",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 493,
  														src: "6057:5:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 1149,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "balanceOf",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1984,
  													src: "6057:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1153,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6057:30:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1154,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1144,
  												src: "6091:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6057:40:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1147,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "6049:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1156,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6049:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1157,
  								nodeType: "ExpressionStatement",
  								src: "6049:49:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1158,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "6109:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1159,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6109:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1160,
  								nodeType: "ExpressionStatement",
  								src: "6109:16:1"
  							},
  							{
  								assignments: [
  									1162
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1162,
  										name: "borrowSnapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1267,
  										src: "6136:37:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  											typeString: "struct Market.BorrowSnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 1161,
  											name: "BorrowSnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 523,
  											src: "6136:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1167,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 1163,
  										name: "borrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 531,
  										src: "6176:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  											typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  										}
  									},
  									id: 1166,
  									indexExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1164,
  											name: "msg",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2431,
  											src: "6184:3:1",
  											typeDescriptions: {
  												typeIdentifier: "t_magic_message",
  												typeString: "msg"
  											}
  										},
  										id: 1165,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sender",
  										nodeType: "MemberAccess",
  										referencedDeclaration: null,
  										src: "6184:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address_payable",
  											typeString: "address payable"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "6176:19:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  										typeString: "struct Market.BorrowSnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "6136:59:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1171,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1168,
  											name: "borrowSnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1162,
  											src: "6210:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1169,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "6210:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1170,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "6237:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "6210:28:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1205,
  								nodeType: "IfStatement",
  								src: "6206:316:1",
  								trueBody: {
  									id: 1204,
  									nodeType: "Block",
  									src: "6240:282:1",
  									statements: [
  										{
  											assignments: [
  												1173
  											],
  											declarations: [
  												{
  													constant: false,
  													id: 1173,
  													name: "interest",
  													nodeType: "VariableDeclaration",
  													scope: 1204,
  													src: "6254:13:1",
  													stateVariable: false,
  													storageLocation: "default",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													},
  													typeName: {
  														id: 1172,
  														name: "uint",
  														nodeType: "ElementaryTypeName",
  														src: "6254:4:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													value: null,
  													visibility: "internal"
  												}
  											],
  											id: 1187,
  											initialValue: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														expression: {
  															argumentTypes: null,
  															id: 1184,
  															name: "borrowSnapshot",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1162,
  															src: "6350:14:1",
  															typeDescriptions: {
  																typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																typeString: "struct Market.BorrowSnapshot storage pointer"
  															}
  														},
  														id: 1185,
  														isConstant: false,
  														isLValue: true,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "principal",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 520,
  														src: "6350:24:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																expression: {
  																	argumentTypes: null,
  																	id: 1180,
  																	name: "borrowSnapshot",
  																	nodeType: "Identifier",
  																	overloadedDeclarations: [
  																	],
  																	referencedDeclaration: 1162,
  																	src: "6316:14:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																		typeString: "struct Market.BorrowSnapshot storage pointer"
  																	}
  																},
  																id: 1181,
  																isConstant: false,
  																isLValue: true,
  																isPure: false,
  																lValueRequested: false,
  																memberName: "interestIndex",
  																nodeType: "MemberAccess",
  																referencedDeclaration: 522,
  																src: "6316:28:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		id: 1177,
  																		name: "borrowIndex",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 503,
  																		src: "6299:11:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: null,
  																		expression: {
  																			argumentTypes: null,
  																			id: 1174,
  																			name: "borrowSnapshot",
  																			nodeType: "Identifier",
  																			overloadedDeclarations: [
  																			],
  																			referencedDeclaration: 1162,
  																			src: "6270:14:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																				typeString: "struct Market.BorrowSnapshot storage pointer"
  																			}
  																		},
  																		id: 1175,
  																		isConstant: false,
  																		isLValue: true,
  																		isPure: false,
  																		lValueRequested: false,
  																		memberName: "principal",
  																		nodeType: "MemberAccess",
  																		referencedDeclaration: 520,
  																		src: "6270:24:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_uint256",
  																			typeString: "uint256"
  																		}
  																	},
  																	id: 1176,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "mul",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 2110,
  																	src: "6270:28:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																		typeString: "function (uint256,uint256) pure returns (uint256)"
  																	}
  																},
  																id: 1178,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "6270:41:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1179,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "div",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2124,
  															src: "6270:45:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1182,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6270:75:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1183,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sub",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2144,
  													src: "6270:79:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1186,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6270:105:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "VariableDeclarationStatement",
  											src: "6254:121:1"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1196,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1188,
  														name: "borrowSnapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1162,
  														src: "6390:14:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1190,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "principal",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 520,
  													src: "6390:24:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 1194,
  															name: "interest",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1173,
  															src: "6446:8:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															expression: {
  																argumentTypes: null,
  																id: 1191,
  																name: "borrowSnapshot",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1162,
  																src: "6417:14:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																	typeString: "struct Market.BorrowSnapshot storage pointer"
  																}
  															},
  															id: 1192,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "principal",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 520,
  															src: "6417:24:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1193,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "add",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2168,
  														src: "6417:28:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1195,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "6417:38:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6390:65:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1197,
  											nodeType: "ExpressionStatement",
  											src: "6390:65:1"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1202,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1198,
  														name: "borrowSnapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1162,
  														src: "6469:14:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1200,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: true,
  													memberName: "interestIndex",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 522,
  													src: "6469:28:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													id: 1201,
  													name: "borrowIndex",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 503,
  													src: "6500:11:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "6469:42:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1203,
  											nodeType: "ExpressionStatement",
  											src: "6469:42:1"
  										}
  									]
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1224,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														expression: {
  															argumentTypes: null,
  															id: 1209,
  															name: "msg",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2431,
  															src: "6571:3:1",
  															typeDescriptions: {
  																typeIdentifier: "t_magic_message",
  																typeString: "msg"
  															}
  														},
  														id: 1210,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sender",
  														nodeType: "MemberAccess",
  														referencedDeclaration: null,
  														src: "6571:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1207,
  														name: "controller",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 495,
  														src: "6540:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_Controller_$479",
  															typeString: "contract Controller"
  														}
  													},
  													id: 1208,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "getAccountLiquidity",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 223,
  													src: "6540:30:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1211,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6540:42:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														hexValue: "32",
  														id: 1222,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														kind: "number",
  														lValueRequested: false,
  														nodeType: "Literal",
  														src: "6635:1:1",
  														subdenomination: null,
  														typeDescriptions: {
  															typeIdentifier: "t_rational_2_by_1",
  															typeString: "int_const 2"
  														},
  														value: "2"
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_rational_2_by_1",
  															typeString: "int_const 2"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1219,
  																name: "amount",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1144,
  																src: "6623:6:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																"arguments": [
  																	{
  																		argumentTypes: null,
  																		"arguments": [
  																			{
  																				argumentTypes: null,
  																				id: 1215,
  																				name: "this",
  																				nodeType: "Identifier",
  																				overloadedDeclarations: [
  																				],
  																				referencedDeclaration: 2455,
  																				src: "6612:4:1",
  																				typeDescriptions: {
  																					typeIdentifier: "t_contract$_Market_$1776",
  																					typeString: "contract Market"
  																				}
  																			}
  																		],
  																		expression: {
  																			argumentTypes: [
  																				{
  																					typeIdentifier: "t_contract$_Market_$1776",
  																					typeString: "contract Market"
  																				}
  																			],
  																			id: 1214,
  																			isConstant: false,
  																			isLValue: false,
  																			isPure: true,
  																			lValueRequested: false,
  																			nodeType: "ElementaryTypeNameExpression",
  																			src: "6604:7:1",
  																			typeDescriptions: {
  																				typeIdentifier: "t_type$_t_address_$",
  																				typeString: "type(address)"
  																			},
  																			typeName: "address"
  																		},
  																		id: 1216,
  																		isConstant: false,
  																		isLValue: false,
  																		isPure: false,
  																		kind: "typeConversion",
  																		lValueRequested: false,
  																		names: [
  																		],
  																		nodeType: "FunctionCall",
  																		src: "6604:13:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	}
  																],
  																expression: {
  																	argumentTypes: [
  																		{
  																			typeIdentifier: "t_address",
  																			typeString: "address"
  																		}
  																	],
  																	expression: {
  																		argumentTypes: null,
  																		id: 1212,
  																		name: "controller",
  																		nodeType: "Identifier",
  																		overloadedDeclarations: [
  																		],
  																		referencedDeclaration: 495,
  																		src: "6586:10:1",
  																		typeDescriptions: {
  																			typeIdentifier: "t_contract$_Controller_$479",
  																			typeString: "contract Controller"
  																		}
  																	},
  																	id: 1213,
  																	isConstant: false,
  																	isLValue: false,
  																	isPure: false,
  																	lValueRequested: false,
  																	memberName: "prices",
  																	nodeType: "MemberAccess",
  																	referencedDeclaration: 20,
  																	src: "6586:17:1",
  																	typeDescriptions: {
  																		typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  																		typeString: "function (address) view external returns (uint256)"
  																	}
  																},
  																id: 1217,
  																isConstant: false,
  																isLValue: false,
  																isPure: false,
  																kind: "functionCall",
  																lValueRequested: false,
  																names: [
  																],
  																nodeType: "FunctionCall",
  																src: "6586:32:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1218,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "6586:36:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1220,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "6586:44:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1221,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "mul",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2110,
  													src: "6586:48:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1223,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "6586:51:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "6540:97:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f7420656e6f756768206163636f756e74206c6971756964697479",
  											id: 1225,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6639:30:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_3481438806bd731c49f94f7a13dfbf51889c04dace9a72cea8773a6e5ca00f2f",
  												typeString: "literal_string \"Not enough account liquidity\""
  											},
  											value: "Not enough account liquidity"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_3481438806bd731c49f94f7a13dfbf51889c04dace9a72cea8773a6e5ca00f2f",
  												typeString: "literal_string \"Not enough account liquidity\""
  											}
  										],
  										id: 1206,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "6532:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1226,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6532:138:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1227,
  								nodeType: "ExpressionStatement",
  								src: "6532:138:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1231,
  														name: "msg",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 2431,
  														src: "6704:3:1",
  														typeDescriptions: {
  															typeIdentifier: "t_magic_message",
  															typeString: "msg"
  														}
  													},
  													id: 1232,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "sender",
  													nodeType: "MemberAccess",
  													referencedDeclaration: null,
  													src: "6704:10:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 1233,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1144,
  													src: "6716:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address_payable",
  														typeString: "address payable"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1229,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "6689:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 1230,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transfer",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1993,
  												src: "6689:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,uint256) external returns (bool)"
  												}
  											},
  											id: 1234,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "6689:34:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e7320746f20626f72726f77",
  											id: 1235,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "6725:28:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_98e8ecbef10c54a0048df6c3e9cfdd8708815736fd05d576aaaa593cbd493129",
  												typeString: "literal_string \"No enough tokens to borrow\""
  											},
  											value: "No enough tokens to borrow"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_98e8ecbef10c54a0048df6c3e9cfdd8708815736fd05d576aaaa593cbd493129",
  												typeString: "literal_string \"No enough tokens to borrow\""
  											}
  										],
  										id: 1228,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "6681:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1236,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6681:73:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1237,
  								nodeType: "ExpressionStatement",
  								src: "6681:73:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1246,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1238,
  											name: "borrowSnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1162,
  											src: "6765:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1240,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "6765:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1244,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1144,
  												src: "6821:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1241,
  													name: "borrowSnapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1162,
  													src: "6792:14:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1242,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "6792:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1243,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "6792:28:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1245,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "6792:36:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "6765:63:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1247,
  								nodeType: "ExpressionStatement",
  								src: "6765:63:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1252,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1248,
  											name: "borrowSnapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1162,
  											src: "6838:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1250,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 522,
  										src: "6838:28:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1251,
  										name: "borrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 503,
  										src: "6869:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "6838:42:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1253,
  								nodeType: "ExpressionStatement",
  								src: "6838:42:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1259,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1254,
  										name: "totalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 505,
  										src: "6891:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1257,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1144,
  												src: "6923:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1255,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "6906:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1256,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "6906:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1258,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "6906:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "6891:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1260,
  								nodeType: "ExpressionStatement",
  								src: "6891:39:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1262,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "6953:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1263,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "6953:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1264,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1144,
  											src: "6965:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1261,
  										name: "Borrow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 552,
  										src: "6946:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1265,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "6946:26:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1266,
  								nodeType: "EmitStatement",
  								src: "6941:31:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1268,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "borrow",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1145,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1144,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1268,
  								src: "6019:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1143,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "6019:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "6018:13:1"
  					},
  					returnParameters: {
  						id: 1146,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "6039:0:1"
  					},
  					scope: 1776,
  					src: "6003:976:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1296,
  						nodeType: "Block",
  						src: "7018:277:1",
  						statements: [
  							{
  								assignments: [
  									1272
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1272,
  										name: "currentBlockNumber",
  										nodeType: "VariableDeclaration",
  										scope: 1296,
  										src: "7028:23:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1271,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7028:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1275,
  								initialValue: {
  									argumentTypes: null,
  									expression: {
  										argumentTypes: null,
  										id: 1273,
  										name: "block",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2421,
  										src: "7054:5:1",
  										typeDescriptions: {
  											typeIdentifier: "t_magic_block",
  											typeString: "block"
  										}
  									},
  									id: 1274,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									memberName: "number",
  									nodeType: "MemberAccess",
  									referencedDeclaration: null,
  									src: "7054:12:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7028:38:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1282,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1276,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7078:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1277,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7092:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1278,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "7077:27:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1280,
  												name: "currentBlockNumber",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1272,
  												src: "7134:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1279,
  											name: "calculateBorrowDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1367,
  											src: "7107:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1281,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7107:46:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "7077:76:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1283,
  								nodeType: "ExpressionStatement",
  								src: "7077:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1290,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1284,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "7164:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1285,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "7177:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1286,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "7163:26:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1288,
  												name: "currentBlockNumber",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1272,
  												src: "7219:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1287,
  											name: "calculateSupplyDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1437,
  											src: "7192:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1289,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7192:46:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "7163:75:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1291,
  								nodeType: "ExpressionStatement",
  								src: "7163:75:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1294,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1292,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "7249:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1293,
  										name: "currentBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1272,
  										src: "7270:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7249:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1295,
  								nodeType: "ExpressionStatement",
  								src: "7249:39:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1297,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "accrueInterest",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1269,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "7008:2:1"
  					},
  					returnParameters: {
  						id: 1270,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "7018:0:1"
  					},
  					scope: 1776,
  					src: "6985:310:1",
  					stateMutability: "nonpayable",
  					superFunction: 1814,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1366,
  						nodeType: "Block",
  						src: "7424:570:1",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1308,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1306,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1299,
  										src: "7438:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<=",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1307,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "7456:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7438:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1313,
  								nodeType: "IfStatement",
  								src: "7434:88:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1309,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7496:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1310,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7510:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1311,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "7495:27:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1305,
  									id: 1312,
  									nodeType: "Return",
  									src: "7488:34:1"
  								}
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1316,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1314,
  										name: "totalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 505,
  										src: "7537:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1315,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "7553:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "7537:17:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1321,
  								nodeType: "IfStatement",
  								src: "7533:69:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1317,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7576:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1318,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7590:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1319,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "7575:27:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1305,
  									id: 1320,
  									nodeType: "Return",
  									src: "7568:34:1"
  								}
  							},
  							{
  								assignments: [
  									1323
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1323,
  										name: "blockDelta",
  										nodeType: "VariableDeclaration",
  										scope: 1366,
  										src: "7613:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1322,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7613:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1327,
  								initialValue: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1326,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1324,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1299,
  										src: "7631:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "-",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1325,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "7648:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7631:35:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7613:53:1"
  							},
  							{
  								assignments: [
  									1329
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1329,
  										name: "simpleInterestFactor",
  										nodeType: "VariableDeclaration",
  										scope: 1366,
  										src: "7677:25:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1328,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7677:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1335,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1333,
  											name: "blockDelta",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1323,
  											src: "7730:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 1330,
  												name: "borrowRatePerBlock",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 782,
  												src: "7705:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 1331,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "7705:20:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1332,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "mul",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2110,
  										src: "7705:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1334,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7705:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7677:64:1"
  							},
  							{
  								assignments: [
  									1337
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1337,
  										name: "interestAccumulated",
  										nodeType: "VariableDeclaration",
  										scope: 1366,
  										src: "7751:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1336,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "7751:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1345,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1343,
  											name: "FACTOR",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 534,
  											src: "7821:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1340,
  													name: "totalBorrows",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 505,
  													src: "7803:12:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1338,
  													name: "simpleInterestFactor",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1329,
  													src: "7778:20:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 1339,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "7778:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 1341,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "7778:38:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1342,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "7778:42:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1344,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "7778:50:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "7751:77:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1357,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1346,
  										name: "newBorrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1304,
  										src: "7839:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1355,
  												name: "borrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 503,
  												src: "7910:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 1352,
  														name: "FACTOR",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 534,
  														src: "7898:6:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1349,
  																name: "borrowIndex",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 503,
  																src: "7881:11:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1347,
  																name: "simpleInterestFactor",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1329,
  																src: "7856:20:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1348,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "7856:24:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1350,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "7856:37:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1351,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "div",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2124,
  													src: "7856:41:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1353,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "7856:49:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1354,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "7856:53:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1356,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7856:66:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7839:83:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1358,
  								nodeType: "ExpressionStatement",
  								src: "7839:83:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1364,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1359,
  										name: "newTotalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1302,
  										src: "7932:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1362,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "7974:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1360,
  												name: "interestAccumulated",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1337,
  												src: "7950:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1361,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "7950:23:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1363,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "7950:37:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "7932:55:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1365,
  								nodeType: "ExpressionStatement",
  								src: "7932:55:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1367,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "calculateBorrowDataAtBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1300,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1299,
  								name: "newBlockNumber",
  								nodeType: "VariableDeclaration",
  								scope: 1367,
  								src: "7337:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1298,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "7337:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7336:21:1"
  					},
  					returnParameters: {
  						id: 1305,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1302,
  								name: "newTotalBorrows",
  								nodeType: "VariableDeclaration",
  								scope: 1367,
  								src: "7381:20:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1301,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "7381:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1304,
  								name: "newBorrowIndex",
  								nodeType: "VariableDeclaration",
  								scope: 1367,
  								src: "7403:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1303,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "7403:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "7380:43:1"
  					},
  					scope: 1776,
  					src: "7301:693:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1436,
  						nodeType: "Block",
  						src: "8122:564:1",
  						statements: [
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1378,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1376,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1369,
  										src: "8136:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<=",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1377,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "8154:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8136:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1383,
  								nodeType: "IfStatement",
  								src: "8132:87:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1379,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "8194:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1380,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "8207:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1381,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "8193:26:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1375,
  									id: 1382,
  									nodeType: "Return",
  									src: "8186:33:1"
  								}
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1386,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1384,
  										name: "totalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 497,
  										src: "8234:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "==",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1385,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "8249:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "8234:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1391,
  								nodeType: "IfStatement",
  								src: "8230:67:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1387,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "8272:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1388,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "8285:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1389,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										nodeType: "TupleExpression",
  										src: "8271:26:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									functionReturnParameters: 1375,
  									id: 1390,
  									nodeType: "Return",
  									src: "8264:33:1"
  								}
  							},
  							{
  								assignments: [
  									1393
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1393,
  										name: "blockDelta",
  										nodeType: "VariableDeclaration",
  										scope: 1436,
  										src: "8308:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1392,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8308:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1397,
  								initialValue: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1396,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1394,
  										name: "newBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1369,
  										src: "8326:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "-",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1395,
  										name: "accrualBlockNumber",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 501,
  										src: "8343:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8326:35:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "8308:53:1"
  							},
  							{
  								assignments: [
  									1399
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1399,
  										name: "simpleInterestFactor",
  										nodeType: "VariableDeclaration",
  										scope: 1436,
  										src: "8372:25:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1398,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8372:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1405,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1403,
  											name: "blockDelta",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1393,
  											src: "8425:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  											],
  											expression: {
  												argumentTypes: [
  												],
  												id: 1400,
  												name: "supplyRatePerBlock",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 795,
  												src: "8400:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_view$__$returns$_t_uint256_$",
  													typeString: "function () view returns (uint256)"
  												}
  											},
  											id: 1401,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "8400:20:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1402,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "mul",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2110,
  										src: "8400:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1404,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "8400:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "8372:64:1"
  							},
  							{
  								assignments: [
  									1407
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1407,
  										name: "interestAccumulated",
  										nodeType: "VariableDeclaration",
  										scope: 1436,
  										src: "8446:24:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1406,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8446:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1415,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1413,
  											name: "FACTOR",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 534,
  											src: "8515:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1410,
  													name: "totalSupply",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 497,
  													src: "8498:11:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1408,
  													name: "simpleInterestFactor",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1399,
  													src: "8473:20:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 1409,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "mul",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2110,
  												src: "8473:24:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 1411,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "8473:37:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1412,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "div",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2124,
  										src: "8473:41:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1414,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "8473:49:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "8446:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1427,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1416,
  										name: "newSupplyIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1374,
  										src: "8533:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1425,
  												name: "supplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 499,
  												src: "8604:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														id: 1422,
  														name: "FACTOR",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 534,
  														src: "8592:6:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														"arguments": [
  															{
  																argumentTypes: null,
  																id: 1419,
  																name: "supplyIndex",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 499,
  																src: "8575:11:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															}
  														],
  														expression: {
  															argumentTypes: [
  																{
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															],
  															expression: {
  																argumentTypes: null,
  																id: 1417,
  																name: "simpleInterestFactor",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1399,
  																src: "8550:20:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_uint256",
  																	typeString: "uint256"
  																}
  															},
  															id: 1418,
  															isConstant: false,
  															isLValue: false,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "mul",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 2110,
  															src: "8550:24:1",
  															typeDescriptions: {
  																typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  																typeString: "function (uint256,uint256) pure returns (uint256)"
  															}
  														},
  														id: 1420,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														kind: "functionCall",
  														lValueRequested: false,
  														names: [
  														],
  														nodeType: "FunctionCall",
  														src: "8550:37:1",
  														typeDescriptions: {
  															typeIdentifier: "t_uint256",
  															typeString: "uint256"
  														}
  													},
  													id: 1421,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "div",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 2124,
  													src: "8550:41:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  														typeString: "function (uint256,uint256) pure returns (uint256)"
  													}
  												},
  												id: 1423,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "8550:49:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1424,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "8550:53:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1426,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "8550:66:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8533:83:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1428,
  								nodeType: "ExpressionStatement",
  								src: "8533:83:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1434,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1429,
  										name: "newTotalSupply",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1372,
  										src: "8626:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1432,
  												name: "totalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 497,
  												src: "8667:11:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1430,
  												name: "interestAccumulated",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1407,
  												src: "8643:19:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1431,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "8643:23:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1433,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "8643:36:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "8626:53:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1435,
  								nodeType: "ExpressionStatement",
  								src: "8626:53:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1437,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "calculateSupplyDataAtBlock",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1370,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1369,
  								name: "newBlockNumber",
  								nodeType: "VariableDeclaration",
  								scope: 1437,
  								src: "8036:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1368,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8036:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8035:21:1"
  					},
  					returnParameters: {
  						id: 1375,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1372,
  								name: "newTotalSupply",
  								nodeType: "VariableDeclaration",
  								scope: 1437,
  								src: "8080:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1371,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8080:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1374,
  								name: "newSupplyIndex",
  								nodeType: "VariableDeclaration",
  								scope: 1437,
  								src: "8101:19:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1373,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8101:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8079:42:1"
  					},
  					scope: 1776,
  					src: "8000:686:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1459,
  						nodeType: "Block",
  						src: "8753:186:1",
  						statements: [
  							{
  								assignments: [
  									1443
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1443,
  										name: "newTotalBorrows",
  										nodeType: "VariableDeclaration",
  										scope: 1459,
  										src: "8763:20:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1442,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8763:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1444,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "8763:20:1"
  							},
  							{
  								assignments: [
  									1446
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1446,
  										name: "newBorrowIndex",
  										nodeType: "VariableDeclaration",
  										scope: 1459,
  										src: "8793:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1445,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "8793:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1447,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "8793:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1455,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1448,
  												name: "newTotalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1443,
  												src: "8824:15:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1449,
  												name: "newBorrowIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1446,
  												src: "8841:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1450,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "8823:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1452,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "8886:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 1453,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "8886:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1451,
  											name: "calculateBorrowDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1367,
  											src: "8859:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1454,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "8859:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "8823:76:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1456,
  								nodeType: "ExpressionStatement",
  								src: "8823:76:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1457,
  									name: "newTotalBorrows",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 1443,
  									src: "8917:15:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1441,
  								id: 1458,
  								nodeType: "Return",
  								src: "8910:22:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1460,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getUpdatedTotalBorrows",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1438,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "8723:2:1"
  					},
  					returnParameters: {
  						id: 1441,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1440,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1460,
  								src: "8747:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1439,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8747:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8746:6:1"
  					},
  					scope: 1776,
  					src: "8692:247:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1482,
  						nodeType: "Block",
  						src: "9005:183:1",
  						statements: [
  							{
  								assignments: [
  									1466
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1466,
  										name: "newTotalSupply",
  										nodeType: "VariableDeclaration",
  										scope: 1482,
  										src: "9015:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1465,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9015:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1467,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9015:19:1"
  							},
  							{
  								assignments: [
  									1469
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1469,
  										name: "newSupplyIndex",
  										nodeType: "VariableDeclaration",
  										scope: 1482,
  										src: "9044:19:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1468,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9044:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1470,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9044:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1478,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1471,
  												name: "newTotalSupply",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1466,
  												src: "9075:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1472,
  												name: "newSupplyIndex",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1469,
  												src: "9091:14:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1473,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "9074:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1475,
  													name: "block",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2421,
  													src: "9136:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_block",
  														typeString: "block"
  													}
  												},
  												id: 1476,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "number",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9136:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1474,
  											name: "calculateSupplyDataAtBlock",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1437,
  											src: "9109:26:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_view$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (uint256) view returns (uint256,uint256)"
  											}
  										},
  										id: 1477,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9109:40:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "9074:75:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1479,
  								nodeType: "ExpressionStatement",
  								src: "9074:75:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1480,
  									name: "newTotalSupply",
  									nodeType: "Identifier",
  									overloadedDeclarations: [
  									],
  									referencedDeclaration: 1466,
  									src: "9167:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								functionReturnParameters: 1464,
  								id: 1481,
  								nodeType: "Return",
  								src: "9160:21:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1483,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "getUpdatedTotalSupply",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1461,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "8975:2:1"
  					},
  					returnParameters: {
  						id: 1464,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1463,
  								name: "",
  								nodeType: "VariableDeclaration",
  								scope: 1483,
  								src: "8999:4:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1462,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "8999:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "8998:6:1"
  					},
  					scope: 1776,
  					src: "8945:243:1",
  					stateMutability: "view",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1522,
  						nodeType: "Block",
  						src: "9233:253:1",
  						statements: [
  							{
  								assignments: [
  									1489
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1489,
  										name: "paid",
  										nodeType: "VariableDeclaration",
  										scope: 1522,
  										src: "9243:9:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1488,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9243:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1490,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9243:9:1"
  							},
  							{
  								assignments: [
  									1492
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1492,
  										name: "additional",
  										nodeType: "VariableDeclaration",
  										scope: 1522,
  										src: "9262:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1491,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9262:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1493,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9262:15:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1504,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1494,
  												name: "paid",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1489,
  												src: "9289:4:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1495,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1492,
  												src: "9295:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1496,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "9288:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1498,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "9327:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1499,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9327:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1500,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "9339:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1501,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9339:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1502,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1485,
  												src: "9351:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1497,
  											name: "payBorrowInternal",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1649,
  											src: "9309:17:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address,address,uint256) returns (uint256,uint256)"
  											}
  										},
  										id: 1503,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9309:49:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "9288:70:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1505,
  								nodeType: "ExpressionStatement",
  								src: "9288:70:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1507,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "9384:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1508,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "9384:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1509,
  											name: "paid",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1489,
  											src: "9396:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1506,
  										name: "PayBorrow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 558,
  										src: "9374:9:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256)"
  										}
  									},
  									id: 1510,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9374:27:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1511,
  								nodeType: "EmitStatement",
  								src: "9369:32:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1514,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1512,
  										name: "additional",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1492,
  										src: "9416:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1513,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "9429:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "9416:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1521,
  								nodeType: "IfStatement",
  								src: "9412:67:1",
  								trueBody: {
  									eventCall: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1516,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "9456:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1517,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "9456:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1518,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1492,
  												src: "9468:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1515,
  											name: "Supply",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 540,
  											src: "9449:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  												typeString: "function (address,uint256)"
  											}
  										},
  										id: 1519,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9449:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 1520,
  									nodeType: "EmitStatement",
  									src: "9444:35:1"
  								}
  							}
  						]
  					},
  					documentation: null,
  					id: 1523,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "payBorrow",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1486,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1485,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1523,
  								src: "9213:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1484,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9213:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "9212:13:1"
  					},
  					returnParameters: {
  						id: 1487,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "9233:0:1"
  					},
  					scope: 1776,
  					src: "9194:292:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1648,
  						nodeType: "Block",
  						src: "9609:852:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1536,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "9619:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1537,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9619:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1538,
  								nodeType: "ExpressionStatement",
  								src: "9619:16:1"
  							},
  							{
  								assignments: [
  									1540
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1540,
  										name: "snapshot",
  										nodeType: "VariableDeclaration",
  										scope: 1648,
  										src: "9646:31:1",
  										stateVariable: false,
  										storageLocation: "storage",
  										typeDescriptions: {
  											typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  											typeString: "struct Market.BorrowSnapshot"
  										},
  										typeName: {
  											contractScope: null,
  											id: 1539,
  											name: "BorrowSnapshot",
  											nodeType: "UserDefinedTypeName",
  											referencedDeclaration: 523,
  											src: "9646:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1544,
  								initialValue: {
  									argumentTypes: null,
  									baseExpression: {
  										argumentTypes: null,
  										id: 1541,
  										name: "borrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 531,
  										src: "9680:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_mapping$_t_address_$_t_struct$_BorrowSnapshot_$523_storage_$",
  											typeString: "mapping(address => struct Market.BorrowSnapshot storage ref)"
  										}
  									},
  									id: 1543,
  									indexExpression: {
  										argumentTypes: null,
  										id: 1542,
  										name: "borrower",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1527,
  										src: "9688:8:1",
  										typeDescriptions: {
  											typeIdentifier: "t_address",
  											typeString: "address"
  										}
  									},
  									isConstant: false,
  									isLValue: true,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "IndexAccess",
  									src: "9680:17:1",
  									typeDescriptions: {
  										typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage",
  										typeString: "struct Market.BorrowSnapshot storage ref"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9646:51:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1549,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1546,
  													name: "snapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1540,
  													src: "9716:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1547,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "9716:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 1548,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "9737:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "9716:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1545,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "9708:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1550,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9708:31:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1551,
  								nodeType: "ExpressionStatement",
  								src: "9708:31:1"
  							},
  							{
  								assignments: [
  									1553
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1553,
  										name: "interest",
  										nodeType: "VariableDeclaration",
  										scope: 1648,
  										src: "9750:13:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1552,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9750:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1567,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1564,
  												name: "snapshot",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1540,
  												src: "9834:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  													typeString: "struct Market.BorrowSnapshot storage pointer"
  												}
  											},
  											id: 1565,
  											isConstant: false,
  											isLValue: true,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "principal",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 520,
  											src: "9834:18:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1560,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1540,
  														src: "9806:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1561,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "interestIndex",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 522,
  													src: "9806:22:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 1557,
  															name: "borrowIndex",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 503,
  															src: "9789:11:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															expression: {
  																argumentTypes: null,
  																id: 1554,
  																name: "snapshot",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1540,
  																src: "9766:8:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																	typeString: "struct Market.BorrowSnapshot storage pointer"
  																}
  															},
  															id: 1555,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "principal",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 520,
  															src: "9766:18:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1556,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "mul",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2110,
  														src: "9766:22:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1558,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "9766:35:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												id: 1559,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "div",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 2124,
  												src: "9766:39:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  													typeString: "function (uint256,uint256) pure returns (uint256)"
  												}
  											},
  											id: 1562,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "9766:63:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										id: 1563,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "sub",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 2144,
  										src: "9766:67:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  											typeString: "function (uint256,uint256) pure returns (uint256)"
  										}
  									},
  									id: 1566,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "9766:87:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "9750:103:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1576,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1568,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "9864:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1570,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "9864:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1574,
  												name: "interest",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1553,
  												src: "9908:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1571,
  													name: "snapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1540,
  													src: "9885:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1572,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "9885:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1573,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "add",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2168,
  											src: "9885:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1575,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "9885:32:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "9864:53:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1577,
  								nodeType: "ExpressionStatement",
  								src: "9864:53:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1582,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1578,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "9927:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1580,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "interestIndex",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 522,
  										src: "9927:22:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 1581,
  										name: "borrowIndex",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 503,
  										src: "9952:11:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "9927:36:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1583,
  								nodeType: "ExpressionStatement",
  								src: "9927:36:1"
  							},
  							{
  								assignments: [
  									1585
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1585,
  										name: "additional",
  										nodeType: "VariableDeclaration",
  										scope: 1648,
  										src: "9974:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1584,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "9974:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1586,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "9974:15:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1590,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1587,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "10004:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1588,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "10004:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: "<",
  									rightExpression: {
  										argumentTypes: null,
  										id: 1589,
  										name: "amount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1529,
  										src: "10025:6:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "10004:27:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1605,
  								nodeType: "IfStatement",
  								src: "10000:142:1",
  								trueBody: {
  									id: 1604,
  									nodeType: "Block",
  									src: "10033:109:1",
  									statements: [
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1597,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 1591,
  													name: "additional",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1585,
  													src: "10047:10:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															expression: {
  																argumentTypes: null,
  																id: 1594,
  																name: "snapshot",
  																nodeType: "Identifier",
  																overloadedDeclarations: [
  																],
  																referencedDeclaration: 1540,
  																src: "10071:8:1",
  																typeDescriptions: {
  																	typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  																	typeString: "struct Market.BorrowSnapshot storage pointer"
  																}
  															},
  															id: 1595,
  															isConstant: false,
  															isLValue: true,
  															isPure: false,
  															lValueRequested: false,
  															memberName: "principal",
  															nodeType: "MemberAccess",
  															referencedDeclaration: 520,
  															src: "10071:18:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														],
  														expression: {
  															argumentTypes: null,
  															id: 1592,
  															name: "amount",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 1529,
  															src: "10060:6:1",
  															typeDescriptions: {
  																typeIdentifier: "t_uint256",
  																typeString: "uint256"
  															}
  														},
  														id: 1593,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sub",
  														nodeType: "MemberAccess",
  														referencedDeclaration: 2144,
  														src: "10060:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  															typeString: "function (uint256,uint256) pure returns (uint256)"
  														}
  													},
  													id: 1596,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "functionCall",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "10060:30:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "10047:43:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1598,
  											nodeType: "ExpressionStatement",
  											src: "10047:43:1"
  										},
  										{
  											expression: {
  												argumentTypes: null,
  												id: 1602,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												leftHandSide: {
  													argumentTypes: null,
  													id: 1599,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1529,
  													src: "10104:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												nodeType: "Assignment",
  												operator: "=",
  												rightHandSide: {
  													argumentTypes: null,
  													expression: {
  														argumentTypes: null,
  														id: 1600,
  														name: "snapshot",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 1540,
  														src: "10113:8:1",
  														typeDescriptions: {
  															typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  															typeString: "struct Market.BorrowSnapshot storage pointer"
  														}
  													},
  													id: 1601,
  													isConstant: false,
  													isLValue: true,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "principal",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 520,
  													src: "10113:18:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												},
  												src: "10104:27:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1603,
  											nodeType: "ExpressionStatement",
  											src: "10104:27:1"
  										}
  									]
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1609,
  													name: "payer",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1525,
  													src: "10179:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													"arguments": [
  														{
  															argumentTypes: null,
  															id: 1611,
  															name: "this",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2455,
  															src: "10194:4:1",
  															typeDescriptions: {
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														}
  													],
  													expression: {
  														argumentTypes: [
  															{
  																typeIdentifier: "t_contract$_Market_$1776",
  																typeString: "contract Market"
  															}
  														],
  														id: 1610,
  														isConstant: false,
  														isLValue: false,
  														isPure: true,
  														lValueRequested: false,
  														nodeType: "ElementaryTypeNameExpression",
  														src: "10186:7:1",
  														typeDescriptions: {
  															typeIdentifier: "t_type$_t_address_$",
  															typeString: "type(address)"
  														},
  														typeName: "address"
  													},
  													id: 1612,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													kind: "typeConversion",
  													lValueRequested: false,
  													names: [
  													],
  													nodeType: "FunctionCall",
  													src: "10186:13:1",
  													typeDescriptions: {
  														typeIdentifier: "t_address",
  														typeString: "address"
  													}
  												},
  												{
  													argumentTypes: null,
  													id: 1613,
  													name: "amount",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1529,
  													src: "10201:6:1",
  													typeDescriptions: {
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_address",
  														typeString: "address"
  													},
  													{
  														typeIdentifier: "t_uint256",
  														typeString: "uint256"
  													}
  												],
  												expression: {
  													argumentTypes: null,
  													id: 1607,
  													name: "token",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 493,
  													src: "10160:5:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_ERC20_$1970",
  														typeString: "contract ERC20"
  													}
  												},
  												id: 1608,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "transferFrom",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 1952,
  												src: "10160:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_bool_$",
  													typeString: "function (address,address,uint256) external returns (bool)"
  												}
  											},
  											id: 1614,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "functionCall",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "10160:48:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										},
  										{
  											argumentTypes: null,
  											hexValue: "4e6f20656e6f75676820746f6b656e73",
  											id: 1615,
  											isConstant: false,
  											isLValue: false,
  											isPure: true,
  											kind: "string",
  											lValueRequested: false,
  											nodeType: "Literal",
  											src: "10210:18:1",
  											subdenomination: null,
  											typeDescriptions: {
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											},
  											value: "No enough tokens"
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											},
  											{
  												typeIdentifier: "t_stringliteral_48f25b17f96194c777c910cff04667bad048b313a152be93f39d26727f7beee1",
  												typeString: "literal_string \"No enough tokens\""
  											}
  										],
  										id: 1606,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2435,
  										src: "10152:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
  											typeString: "function (bool,string memory) pure"
  										}
  									},
  									id: 1616,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10152:77:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1617,
  								nodeType: "ExpressionStatement",
  								src: "10152:77:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1626,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										expression: {
  											argumentTypes: null,
  											id: 1618,
  											name: "snapshot",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1540,
  											src: "10240:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  												typeString: "struct Market.BorrowSnapshot storage pointer"
  											}
  										},
  										id: 1620,
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										memberName: "principal",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 520,
  										src: "10240:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1624,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1529,
  												src: "10284:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1621,
  													name: "snapshot",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1540,
  													src: "10261:8:1",
  													typeDescriptions: {
  														typeIdentifier: "t_struct$_BorrowSnapshot_$523_storage_ptr",
  														typeString: "struct Market.BorrowSnapshot storage pointer"
  													}
  												},
  												id: 1622,
  												isConstant: false,
  												isLValue: true,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "principal",
  												nodeType: "MemberAccess",
  												referencedDeclaration: 520,
  												src: "10261:18:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1623,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "10261:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1625,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "10261:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "10240:51:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1627,
  								nodeType: "ExpressionStatement",
  								src: "10240:51:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1633,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 1628,
  										name: "totalBorrows",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 505,
  										src: "10301:12:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1631,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1529,
  												src: "10333:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											expression: {
  												argumentTypes: null,
  												id: 1629,
  												name: "totalBorrows",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 505,
  												src: "10316:12:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											id: 1630,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sub",
  											nodeType: "MemberAccess",
  											referencedDeclaration: 2144,
  											src: "10316:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
  												typeString: "function (uint256,uint256) pure returns (uint256)"
  											}
  										},
  										id: 1632,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "10316:24:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "10301:39:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 1634,
  								nodeType: "ExpressionStatement",
  								src: "10301:39:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1637,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1635,
  										name: "additional",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1585,
  										src: "10355:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1636,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "10368:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "10355:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1643,
  								nodeType: "IfStatement",
  								src: "10351:65:1",
  								trueBody: {
  									expression: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												id: 1639,
  												name: "payer",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1525,
  												src: "10398:5:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1640,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1585,
  												src: "10405:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1638,
  											name: "supplyInternal",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1007,
  											src: "10383:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_uint256_$returns$__$",
  												typeString: "function (address,uint256)"
  											}
  										},
  										id: 1641,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "10383:33:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 1642,
  									nodeType: "ExpressionStatement",
  									src: "10383:33:1"
  								}
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									components: [
  										{
  											argumentTypes: null,
  											id: 1644,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1529,
  											src: "10435:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1645,
  											name: "additional",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1585,
  											src: "10443:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									id: 1646,
  									isConstant: false,
  									isInlineArray: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									nodeType: "TupleExpression",
  									src: "10434:20:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  										typeString: "tuple(uint256,uint256)"
  									}
  								},
  								functionReturnParameters: 1535,
  								id: 1647,
  								nodeType: "Return",
  								src: "10427:27:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1649,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "payBorrowInternal",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1530,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1525,
  								name: "payer",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9519:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1524,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "9519:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1527,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9534:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1526,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "9534:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1529,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9552:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1528,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9552:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "9518:46:1"
  					},
  					returnParameters: {
  						id: 1535,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1532,
  								name: "paid",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9583:9:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1531,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9583:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1534,
  								name: "supplied",
  								nodeType: "VariableDeclaration",
  								scope: 1649,
  								src: "9594:13:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1533,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "9594:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "9582:26:1"
  					},
  					scope: 1776,
  					src: "9492:969:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "internal"
  				},
  				{
  					body: {
  						id: 1750,
  						nodeType: "Block",
  						src: "10564:704:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1661,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1659,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "10582:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 1660,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "10591:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "10582:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1658,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10574:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1662,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10574:19:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1663,
  								nodeType: "ExpressionStatement",
  								src: "10574:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											id: 1668,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1665,
  												name: "borrower",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1651,
  												src: "10611:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: "!=",
  											rightExpression: {
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1666,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "10623:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1667,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "10623:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											src: "10611:22:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1664,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10603:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1669,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10603:31:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1670,
  								nodeType: "ExpressionStatement",
  								src: "10603:31:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										id: 1671,
  										name: "accrueInterest",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1297,
  										src: "10645:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$__$returns$__$",
  											typeString: "function ()"
  										}
  									},
  									id: 1672,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10645:16:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1673,
  								nodeType: "ExpressionStatement",
  								src: "10645:16:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  									],
  									expression: {
  										argumentTypes: [
  										],
  										expression: {
  											argumentTypes: null,
  											id: 1674,
  											name: "collateralMarket",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1655,
  											src: "10671:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										},
  										id: 1676,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "accrueInterest",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 1814,
  										src: "10671:31:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_nonpayable$__$returns$__$",
  											typeString: "function () external"
  										}
  									},
  									id: 1677,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10671:33:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1678,
  								nodeType: "ExpressionStatement",
  								src: "10671:33:1"
  							},
  							{
  								assignments: [
  									1680
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1680,
  										name: "debt",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10715:9:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1679,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10715:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1684,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1682,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1651,
  											src: "10743:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										],
  										id: 1681,
  										name: "updatedBorrowBy",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 867,
  										src: "10727:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_view$_t_address_$returns$_t_uint256_$",
  											typeString: "function (address) view returns (uint256)"
  										}
  									},
  									id: 1683,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10727:25:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10715:37:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1688,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1686,
  												name: "debt",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1680,
  												src: "10771:4:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1687,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "10779:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "10771:14:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1685,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10763:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1689,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10763:23:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1690,
  								nodeType: "ExpressionStatement",
  								src: "10763:23:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1698,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												"arguments": [
  													{
  														argumentTypes: null,
  														expression: {
  															argumentTypes: null,
  															id: 1694,
  															name: "msg",
  															nodeType: "Identifier",
  															overloadedDeclarations: [
  															],
  															referencedDeclaration: 2431,
  															src: "10820:3:1",
  															typeDescriptions: {
  																typeIdentifier: "t_magic_message",
  																typeString: "msg"
  															}
  														},
  														id: 1695,
  														isConstant: false,
  														isLValue: false,
  														isPure: false,
  														lValueRequested: false,
  														memberName: "sender",
  														nodeType: "MemberAccess",
  														referencedDeclaration: null,
  														src: "10820:10:1",
  														typeDescriptions: {
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													}
  												],
  												expression: {
  													argumentTypes: [
  														{
  															typeIdentifier: "t_address_payable",
  															typeString: "address payable"
  														}
  													],
  													expression: {
  														argumentTypes: null,
  														id: 1692,
  														name: "token",
  														nodeType: "Identifier",
  														overloadedDeclarations: [
  														],
  														referencedDeclaration: 493,
  														src: "10804:5:1",
  														typeDescriptions: {
  															typeIdentifier: "t_contract$_ERC20_$1970",
  															typeString: "contract ERC20"
  														}
  													},
  													id: 1693,
  													isConstant: false,
  													isLValue: false,
  													isPure: false,
  													lValueRequested: false,
  													memberName: "balanceOf",
  													nodeType: "MemberAccess",
  													referencedDeclaration: 1984,
  													src: "10804:15:1",
  													typeDescriptions: {
  														typeIdentifier: "t_function_external_view$_t_address_$returns$_t_uint256_$",
  														typeString: "function (address) view external returns (uint256)"
  													}
  												},
  												id: 1696,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												kind: "functionCall",
  												lValueRequested: false,
  												names: [
  												],
  												nodeType: "FunctionCall",
  												src: "10804:27:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">=",
  											rightExpression: {
  												argumentTypes: null,
  												id: 1697,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "10835:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											src: "10804:37:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1691,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "10796:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1699,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10796:46:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1700,
  								nodeType: "ExpressionStatement",
  								src: "10796:46:1"
  							},
  							{
  								assignments: [
  									1702
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1702,
  										name: "collateralAmount",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10853:21:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1701,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10853:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1711,
  								initialValue: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1705,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1651,
  											src: "10908:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1706,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "10918:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1707,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "10918:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1708,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1653,
  											src: "10930:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1709,
  											name: "collateralMarket",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1655,
  											src: "10938:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_contract$_MarketInterface_$1824",
  												typeString: "contract MarketInterface"
  											}
  										],
  										expression: {
  											argumentTypes: null,
  											id: 1703,
  											name: "controller",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 495,
  											src: "10877:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_contract$_Controller_$479",
  												typeString: "contract Controller"
  											}
  										},
  										id: 1704,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										lValueRequested: false,
  										memberName: "liquidateCollateral",
  										nodeType: "MemberAccess",
  										referencedDeclaration: 478,
  										src: "10877:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_external_nonpayable$_t_address_$_t_address_$_t_uint256_$_t_contract$_MarketInterface_$1824_$returns$_t_uint256_$",
  											typeString: "function (address,address,uint256,contract MarketInterface) external returns (uint256)"
  										}
  									},
  									id: 1710,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "10877:78:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								nodeType: "VariableDeclarationStatement",
  								src: "10853:102:1"
  							},
  							{
  								assignments: [
  									1713
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1713,
  										name: "paid",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10966:9:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1712,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10966:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1714,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "10966:9:1"
  							},
  							{
  								assignments: [
  									1716
  								],
  								declarations: [
  									{
  										constant: false,
  										id: 1716,
  										name: "additional",
  										nodeType: "VariableDeclaration",
  										scope: 1750,
  										src: "10985:15:1",
  										stateVariable: false,
  										storageLocation: "default",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										},
  										typeName: {
  											id: 1715,
  											name: "uint",
  											nodeType: "ElementaryTypeName",
  											src: "10985:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										value: null,
  										visibility: "internal"
  									}
  								],
  								id: 1717,
  								initialValue: null,
  								nodeType: "VariableDeclarationStatement",
  								src: "10985:15:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 1727,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										components: [
  											{
  												argumentTypes: null,
  												id: 1718,
  												name: "paid",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1713,
  												src: "11012:4:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1719,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1716,
  												src: "11018:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										id: 1720,
  										isConstant: false,
  										isInlineArray: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "TupleExpression",
  										src: "11011:18:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1722,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "11050:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1723,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "11050:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1724,
  												name: "borrower",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1651,
  												src: "11062:8:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address",
  													typeString: "address"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1725,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1653,
  												src: "11072:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_address",
  													typeString: "address"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1721,
  											name: "payBorrowInternal",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1649,
  											src: "11032:17:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$_t_uint256_$_t_uint256_$",
  												typeString: "function (address,address,uint256) returns (uint256,uint256)"
  											}
  										},
  										id: 1726,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "11032:47:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$_t_uint256_$_t_uint256_$",
  											typeString: "tuple(uint256,uint256)"
  										}
  									},
  									src: "11011:68:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1728,
  								nodeType: "ExpressionStatement",
  								src: "11011:68:1"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1730,
  											name: "borrower",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1651,
  											src: "11111:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1731,
  											name: "paid",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1713,
  											src: "11121:4:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										},
  										{
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 1732,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2431,
  												src: "11127:3:1",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 1733,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "11127:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 1735,
  													name: "collateralMarket",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 1655,
  													src: "11147:16:1",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_MarketInterface_$1824",
  														typeString: "contract MarketInterface"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_MarketInterface_$1824",
  														typeString: "contract MarketInterface"
  													}
  												],
  												id: 1734,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "11139:7:1",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 1736,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "11139:25:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1737,
  											name: "collateralAmount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1702,
  											src: "11166:16:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											{
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1729,
  										name: "LiquidateBorrow",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 570,
  										src: "11095:15:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,uint256,address,address,uint256)"
  										}
  									},
  									id: 1738,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "11095:88:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1739,
  								nodeType: "EmitStatement",
  								src: "11090:93:1"
  							},
  							{
  								condition: {
  									argumentTypes: null,
  									commonType: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									},
  									id: 1742,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftExpression: {
  										argumentTypes: null,
  										id: 1740,
  										name: "additional",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1716,
  										src: "11198:10:1",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "BinaryOperation",
  									operator: ">",
  									rightExpression: {
  										argumentTypes: null,
  										hexValue: "30",
  										id: 1741,
  										isConstant: false,
  										isLValue: false,
  										isPure: true,
  										kind: "number",
  										lValueRequested: false,
  										nodeType: "Literal",
  										src: "11211:1:1",
  										subdenomination: null,
  										typeDescriptions: {
  											typeIdentifier: "t_rational_0_by_1",
  											typeString: "int_const 0"
  										},
  										value: "0"
  									},
  									src: "11198:14:1",
  									typeDescriptions: {
  										typeIdentifier: "t_bool",
  										typeString: "bool"
  									}
  								},
  								falseBody: null,
  								id: 1749,
  								nodeType: "IfStatement",
  								src: "11194:67:1",
  								trueBody: {
  									eventCall: {
  										argumentTypes: null,
  										"arguments": [
  											{
  												argumentTypes: null,
  												expression: {
  													argumentTypes: null,
  													id: 1744,
  													name: "msg",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2431,
  													src: "11238:3:1",
  													typeDescriptions: {
  														typeIdentifier: "t_magic_message",
  														typeString: "msg"
  													}
  												},
  												id: 1745,
  												isConstant: false,
  												isLValue: false,
  												isPure: false,
  												lValueRequested: false,
  												memberName: "sender",
  												nodeType: "MemberAccess",
  												referencedDeclaration: null,
  												src: "11238:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												}
  											},
  											{
  												argumentTypes: null,
  												id: 1746,
  												name: "additional",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1716,
  												src: "11250:10:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											}
  										],
  										expression: {
  											argumentTypes: [
  												{
  													typeIdentifier: "t_address_payable",
  													typeString: "address payable"
  												},
  												{
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											],
  											id: 1743,
  											name: "Supply",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 540,
  											src: "11231:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_uint256_$returns$__$",
  												typeString: "function (address,uint256)"
  											}
  										},
  										id: 1747,
  										isConstant: false,
  										isLValue: false,
  										isPure: false,
  										kind: "functionCall",
  										lValueRequested: false,
  										names: [
  										],
  										nodeType: "FunctionCall",
  										src: "11231:30:1",
  										typeDescriptions: {
  											typeIdentifier: "t_tuple$__$",
  											typeString: "tuple()"
  										}
  									},
  									id: 1748,
  									nodeType: "EmitStatement",
  									src: "11226:35:1"
  								}
  							}
  						]
  					},
  					documentation: null,
  					id: 1751,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "liquidateBorrow",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1656,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1651,
  								name: "borrower",
  								nodeType: "VariableDeclaration",
  								scope: 1751,
  								src: "10492:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1650,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "10492:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1653,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1751,
  								src: "10510:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1652,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "10510:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1655,
  								name: "collateralMarket",
  								nodeType: "VariableDeclaration",
  								scope: 1751,
  								src: "10523:32:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_contract$_MarketInterface_$1824",
  									typeString: "contract MarketInterface"
  								},
  								typeName: {
  									contractScope: null,
  									id: 1654,
  									name: "MarketInterface",
  									nodeType: "UserDefinedTypeName",
  									referencedDeclaration: 1824,
  									src: "10523:15:1",
  									typeDescriptions: {
  										typeIdentifier: "t_contract$_MarketInterface_$1824",
  										typeString: "contract MarketInterface"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "10491:65:1"
  					},
  					returnParameters: {
  						id: 1657,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "10564:0:1"
  					},
  					scope: 1776,
  					src: "10467:801:1",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 1774,
  						nodeType: "Block",
  						src: "11363:86:1",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											commonType: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											},
  											id: 1765,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											leftExpression: {
  												argumentTypes: null,
  												id: 1763,
  												name: "amount",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 1757,
  												src: "11381:6:1",
  												typeDescriptions: {
  													typeIdentifier: "t_uint256",
  													typeString: "uint256"
  												}
  											},
  											nodeType: "BinaryOperation",
  											operator: ">",
  											rightExpression: {
  												argumentTypes: null,
  												hexValue: "30",
  												id: 1764,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												kind: "number",
  												lValueRequested: false,
  												nodeType: "Literal",
  												src: "11390:1:1",
  												subdenomination: null,
  												typeDescriptions: {
  													typeIdentifier: "t_rational_0_by_1",
  													typeString: "int_const 0"
  												},
  												value: "0"
  											},
  											src: "11381:10:1",
  											typeDescriptions: {
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_bool",
  												typeString: "bool"
  											}
  										],
  										id: 1762,
  										name: "require",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  											2434,
  											2435
  										],
  										referencedDeclaration: 2434,
  										src: "11373:7:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_require_pure$_t_bool_$returns$__$",
  											typeString: "function (bool) pure"
  										}
  									},
  									id: 1766,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "11373:19:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1767,
  								nodeType: "ExpressionStatement",
  								src: "11373:19:1"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											id: 1769,
  											name: "sender",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1753,
  											src: "11417:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1770,
  											name: "receiver",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1755,
  											src: "11425:8:1",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 1771,
  											name: "amount",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1757,
  											src: "11435:6:1",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 1768,
  										name: "redeemInternal",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1142,
  										src: "11402:14:1",
  										typeDescriptions: {
  											typeIdentifier: "t_function_internal_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 1772,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "11402:40:1",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 1773,
  								nodeType: "ExpressionStatement",
  								src: "11402:40:1"
  							}
  						]
  					},
  					documentation: null,
  					id: 1775,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  						{
  							"arguments": null,
  							id: 1760,
  							modifierName: {
  								argumentTypes: null,
  								id: 1759,
  								name: "onlyController",
  								nodeType: "Identifier",
  								overloadedDeclarations: [
  								],
  								referencedDeclaration: 661,
  								src: "11348:14:1",
  								typeDescriptions: {
  									typeIdentifier: "t_modifier$__$",
  									typeString: "modifier ()"
  								}
  							},
  							nodeType: "ModifierInvocation",
  							src: "11348:14:1"
  						}
  					],
  					name: "transferTo",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 1758,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 1753,
  								name: "sender",
  								nodeType: "VariableDeclaration",
  								scope: 1775,
  								src: "11294:14:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1752,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "11294:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1755,
  								name: "receiver",
  								nodeType: "VariableDeclaration",
  								scope: 1775,
  								src: "11310:16:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 1754,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "11310:7:1",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 1757,
  								name: "amount",
  								nodeType: "VariableDeclaration",
  								scope: 1775,
  								src: "11328:11:1",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 1756,
  									name: "uint",
  									nodeType: "ElementaryTypeName",
  									src: "11328:4:1",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "11293:47:1"
  					},
  					returnParameters: {
  						id: 1761,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "11363:0:1"
  					},
  					scope: 1776,
  					src: "11274:175:1",
  					stateMutability: "nonpayable",
  					superFunction: 1823,
  					visibility: "public"
  				}
  			],
  			scope: 1777,
  			src: "118:11333:1"
  		}
  	],
  	src: "0:11453:1"
  };
  var compiler = {
  	name: "solc",
  	version: "0.5.16+commit.9c3226ce.Emscripten.clang"
  };
  var networks = {
  };
  var schemaVersion = "3.2.4";
  var updatedAt = "2020-09-24T14:12:15.617Z";
  var devdoc = {
  	methods: {
  	}
  };
  var userdoc = {
  	methods: {
  	}
  };
  var MarketContract = {
  	contractName: contractName,
  	abi: abi,
  	metadata: metadata,
  	bytecode: bytecode,
  	deployedBytecode: deployedBytecode,
  	sourceMap: sourceMap,
  	deployedSourceMap: deployedSourceMap,
  	source: source,
  	sourcePath: sourcePath,
  	ast: ast,
  	legacyAST: legacyAST,
  	compiler: compiler,
  	networks: networks,
  	schemaVersion: schemaVersion,
  	updatedAt: updatedAt,
  	devdoc: devdoc,
  	userdoc: userdoc
  };

  var contractName$1 = "FaucetToken";
  var abi$1 = [
  	{
  		inputs: [
  			{
  				internalType: "uint256",
  				name: "_initialAmount",
  				type: "uint256"
  			},
  			{
  				internalType: "string",
  				name: "_tokenName",
  				type: "string"
  			},
  			{
  				internalType: "uint8",
  				name: "_decimalUnits",
  				type: "uint8"
  			},
  			{
  				internalType: "string",
  				name: "_tokenSymbol",
  				type: "string"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "constructor"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "owner",
  				type: "address"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "spender",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			}
  		],
  		name: "Approval",
  		type: "event"
  	},
  	{
  		anonymous: false,
  		inputs: [
  			{
  				indexed: true,
  				internalType: "address",
  				name: "from",
  				type: "address"
  			},
  			{
  				indexed: true,
  				internalType: "address",
  				name: "to",
  				type: "address"
  			},
  			{
  				indexed: false,
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			}
  		],
  		name: "Transfer",
  		type: "event"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_owner",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "_spender",
  				type: "address"
  			}
  		],
  		name: "allowance",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_spender",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_value",
  				type: "uint256"
  			}
  		],
  		name: "approve",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_owner",
  				type: "address"
  			}
  		],
  		name: "balanceOf",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "decimals",
  		outputs: [
  			{
  				internalType: "uint8",
  				name: "",
  				type: "uint8"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_spender",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_subtractedValue",
  				type: "uint256"
  			}
  		],
  		name: "decreaseApproval",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_spender",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_addedValue",
  				type: "uint256"
  			}
  		],
  		name: "increaseApproval",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "name",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "symbol",
  		outputs: [
  			{
  				internalType: "string",
  				name: "",
  				type: "string"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: true,
  		inputs: [
  		],
  		name: "totalSupply",
  		outputs: [
  			{
  				internalType: "uint256",
  				name: "",
  				type: "uint256"
  			}
  		],
  		payable: false,
  		stateMutability: "view",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_value",
  				type: "uint256"
  			}
  		],
  		name: "transfer",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_from",
  				type: "address"
  			},
  			{
  				internalType: "address",
  				name: "_to",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "_value",
  				type: "uint256"
  			}
  		],
  		name: "transferFrom",
  		outputs: [
  			{
  				internalType: "bool",
  				name: "",
  				type: "bool"
  			}
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	},
  	{
  		constant: false,
  		inputs: [
  			{
  				internalType: "address",
  				name: "_owner",
  				type: "address"
  			},
  			{
  				internalType: "uint256",
  				name: "value",
  				type: "uint256"
  			}
  		],
  		name: "allocateTo",
  		outputs: [
  		],
  		payable: false,
  		stateMutability: "nonpayable",
  		type: "function"
  	}
  ];
  var metadata$1 = "{\"compiler\":{\"version\":\"0.5.16+commit.9c3226ce\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_initialAmount\",\"type\":\"uint256\"},{\"internalType\":\"string\",\"name\":\"_tokenName\",\"type\":\"string\"},{\"internalType\":\"uint8\",\"name\":\"_decimalUnits\",\"type\":\"uint8\"},{\"internalType\":\"string\",\"name\":\"_tokenSymbol\",\"type\":\"string\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"owner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"spender\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"value\",\"type\":\"uint256\"}],\"name\":\"Approval\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"from\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"to\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"value\",\"type\":\"uint256\"}],\"name\":\"Transfer\",\"type\":\"event\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_owner\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"value\",\"type\":\"uint256\"}],\"name\":\"allocateTo\",\"outputs\":[],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_owner\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_spender\",\"type\":\"address\"}],\"name\":\"allowance\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_spender\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_value\",\"type\":\"uint256\"}],\"name\":\"approve\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_owner\",\"type\":\"address\"}],\"name\":\"balanceOf\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"decimals\",\"outputs\":[{\"internalType\":\"uint8\",\"name\":\"\",\"type\":\"uint8\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_spender\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_subtractedValue\",\"type\":\"uint256\"}],\"name\":\"decreaseApproval\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_spender\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_addedValue\",\"type\":\"uint256\"}],\"name\":\"increaseApproval\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"name\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"symbol\",\"outputs\":[{\"internalType\":\"string\",\"name\":\"\",\"type\":\"string\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":true,\"inputs\":[],\"name\":\"totalSupply\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"payable\":false,\"stateMutability\":\"view\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_value\",\"type\":\"uint256\"}],\"name\":\"transfer\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"constant\":false,\"inputs\":[{\"internalType\":\"address\",\"name\":\"_from\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_value\",\"type\":\"uint256\"}],\"name\":\"transferFrom\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"\",\"type\":\"bool\"}],\"payable\":false,\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"devdoc\":{\"author\":\"Compound\",\"methods\":{\"allocateTo(address,uint256)\":{\"details\":\"Arbitrarily adds tokens to any account\"},\"allowance(address,address)\":{\"details\":\"Function to check the amount of tokens that an owner allowed to a spender.\",\"params\":{\"_owner\":\"address The address which owns the funds.\",\"_spender\":\"address The address which will spend the funds.\"},\"return\":\"A uint256 specifying the amount of tokens still available for the spender.\"},\"approve(address,uint256)\":{\"details\":\"Approve the passed address to spend the specified amount of tokens on behalf of msg.sender. Beware that changing an allowance with this method brings the risk that someone may use both the old and the new allowance by unfortunate transaction ordering. One possible solution to mitigate this race condition is to first reduce the spender's allowance to 0 and set the desired value afterwards: https://github.com/ethereum/EIPs/issues/20#issuecomment-263524729\",\"params\":{\"_spender\":\"The address which will spend the funds.\",\"_value\":\"The amount of tokens to be spent.\"}},\"balanceOf(address)\":{\"details\":\"Gets the balance of the specified address.\",\"params\":{\"_owner\":\"The address to query the the balance of.\"},\"return\":\"An uint256 representing the amount owned by the passed address.\"},\"decreaseApproval(address,uint256)\":{\"details\":\"Decrease the amount of tokens that an owner allowed to a spender. approve should be called when allowed[_spender] == 0. To decrement allowed value is better to use this function to avoid 2 calls (and wait until the first transaction is mined) From MonolithDAO Token.sol\",\"params\":{\"_spender\":\"The address which will spend the funds.\",\"_subtractedValue\":\"The amount of tokens to decrease the allowance by.\"}},\"increaseApproval(address,uint256)\":{\"details\":\"Increase the amount of tokens that an owner allowed to a spender. approve should be called when allowed[_spender] == 0. To increment allowed value is better to use this function to avoid 2 calls (and wait until the first transaction is mined) From MonolithDAO Token.sol\",\"params\":{\"_addedValue\":\"The amount of tokens to increase the allowance by.\",\"_spender\":\"The address which will spend the funds.\"}},\"totalSupply()\":{\"details\":\"Total number of tokens in existence\"},\"transfer(address,uint256)\":{\"details\":\"Transfer token for a specified address\",\"params\":{\"_to\":\"The address to transfer to.\",\"_value\":\"The amount to be transferred.\"}},\"transferFrom(address,address,uint256)\":{\"details\":\"Transfer tokens from one address to another\",\"params\":{\"_from\":\"address The address which you want to send tokens from\",\"_to\":\"address The address which you want to transfer to\",\"_value\":\"uint256 the amount of tokens to be transferred\"}}},\"title\":\"The Compound Faucet Test Token\"},\"userdoc\":{\"methods\":{},\"notice\":\"A simple test token that lets anyone get more of it.\"}},\"settings\":{\"compilationTarget\":{\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/FaucetToken.sol\":\"FaucetToken\"},\"evmVersion\":\"istanbul\",\"libraries\":{},\"optimizer\":{\"enabled\":false,\"runs\":200},\"remappings\":[]},\"sources\":{\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/BasicToken.sol\":{\"keccak256\":\"0x6121e538cdeaca8087378d46ac765ecaf68fc433b2add86f68c27e5a67d1b5a8\",\"urls\":[\"bzz-raw://201aa3da9508a75e5f77220ac4df4770fa9bf8c3f7024132d8ad6ae249e0e56b\",\"dweb:/ipfs/QmaKiDa426sp5pHLYWvMWKsmnVZbL5as6VpGcNoFMz7bZ8\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/ERC20.sol\":{\"keccak256\":\"0x02c6ac5bd8a7fd2f9f3cfd1994cc6863c3c976dc9cc0e6feaf6a35ab74a995c7\",\"urls\":[\"bzz-raw://dd007c7ab067c2cbcb28bd6df30a2309c8cb4a5d57d568635e22a77fbaa19db6\",\"dweb:/ipfs/QmSSixKxCuUxQvNY6i9cztvnUjUcSi7vs7dVrFLxSiH4dg\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/ERC20Basic.sol\":{\"keccak256\":\"0x608e6105b904166b430c78d9753cf47fda95c16a77cf32766b7788517fa30b83\",\"urls\":[\"bzz-raw://312dd66988716a0fa6d93869bea9a309c565050a181667af846ce62fb1528c14\",\"dweb:/ipfs/QmejTneFNrzGshLhJpHE2dTJVhGWvFkwgi1eHP2CAj6uqE\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/FaucetToken.sol\":{\"keccak256\":\"0xc7ddbaa6f940321c611bb78a6306f25424a9adb6612e09b1c743a3b8f3fc0eae\",\"urls\":[\"bzz-raw://8fa93dc0074cc9c62e16f31ea12ec1d4a4358f0f0f911eae87cfb997b2307a5c\",\"dweb:/ipfs/QmeADrRPdZCKZhiLGzgGPNHJhWYPJDsCUSJSJQXBthxSuo\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/SafeMath.sol\":{\"keccak256\":\"0xa83f091bb99c1f412f78ceb5ca5a23f8adc2fdf0f20d730ac5de3ed99609d08a\",\"urls\":[\"bzz-raw://3d8d04982ebb23c75e529ae3fab2c0e53d7ffccf6b90308219f232f578bbc9b5\",\"dweb:/ipfs/QmeZ8TeKWfYHgZ1H5d5uWzjwVwFsC4E2sbBDxy96XWabJr\"]},\"/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/StandardToken.sol\":{\"keccak256\":\"0x16acddc338e571a3b2447016aab5722c12f0bd658e49115da1707ebc8da4c308\",\"urls\":[\"bzz-raw://c52ef8b8bfcc540d9e5ab590f6f92cc2e6e7596386d19889037e07b96b210ea9\",\"dweb:/ipfs/QmSKGLVNm91FQa8dz9NKhRvF2oWmw4dmb3KWBakD8gJUDQ\"]}},\"version\":1}";
  var bytecode$1 = "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";
  var deployedBytecode$1 = "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";
  var sourceMap$1 = "194:686:7:-;;;316:303;8:9:-1;5:2;;;30:1;27;20:12;5:2;316:303:7;;;;;;;;;;;;;;;13:3:-1;8;5:12;2:2;;;30:1;27;20:12;2:2;316:303:7;;;;;;;;;;;;;;;;;;;;;;19:11:-1;14:3;11:20;8:2;;;44:1;41;34:12;8:2;71:11;66:3;62:21;55:28;;123:4;118:3;114:14;159:9;141:16;138:31;135:2;;;182:1;179;172:12;135:2;219:3;213:10;330:9;325:1;311:12;307:20;289:16;285:43;282:58;261:11;247:12;244:29;233:115;230:2;;;361:1;358;351:12;230:2;384:12;379:3;372:25;420:4;415:3;411:14;404:21;;0:432;;316:303:7;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;316:303:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;19:11:-1;14:3;11:20;8:2;;;44:1;41;34:12;8:2;71:11;66:3;62:21;55:28;;123:4;118:3;114:14;159:9;141:16;138:31;135:2;;;182:1;179;172:12;135:2;219:3;213:10;330:9;325:1;311:12;307:20;289:16;285:43;282:58;261:11;247:12;244:29;233:115;230:2;;;361:1;358;351:12;230:2;384:12;379:3;372:25;420:4;415:3;411:14;404:21;;0:432;;316:303:7;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;316:303:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;459:14;444:12;:29;;;;506:14;483:8;:20;492:10;483:20;;;;;;;;;;;;;;;:37;;;;537:10;530:4;:17;;;;;;;;;;;;:::i;:::-;;566:12;557:6;:21;;;;;;;;;;;;:::i;:::-;;599:13;588:8;;:24;;;;;;;;;;;;;;;;;;316:303;;;;194:686;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;";
  var deployedSourceMap$1 = "194:686:7:-;;;;8:9:-1;5:2;;;30:1;27;20:12;5:2;194:686:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;238:18;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;238:18:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;694:184;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;694:184:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;1908:202:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1908:202:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;376:89:4;;;:::i;:::-;;;;;;;;;;;;;;;;;;;742:528:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;742:528:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;288:21:7;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;3911:489:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3911:489:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;1192:105:4;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;1192:105:4;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;262:20:7;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;262:20:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;631:347:4;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;631:347:4;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;3098:336:9;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;3098:336:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;2443:183;;;;;;13:2:-1;8:3;5:11;2:2;;;29:1;26;19:12;2:2;2443:183:9;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;238:18:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;694:184::-;782:5;762:8;:16;771:6;762:16;;;;;;;;;;;;;;;;:25;;;;;;;;;;;813:5;797:12;;:21;;;;;;;;;;;857:6;833:38;;850:4;833:38;;;865:5;833:38;;;;;;;;;;;;;;;;;;694:184;;:::o;1908:202:9:-;1975:4;2023:6;1991:7;:19;1999:10;1991:19;;;;;;;;;;;;;;;:29;2011:8;1991:29;;;;;;;;;;;;;;;:38;;;;2065:8;2044:38;;2053:10;2044:38;;;2075:6;2044:38;;;;;;;;;;;;;;;;;;2099:4;2092:11;;1908:202;;;;:::o;376:89:4:-;420:7;446:12;;439:19;;376:89;:::o;742:528:9:-;870:4;913:1;898:17;;:3;:17;;;;890:26;;;;;;944:8;:15;953:5;944:15;;;;;;;;;;;;;;;;934:6;:25;;926:34;;;;;;988:7;:14;996:5;988:14;;;;;;;;;;;;;;;:26;1003:10;988:26;;;;;;;;;;;;;;;;978:6;:36;;970:45;;;;;;1044:27;1064:6;1044:8;:15;1053:5;1044:15;;;;;;;;;;;;;;;;:19;;:27;;;;:::i;:::-;1026:8;:15;1035:5;1026:15;;;;;;;;;;;;;;;:45;;;;1097:25;1115:6;1097:8;:13;1106:3;1097:13;;;;;;;;;;;;;;;;:17;;:25;;;;:::i;:::-;1081:8;:13;1090:3;1081:13;;;;;;;;;;;;;;;:41;;;;1161:38;1192:6;1161:7;:14;1169:5;1161:14;;;;;;;;;;;;;;;:26;1176:10;1161:26;;;;;;;;;;;;;;;;:30;;:38;;;;:::i;:::-;1132:7;:14;1140:5;1132:14;;;;;;;;;;;;;;;:26;1147:10;1132:26;;;;;;;;;;;;;;;:67;;;;1230:3;1214:28;;1223:5;1214:28;;;1235:6;1214:28;;;;;;;;;;;;;;;;;;1259:4;1252:11;;742:528;;;;;:::o;288:21:7:-;;;;;;;;;;;;;:::o;3911:489:9:-;4035:4;4055:16;4074:7;:19;4082:10;4074:19;;;;;;;;;;;;;;;:29;4094:8;4074:29;;;;;;;;;;;;;;;;4055:48;;4136:8;4117:16;:27;4113:184;;;4192:1;4160:7;:19;4168:10;4160:19;;;;;;;;;;;;;;;:29;4180:8;4160:29;;;;;;;;;;;;;;;:33;;;;4113:184;;;4256:30;4269:16;4256:8;:12;;:30;;;;:::i;:::-;4224:7;:19;4232:10;4224:19;;;;;;;;;;;;;;;:29;4244:8;4224:29;;;;;;;;;;;;;;;:62;;;;4113:184;4332:8;4311:61;;4320:10;4311:61;;;4342:7;:19;4350:10;4342:19;;;;;;;;;;;;;;;:29;4362:8;4342:29;;;;;;;;;;;;;;;;4311:61;;;;;;;;;;;;;;;;;;4389:4;4382:11;;;3911:489;;;;:::o;1192:105:4:-;1248:7;1274:8;:16;1283:6;1274:16;;;;;;;;;;;;;;;;1267:23;;1192:105;;;:::o;262:20:7:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;631:347:4:-;694:4;733:1;718:17;;:3;:17;;;;710:26;;;;;;764:8;:20;773:10;764:20;;;;;;;;;;;;;;;;754:6;:30;;746:39;;;;;;819:32;844:6;819:8;:20;828:10;819:20;;;;;;;;;;;;;;;;:24;;:32;;;;:::i;:::-;796:8;:20;805:10;796:20;;;;;;;;;;;;;;;:55;;;;877:25;895:6;877:8;:13;886:3;877:13;;;;;;;;;;;;;;;;:17;;:25;;;;:::i;:::-;861:8;:13;870:3;861:13;;;;;;;;;;;;;;;:41;;;;938:3;917:33;;926:10;917:33;;;943:6;917:33;;;;;;;;;;;;;;;;;;967:4;960:11;;631:347;;;;:::o;3098:336:9:-;3217:4;3283:46;3317:11;3283:7;:19;3291:10;3283:19;;;;;;;;;;;;;;;:29;3303:8;3283:29;;;;;;;;;;;;;;;;:33;;:46;;;;:::i;:::-;3237:7;:19;3245:10;3237:19;;;;;;;;;;;;;;;:29;3257:8;3237:29;;;;;;;;;;;;;;;:93;;;;3366:8;3345:61;;3354:10;3345:61;;;3376:7;:19;3384:10;3376:19;;;;;;;;;;;;;;;:29;3396:8;3376:29;;;;;;;;;;;;;;;;3345:61;;;;;;;;;;;;;;;;;;3423:4;3416:11;;3098:336;;;;:::o;2443:183::-;2564:7;2594;:15;2602:6;2594:15;;;;;;;;;;;;;;;:25;2610:8;2594:25;;;;;;;;;;;;;;;;2587:32;;2443:183;;;;:::o;1124:120:8:-;1182:7;1213:1;1208;:6;;1201:14;;;;1236:1;1232;:5;1225:12;;1124:120;;;;:::o;1314:137::-;1372:9;1401:1;1397;:5;1393:9;;1424:1;1419;:6;;1412:14;;;;1443:1;1436:8;;1314:137;;;;:::o";
  var source$1 = "pragma solidity ^0.5.12;\n\nimport \"./StandardToken.sol\";\n\n/**\n  * @title The Compound Faucet Test Token\n  * @author Compound\n  * @notice A simple test token that lets anyone get more of it.\n  */\ncontract FaucetToken is StandardToken {\n    string public name;\n    string public symbol;\n    uint8 public decimals;\n\n    constructor(uint256 _initialAmount, string memory _tokenName, uint8 _decimalUnits, string memory _tokenSymbol) public {\n        totalSupply_ = _initialAmount;\n        balances[msg.sender] = _initialAmount;\n        name = _tokenName;\n        symbol = _tokenSymbol;\n        decimals = _decimalUnits;\n    }\n\n    /**\n      * @dev Arbitrarily adds tokens to any account\n      */\n    function allocateTo(address _owner, uint256 value) public {\n        balances[_owner] += value;\n        totalSupply_ += value;\n        emit Transfer(address(this), _owner, value);\n    }\n}\n";
  var sourcePath$1 = "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/FaucetToken.sol";
  var ast$1 = {
  	absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/FaucetToken.sol",
  	exportedSymbols: {
  		FaucetToken: [
  			2061
  		]
  	},
  	id: 2062,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 1990,
  			literals: [
  				"solidity",
  				"^",
  				"0.5",
  				".12"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:24:7"
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/StandardToken.sol",
  			file: "./StandardToken.sol",
  			id: 1991,
  			nodeType: "ImportDirective",
  			scope: 2062,
  			sourceUnit: 2403,
  			src: "26:29:7",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 1992,
  						name: "StandardToken",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2402,
  						src: "218:13:7",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_StandardToken_$2402",
  							typeString: "contract StandardToken"
  						}
  					},
  					id: 1993,
  					nodeType: "InheritanceSpecifier",
  					src: "218:13:7"
  				}
  			],
  			contractDependencies: [
  				1913,
  				1956,
  				1988,
  				2402
  			],
  			contractKind: "contract",
  			documentation: "@title The Compound Faucet Test Token\n@author Compound\n@notice A simple test token that lets anyone get more of it.",
  			fullyImplemented: true,
  			id: 2061,
  			linearizedBaseContracts: [
  				2061,
  				2402,
  				1913,
  				1956,
  				1988
  			],
  			name: "FaucetToken",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					constant: false,
  					id: 1995,
  					name: "name",
  					nodeType: "VariableDeclaration",
  					scope: 2061,
  					src: "238:18:7",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_storage",
  						typeString: "string"
  					},
  					typeName: {
  						id: 1994,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "238:6:7",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 1997,
  					name: "symbol",
  					nodeType: "VariableDeclaration",
  					scope: 2061,
  					src: "262:20:7",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_storage",
  						typeString: "string"
  					},
  					typeName: {
  						id: 1996,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "262:6:7",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 1999,
  					name: "decimals",
  					nodeType: "VariableDeclaration",
  					scope: 2061,
  					src: "288:21:7",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint8",
  						typeString: "uint8"
  					},
  					typeName: {
  						id: 1998,
  						name: "uint8",
  						nodeType: "ElementaryTypeName",
  						src: "288:5:7",
  						typeDescriptions: {
  							typeIdentifier: "t_uint8",
  							typeString: "uint8"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2033,
  						nodeType: "Block",
  						src: "434:185:7",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2012,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2010,
  										name: "totalSupply_",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1832,
  										src: "444:12:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2011,
  										name: "_initialAmount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2001,
  										src: "459:14:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "444:29:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2013,
  								nodeType: "ExpressionStatement",
  								src: "444:29:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2019,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 2014,
  											name: "balances",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1830,
  											src: "483:8:7",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 2017,
  										indexExpression: {
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 2015,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2417,
  												src: "492:3:7",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 2016,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "492:10:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "483:20:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2018,
  										name: "_initialAmount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2001,
  										src: "506:14:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "483:37:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2020,
  								nodeType: "ExpressionStatement",
  								src: "483:37:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2023,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2021,
  										name: "name",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1995,
  										src: "530:4:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_storage",
  											typeString: "string storage ref"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2022,
  										name: "_tokenName",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2003,
  										src: "537:10:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_memory_ptr",
  											typeString: "string memory"
  										}
  									},
  									src: "530:17:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage",
  										typeString: "string storage ref"
  									}
  								},
  								id: 2024,
  								nodeType: "ExpressionStatement",
  								src: "530:17:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2027,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2025,
  										name: "symbol",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1997,
  										src: "557:6:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_storage",
  											typeString: "string storage ref"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2026,
  										name: "_tokenSymbol",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2007,
  										src: "566:12:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_memory_ptr",
  											typeString: "string memory"
  										}
  									},
  									src: "557:21:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage",
  										typeString: "string storage ref"
  									}
  								},
  								id: 2028,
  								nodeType: "ExpressionStatement",
  								src: "557:21:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2031,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2029,
  										name: "decimals",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1999,
  										src: "588:8:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint8",
  											typeString: "uint8"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2030,
  										name: "_decimalUnits",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2005,
  										src: "599:13:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint8",
  											typeString: "uint8"
  										}
  									},
  									src: "588:24:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint8",
  										typeString: "uint8"
  									}
  								},
  								id: 2032,
  								nodeType: "ExpressionStatement",
  								src: "588:24:7"
  							}
  						]
  					},
  					documentation: null,
  					id: 2034,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2008,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2001,
  								name: "_initialAmount",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "328:22:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2000,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "328:7:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2003,
  								name: "_tokenName",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "352:24:7",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 2002,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "352:6:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2005,
  								name: "_decimalUnits",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "378:19:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint8",
  									typeString: "uint8"
  								},
  								typeName: {
  									id: 2004,
  									name: "uint8",
  									nodeType: "ElementaryTypeName",
  									src: "378:5:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint8",
  										typeString: "uint8"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2007,
  								name: "_tokenSymbol",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "399:26:7",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 2006,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "399:6:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "327:99:7"
  					},
  					returnParameters: {
  						id: 2009,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "434:0:7"
  					},
  					scope: 2061,
  					src: "316:303:7",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2059,
  						nodeType: "Block",
  						src: "752:126:7",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2045,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 2041,
  											name: "balances",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1830,
  											src: "762:8:7",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 2043,
  										indexExpression: {
  											argumentTypes: null,
  											id: 2042,
  											name: "_owner",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2036,
  											src: "771:6:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "762:16:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "+=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2044,
  										name: "value",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2038,
  										src: "782:5:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "762:25:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2046,
  								nodeType: "ExpressionStatement",
  								src: "762:25:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2049,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2047,
  										name: "totalSupply_",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1832,
  										src: "797:12:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "+=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2048,
  										name: "value",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2038,
  										src: "813:5:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "797:21:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2050,
  								nodeType: "ExpressionStatement",
  								src: "797:21:7"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 2053,
  													name: "this",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2449,
  													src: "850:4:7",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_FaucetToken_$2061",
  														typeString: "contract FaucetToken"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_FaucetToken_$2061",
  														typeString: "contract FaucetToken"
  													}
  												],
  												id: 2052,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "842:7:7",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 2054,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "842:13:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 2055,
  											name: "_owner",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2036,
  											src: "857:6:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 2056,
  											name: "value",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2038,
  											src: "865:5:7",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 2051,
  										name: "Transfer",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1987,
  										src: "833:8:7",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 2057,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "833:38:7",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2058,
  								nodeType: "EmitStatement",
  								src: "828:43:7"
  							}
  						]
  					},
  					documentation: "@dev Arbitrarily adds tokens to any account",
  					id: 2060,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "allocateTo",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2039,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2036,
  								name: "_owner",
  								nodeType: "VariableDeclaration",
  								scope: 2060,
  								src: "714:14:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 2035,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "714:7:7",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2038,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 2060,
  								src: "730:13:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2037,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "730:7:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "713:31:7"
  					},
  					returnParameters: {
  						id: 2040,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "752:0:7"
  					},
  					scope: 2061,
  					src: "694:184:7",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				}
  			],
  			scope: 2062,
  			src: "194:686:7"
  		}
  	],
  	src: "0:881:7"
  };
  var legacyAST$1 = {
  	absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/FaucetToken.sol",
  	exportedSymbols: {
  		FaucetToken: [
  			2061
  		]
  	},
  	id: 2062,
  	nodeType: "SourceUnit",
  	nodes: [
  		{
  			id: 1990,
  			literals: [
  				"solidity",
  				"^",
  				"0.5",
  				".12"
  			],
  			nodeType: "PragmaDirective",
  			src: "0:24:7"
  		},
  		{
  			absolutePath: "/home/mesi/Projects/IOV Labs/rbank-js/dependencies/DeFiProt/contracts/test/StandardToken.sol",
  			file: "./StandardToken.sol",
  			id: 1991,
  			nodeType: "ImportDirective",
  			scope: 2062,
  			sourceUnit: 2403,
  			src: "26:29:7",
  			symbolAliases: [
  			],
  			unitAlias: ""
  		},
  		{
  			baseContracts: [
  				{
  					"arguments": null,
  					baseName: {
  						contractScope: null,
  						id: 1992,
  						name: "StandardToken",
  						nodeType: "UserDefinedTypeName",
  						referencedDeclaration: 2402,
  						src: "218:13:7",
  						typeDescriptions: {
  							typeIdentifier: "t_contract$_StandardToken_$2402",
  							typeString: "contract StandardToken"
  						}
  					},
  					id: 1993,
  					nodeType: "InheritanceSpecifier",
  					src: "218:13:7"
  				}
  			],
  			contractDependencies: [
  				1913,
  				1956,
  				1988,
  				2402
  			],
  			contractKind: "contract",
  			documentation: "@title The Compound Faucet Test Token\n@author Compound\n@notice A simple test token that lets anyone get more of it.",
  			fullyImplemented: true,
  			id: 2061,
  			linearizedBaseContracts: [
  				2061,
  				2402,
  				1913,
  				1956,
  				1988
  			],
  			name: "FaucetToken",
  			nodeType: "ContractDefinition",
  			nodes: [
  				{
  					constant: false,
  					id: 1995,
  					name: "name",
  					nodeType: "VariableDeclaration",
  					scope: 2061,
  					src: "238:18:7",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_storage",
  						typeString: "string"
  					},
  					typeName: {
  						id: 1994,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "238:6:7",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 1997,
  					name: "symbol",
  					nodeType: "VariableDeclaration",
  					scope: 2061,
  					src: "262:20:7",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_string_storage",
  						typeString: "string"
  					},
  					typeName: {
  						id: 1996,
  						name: "string",
  						nodeType: "ElementaryTypeName",
  						src: "262:6:7",
  						typeDescriptions: {
  							typeIdentifier: "t_string_storage_ptr",
  							typeString: "string"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					constant: false,
  					id: 1999,
  					name: "decimals",
  					nodeType: "VariableDeclaration",
  					scope: 2061,
  					src: "288:21:7",
  					stateVariable: true,
  					storageLocation: "default",
  					typeDescriptions: {
  						typeIdentifier: "t_uint8",
  						typeString: "uint8"
  					},
  					typeName: {
  						id: 1998,
  						name: "uint8",
  						nodeType: "ElementaryTypeName",
  						src: "288:5:7",
  						typeDescriptions: {
  							typeIdentifier: "t_uint8",
  							typeString: "uint8"
  						}
  					},
  					value: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2033,
  						nodeType: "Block",
  						src: "434:185:7",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2012,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2010,
  										name: "totalSupply_",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1832,
  										src: "444:12:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2011,
  										name: "_initialAmount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2001,
  										src: "459:14:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "444:29:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2013,
  								nodeType: "ExpressionStatement",
  								src: "444:29:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2019,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 2014,
  											name: "balances",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1830,
  											src: "483:8:7",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 2017,
  										indexExpression: {
  											argumentTypes: null,
  											expression: {
  												argumentTypes: null,
  												id: 2015,
  												name: "msg",
  												nodeType: "Identifier",
  												overloadedDeclarations: [
  												],
  												referencedDeclaration: 2417,
  												src: "492:3:7",
  												typeDescriptions: {
  													typeIdentifier: "t_magic_message",
  													typeString: "msg"
  												}
  											},
  											id: 2016,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											lValueRequested: false,
  											memberName: "sender",
  											nodeType: "MemberAccess",
  											referencedDeclaration: null,
  											src: "492:10:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address_payable",
  												typeString: "address payable"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "483:20:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2018,
  										name: "_initialAmount",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2001,
  										src: "506:14:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "483:37:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2020,
  								nodeType: "ExpressionStatement",
  								src: "483:37:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2023,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2021,
  										name: "name",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1995,
  										src: "530:4:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_storage",
  											typeString: "string storage ref"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2022,
  										name: "_tokenName",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2003,
  										src: "537:10:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_memory_ptr",
  											typeString: "string memory"
  										}
  									},
  									src: "530:17:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage",
  										typeString: "string storage ref"
  									}
  								},
  								id: 2024,
  								nodeType: "ExpressionStatement",
  								src: "530:17:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2027,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2025,
  										name: "symbol",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1997,
  										src: "557:6:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_storage",
  											typeString: "string storage ref"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2026,
  										name: "_tokenSymbol",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2007,
  										src: "566:12:7",
  										typeDescriptions: {
  											typeIdentifier: "t_string_memory_ptr",
  											typeString: "string memory"
  										}
  									},
  									src: "557:21:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage",
  										typeString: "string storage ref"
  									}
  								},
  								id: 2028,
  								nodeType: "ExpressionStatement",
  								src: "557:21:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2031,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2029,
  										name: "decimals",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1999,
  										src: "588:8:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint8",
  											typeString: "uint8"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2030,
  										name: "_decimalUnits",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2005,
  										src: "599:13:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint8",
  											typeString: "uint8"
  										}
  									},
  									src: "588:24:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint8",
  										typeString: "uint8"
  									}
  								},
  								id: 2032,
  								nodeType: "ExpressionStatement",
  								src: "588:24:7"
  							}
  						]
  					},
  					documentation: null,
  					id: 2034,
  					implemented: true,
  					kind: "constructor",
  					modifiers: [
  					],
  					name: "",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2008,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2001,
  								name: "_initialAmount",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "328:22:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2000,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "328:7:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2003,
  								name: "_tokenName",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "352:24:7",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 2002,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "352:6:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2005,
  								name: "_decimalUnits",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "378:19:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint8",
  									typeString: "uint8"
  								},
  								typeName: {
  									id: 2004,
  									name: "uint8",
  									nodeType: "ElementaryTypeName",
  									src: "378:5:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint8",
  										typeString: "uint8"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2007,
  								name: "_tokenSymbol",
  								nodeType: "VariableDeclaration",
  								scope: 2034,
  								src: "399:26:7",
  								stateVariable: false,
  								storageLocation: "memory",
  								typeDescriptions: {
  									typeIdentifier: "t_string_memory_ptr",
  									typeString: "string"
  								},
  								typeName: {
  									id: 2006,
  									name: "string",
  									nodeType: "ElementaryTypeName",
  									src: "399:6:7",
  									typeDescriptions: {
  										typeIdentifier: "t_string_storage_ptr",
  										typeString: "string"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "327:99:7"
  					},
  					returnParameters: {
  						id: 2009,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "434:0:7"
  					},
  					scope: 2061,
  					src: "316:303:7",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				},
  				{
  					body: {
  						id: 2059,
  						nodeType: "Block",
  						src: "752:126:7",
  						statements: [
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2045,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										baseExpression: {
  											argumentTypes: null,
  											id: 2041,
  											name: "balances",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 1830,
  											src: "762:8:7",
  											typeDescriptions: {
  												typeIdentifier: "t_mapping$_t_address_$_t_uint256_$",
  												typeString: "mapping(address => uint256)"
  											}
  										},
  										id: 2043,
  										indexExpression: {
  											argumentTypes: null,
  											id: 2042,
  											name: "_owner",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2036,
  											src: "771:6:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										isConstant: false,
  										isLValue: true,
  										isPure: false,
  										lValueRequested: true,
  										nodeType: "IndexAccess",
  										src: "762:16:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "+=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2044,
  										name: "value",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2038,
  										src: "782:5:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "762:25:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2046,
  								nodeType: "ExpressionStatement",
  								src: "762:25:7"
  							},
  							{
  								expression: {
  									argumentTypes: null,
  									id: 2049,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									lValueRequested: false,
  									leftHandSide: {
  										argumentTypes: null,
  										id: 2047,
  										name: "totalSupply_",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1832,
  										src: "797:12:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									nodeType: "Assignment",
  									operator: "+=",
  									rightHandSide: {
  										argumentTypes: null,
  										id: 2048,
  										name: "value",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 2038,
  										src: "813:5:7",
  										typeDescriptions: {
  											typeIdentifier: "t_uint256",
  											typeString: "uint256"
  										}
  									},
  									src: "797:21:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								id: 2050,
  								nodeType: "ExpressionStatement",
  								src: "797:21:7"
  							},
  							{
  								eventCall: {
  									argumentTypes: null,
  									"arguments": [
  										{
  											argumentTypes: null,
  											"arguments": [
  												{
  													argumentTypes: null,
  													id: 2053,
  													name: "this",
  													nodeType: "Identifier",
  													overloadedDeclarations: [
  													],
  													referencedDeclaration: 2449,
  													src: "850:4:7",
  													typeDescriptions: {
  														typeIdentifier: "t_contract$_FaucetToken_$2061",
  														typeString: "contract FaucetToken"
  													}
  												}
  											],
  											expression: {
  												argumentTypes: [
  													{
  														typeIdentifier: "t_contract$_FaucetToken_$2061",
  														typeString: "contract FaucetToken"
  													}
  												],
  												id: 2052,
  												isConstant: false,
  												isLValue: false,
  												isPure: true,
  												lValueRequested: false,
  												nodeType: "ElementaryTypeNameExpression",
  												src: "842:7:7",
  												typeDescriptions: {
  													typeIdentifier: "t_type$_t_address_$",
  													typeString: "type(address)"
  												},
  												typeName: "address"
  											},
  											id: 2054,
  											isConstant: false,
  											isLValue: false,
  											isPure: false,
  											kind: "typeConversion",
  											lValueRequested: false,
  											names: [
  											],
  											nodeType: "FunctionCall",
  											src: "842:13:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 2055,
  											name: "_owner",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2036,
  											src: "857:6:7",
  											typeDescriptions: {
  												typeIdentifier: "t_address",
  												typeString: "address"
  											}
  										},
  										{
  											argumentTypes: null,
  											id: 2056,
  											name: "value",
  											nodeType: "Identifier",
  											overloadedDeclarations: [
  											],
  											referencedDeclaration: 2038,
  											src: "865:5:7",
  											typeDescriptions: {
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										}
  									],
  									expression: {
  										argumentTypes: [
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_address",
  												typeString: "address"
  											},
  											{
  												typeIdentifier: "t_uint256",
  												typeString: "uint256"
  											}
  										],
  										id: 2051,
  										name: "Transfer",
  										nodeType: "Identifier",
  										overloadedDeclarations: [
  										],
  										referencedDeclaration: 1987,
  										src: "833:8:7",
  										typeDescriptions: {
  											typeIdentifier: "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
  											typeString: "function (address,address,uint256)"
  										}
  									},
  									id: 2057,
  									isConstant: false,
  									isLValue: false,
  									isPure: false,
  									kind: "functionCall",
  									lValueRequested: false,
  									names: [
  									],
  									nodeType: "FunctionCall",
  									src: "833:38:7",
  									typeDescriptions: {
  										typeIdentifier: "t_tuple$__$",
  										typeString: "tuple()"
  									}
  								},
  								id: 2058,
  								nodeType: "EmitStatement",
  								src: "828:43:7"
  							}
  						]
  					},
  					documentation: "@dev Arbitrarily adds tokens to any account",
  					id: 2060,
  					implemented: true,
  					kind: "function",
  					modifiers: [
  					],
  					name: "allocateTo",
  					nodeType: "FunctionDefinition",
  					parameters: {
  						id: 2039,
  						nodeType: "ParameterList",
  						parameters: [
  							{
  								constant: false,
  								id: 2036,
  								name: "_owner",
  								nodeType: "VariableDeclaration",
  								scope: 2060,
  								src: "714:14:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_address",
  									typeString: "address"
  								},
  								typeName: {
  									id: 2035,
  									name: "address",
  									nodeType: "ElementaryTypeName",
  									src: "714:7:7",
  									stateMutability: "nonpayable",
  									typeDescriptions: {
  										typeIdentifier: "t_address",
  										typeString: "address"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							},
  							{
  								constant: false,
  								id: 2038,
  								name: "value",
  								nodeType: "VariableDeclaration",
  								scope: 2060,
  								src: "730:13:7",
  								stateVariable: false,
  								storageLocation: "default",
  								typeDescriptions: {
  									typeIdentifier: "t_uint256",
  									typeString: "uint256"
  								},
  								typeName: {
  									id: 2037,
  									name: "uint256",
  									nodeType: "ElementaryTypeName",
  									src: "730:7:7",
  									typeDescriptions: {
  										typeIdentifier: "t_uint256",
  										typeString: "uint256"
  									}
  								},
  								value: null,
  								visibility: "internal"
  							}
  						],
  						src: "713:31:7"
  					},
  					returnParameters: {
  						id: 2040,
  						nodeType: "ParameterList",
  						parameters: [
  						],
  						src: "752:0:7"
  					},
  					scope: 2061,
  					src: "694:184:7",
  					stateMutability: "nonpayable",
  					superFunction: null,
  					visibility: "public"
  				}
  			],
  			scope: 2062,
  			src: "194:686:7"
  		}
  	],
  	src: "0:881:7"
  };
  var compiler$1 = {
  	name: "solc",
  	version: "0.5.16+commit.9c3226ce.Emscripten.clang"
  };
  var networks$1 = {
  };
  var schemaVersion$1 = "3.2.3";
  var updatedAt$1 = "2020-08-19T10:43:21.262Z";
  var devdoc$1 = {
  	author: "Compound",
  	methods: {
  		"allocateTo(address,uint256)": {
  			details: "Arbitrarily adds tokens to any account"
  		},
  		"allowance(address,address)": {
  			details: "Function to check the amount of tokens that an owner allowed to a spender.",
  			params: {
  				_owner: "address The address which owns the funds.",
  				_spender: "address The address which will spend the funds."
  			},
  			"return": "A uint256 specifying the amount of tokens still available for the spender."
  		},
  		"approve(address,uint256)": {
  			details: "Approve the passed address to spend the specified amount of tokens on behalf of msg.sender. Beware that changing an allowance with this method brings the risk that someone may use both the old and the new allowance by unfortunate transaction ordering. One possible solution to mitigate this race condition is to first reduce the spender's allowance to 0 and set the desired value afterwards: https://github.com/ethereum/EIPs/issues/20#issuecomment-263524729",
  			params: {
  				_spender: "The address which will spend the funds.",
  				_value: "The amount of tokens to be spent."
  			}
  		},
  		"balanceOf(address)": {
  			details: "Gets the balance of the specified address.",
  			params: {
  				_owner: "The address to query the the balance of."
  			},
  			"return": "An uint256 representing the amount owned by the passed address."
  		},
  		"decreaseApproval(address,uint256)": {
  			details: "Decrease the amount of tokens that an owner allowed to a spender. approve should be called when allowed[_spender] == 0. To decrement allowed value is better to use this function to avoid 2 calls (and wait until the first transaction is mined) From MonolithDAO Token.sol",
  			params: {
  				_spender: "The address which will spend the funds.",
  				_subtractedValue: "The amount of tokens to decrease the allowance by."
  			}
  		},
  		"increaseApproval(address,uint256)": {
  			details: "Increase the amount of tokens that an owner allowed to a spender. approve should be called when allowed[_spender] == 0. To increment allowed value is better to use this function to avoid 2 calls (and wait until the first transaction is mined) From MonolithDAO Token.sol",
  			params: {
  				_addedValue: "The amount of tokens to increase the allowance by.",
  				_spender: "The address which will spend the funds."
  			}
  		},
  		"totalSupply()": {
  			details: "Total number of tokens in existence"
  		},
  		"transfer(address,uint256)": {
  			details: "Transfer token for a specified address",
  			params: {
  				_to: "The address to transfer to.",
  				_value: "The amount to be transferred."
  			}
  		},
  		"transferFrom(address,address,uint256)": {
  			details: "Transfer tokens from one address to another",
  			params: {
  				_from: "address The address which you want to send tokens from",
  				_to: "address The address which you want to transfer to",
  				_value: "uint256 the amount of tokens to be transferred"
  			}
  		}
  	},
  	title: "The Compound Faucet Test Token"
  };
  var userdoc$1 = {
  	methods: {
  	},
  	notice: "A simple test token that lets anyone get more of it."
  };
  var TokenContract = {
  	contractName: contractName$1,
  	abi: abi$1,
  	metadata: metadata$1,
  	bytecode: bytecode$1,
  	deployedBytecode: deployedBytecode$1,
  	sourceMap: sourceMap$1,
  	deployedSourceMap: deployedSourceMap$1,
  	source: source$1,
  	sourcePath: sourcePath$1,
  	ast: ast$1,
  	legacyAST: legacyAST$1,
  	compiler: compiler$1,
  	networks: networks$1,
  	schemaVersion: schemaVersion$1,
  	updatedAt: updatedAt$1,
  	devdoc: devdoc$1,
  	userdoc: userdoc$1
  };

  var Token = function () {
    function Token() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      _classCallCheck__default['default'](this, Token);
      this.internalAddress = address.toLowerCase();
      if (!this.address.match(/0x[a-f0-9]{40}/)) return new Error('Missing token address');
      this.instance = new rbankUtils.web3.eth.Contract(TokenContract.abi, this.address);
    }
    _createClass__default['default'](Token, [{
      key: "eventualBalanceOf",
      value: function eventualBalanceOf() {
        var _this = this;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return new Promise(function (resolve, reject) {
          _this.instance.methods.balanceOf(from).call().then(function (balance) {
            return Number(balance);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "approve",
      value: function approve(marketAddress, amount) {
        var _this2 = this;
        var from = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.send(_this2.instance.methods.approve(marketAddress, amount), from).then(resolve).catch(reject);
        });
      }
    }, {
      key: "address",
      get: function get() {
        return this.internalAddress;
      }
    }, {
      key: "eventualName",
      get: function get() {
        var _this3 = this;
        return new Promise(function (resolve, reject) {
          _this3.instance.methods.name().call().then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualSymbol",
      get: function get() {
        var _this4 = this;
        return new Promise(function (resolve, reject) {
          _this4.instance.methods.symbol().call().then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualDecimals",
      get: function get() {
        var _this5 = this;
        return new Promise(function (resolve, reject) {
          _this5.instance.methods.decimals().call().then(function (decimals) {
            return Number(decimals);
          }).then(resolve).catch(reject);
        });
      }
    }]);
    return Token;
  }();

  var Market = function () {
    function Market() {
      var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        1337: {
          httpProvider: 'http://127.0.0.1:8545',
          wsProvider: 'ws://127.0.0.1:8545'
        }
      };
      _classCallCheck__default['default'](this, Market);
      this.instanceAddress = address.toLowerCase();
      if (!this.address.match(/0x[a-f0-9]{40}/)) return new Error('Missing address');
      this.instance = new rbankUtils.web3.eth.Contract(MarketContract.abi, address);
      this.eventualWeb3WS = rbankUtils.getEventualChainId().then(function (chainId) {
        return new rbankUtils.Web3Utils(new rbankUtils.Web3Utils.providers.WebsocketProvider(config[chainId].wsProvider));
      }).catch(function () {
        return new Error('Something went wrong with the web3 instance over web sockets on Market');
      });
      this.eventualWeb3Http = rbankUtils.getEventualChainId().then(function (chainId) {
        return new rbankUtils.Web3Utils(new rbankUtils.Web3Utils.providers.HttpProvider(config[chainId].httpProvider));
      }).catch(function () {
        return new Error('Something went wrong with the web3 instance over http on Market');
      });
      this.token = this.instance.methods.token().call().then(function (tokenAddress) {
        return new Token(tokenAddress);
      });
    }
    _createClass__default['default'](Market, [{
      key: "getPastEvents",
      value: function getPastEvents(eventName, fromBlock) {
        var _this = this;
        var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return new Promise(function (resolve, reject) {
          _this.eventualWeb3Http.then(function (web3Http) {
            return new web3Http.eth.Contract(MarketContract.abi, _this.address);
          }).then(function (marketInstance) {
            return marketInstance.getPastEvents(eventName, {
              filter: filter,
              fromBlock: fromBlock,
              toBlock: 'latest'
            });
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "getPastBlockNumbers",
      value: function getPastBlockNumbers(period) {
        var _this2 = this;
        var pastBlockNumbers = [];
        var blocksPerYear = 1000000;
        var labelsPerPeriod;
        var blocksPerPeriod;
        switch (period) {
          case rbankUtils.PERIOD_DAY:
            labelsPerPeriod = 12;
            blocksPerPeriod = Math.floor(blocksPerYear / (365.25 * 12));
            break;
          case rbankUtils.PERIOD_WEEK:
            labelsPerPeriod = 7;
            blocksPerPeriod = Math.floor(blocksPerYear / 365.25);
            break;
          case rbankUtils.PERIOD_MONTH:
            labelsPerPeriod = 15;
            blocksPerPeriod = Math.floor(blocksPerYear * 2 / 365.25);
            break;
          case rbankUtils.PERIOD_YEAR:
            labelsPerPeriod = 12;
            blocksPerPeriod = Math.floor(blocksPerYear / 12);
            break;
          default:
            labelsPerPeriod = 7;
            blocksPerPeriod = Math.floor(blocksPerYear / 365.25);
        }
        return new Promise(function (resolve, reject) {
          Promise.all([_this2.eventualDeployBlock, rbankUtils.web3.eth.getBlockNumber()]).then(function (_ref) {
            var _ref2 = _slicedToArray__default['default'](_ref, 2),
                deployBlock = _ref2[0],
                currentBlockNumber = _ref2[1];
            ___default['default'].range(labelsPerPeriod).forEach(function (i) {
              var pastBlockNumber = currentBlockNumber - blocksPerPeriod * i >= deployBlock ? currentBlockNumber - blocksPerPeriod * i : deployBlock;
              pastBlockNumbers.push(pastBlockNumber);
            });
            resolve(pastBlockNumbers);
          }).catch(reject);
        });
      }
    }, {
      key: "getOverallBalance",
      value: function getOverallBalance() {
        var _this3 = this;
        var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rbankUtils.PERIOD_WEEK;
        return new Promise(function (resolve, reject) {
          _this3.getPastBlockNumbers(period).then(function (pastBlockNumbers) {
            var pastMarketBalancesPromises = Promise.all(pastBlockNumbers.map(function (blockNumber) {
              var market = new Market(_this3.address);
              market.setDefaultBlock(blockNumber);
              return Promise.all([market.eventualUpdatedTotalSupply, market.eventualUpdatedTotalBorrows]);
            }));
            var pastBlocksPromise = Promise.all(pastBlockNumbers.map(function (blockNumber) {
              return rbankUtils.web3.eth.getBlock(blockNumber);
            }));
            return Promise.all([pastMarketBalancesPromises, pastBlocksPromise]);
          }).then(function (_ref3) {
            var _ref4 = _slicedToArray__default['default'](_ref3, 2),
                pastMarketBalances = _ref4[0],
                pastBlocks = _ref4[1];
            var overallBalances = pastMarketBalances.map(function (_ref5, idx) {
              var _ref6 = _slicedToArray__default['default'](_ref5, 2),
                  updatedTotalSupply = _ref6[0],
                  updatedTotalBorrow = _ref6[1];
              var time = new Date(pastBlocks[idx].timestamp * 1000);
              return [time, updatedTotalSupply, updatedTotalBorrow];
            });
            resolve(overallBalances);
          }).catch(reject);
        });
      }
    }, {
      key: "setDefaultBlock",
      value: function setDefaultBlock(blockNumber) {
        this.instance.defaultBlock = blockNumber;
      }
    }, {
      key: "setControllerAddress",
      value: function setControllerAddress(controllerAddress) {
        var _this4 = this;
        return new Promise(function (resolve, reject) {
          rbankUtils.send(_this4.instance.methods.setController(controllerAddress)).then(resolve).catch(reject);
        });
      }
    }, {
      key: "supply",
      value: function supply(amount) {
        var _this5 = this;
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return new Promise(function (resolve, reject) {
          _this5.token.then(function (token) {
            return token.approve(_this5.instanceAddress, amount, from);
          }).then(function () {
            return rbankUtils.send(_this5.instance.methods.supply(amount), from);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "borrow",
      value: function borrow(amount) {
        var _this6 = this;
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.send(_this6.instance.methods.borrow(amount), from).then(resolve).catch(reject);
        });
      }
    }, {
      key: "payBorrow",
      value: function payBorrow(amount) {
        var _this7 = this;
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return new Promise(function (resolve, reject) {
          _this7.token.then(function (token) {
            return token.approve(_this7.instanceAddress, amount, from);
          }).then(function () {
            return rbankUtils.send(_this7.instance.methods.payBorrow(amount), from);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "redeem",
      value: function redeem(amount) {
        var _this8 = this;
        var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.send(_this8.instance.methods.redeem(amount), from).then(resolve).catch(function () {
            reject(new Error('There was an error redeeming your tokens'));
          });
        });
      }
    }, {
      key: "supplyOf",
      value: function supplyOf() {
        var _this9 = this;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.web3.eth.getAccounts().then(function (_ref7) {
            var _ref8 = _slicedToArray__default['default'](_ref7, 1),
                account = _ref8[0];
            return _this9.instance.methods.supplyOf(from || account).call();
          }).then(function (supplyOf) {
            return Number(supplyOf);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "updatedSupplyOf",
      value: function updatedSupplyOf() {
        var _this10 = this;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.web3.eth.getAccounts().then(function (_ref9) {
            var _ref10 = _slicedToArray__default['default'](_ref9, 1),
                account = _ref10[0];
            return _this10.instance.methods.updatedSupplyOf(from || account).call();
          }).then(function (updatedSupplyOf) {
            return Number(updatedSupplyOf);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "borrowBy",
      value: function borrowBy() {
        var _this11 = this;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.web3.eth.getAccounts().then(function (_ref11) {
            var _ref12 = _slicedToArray__default['default'](_ref11, 1),
                account = _ref12[0];
            return _this11.instance.methods.borrowBy(from || account).call();
          }).then(function (borrowBy) {
            return Number(borrowBy);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "updatedBorrowBy",
      value: function updatedBorrowBy() {
        var _this12 = this;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.web3.eth.getAccounts().then(function (_ref13) {
            var _ref14 = _slicedToArray__default['default'](_ref13, 1),
                account = _ref14[0];
            return _this12.instance.methods.updatedBorrowBy(from || account).call();
          }).then(function (updatedBorrowBy) {
            return Number(updatedBorrowBy);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualAccountEarnings",
      value: function eventualAccountEarnings() {
        var _this13 = this;
        var from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return new Promise(function (resolve, reject) {
          rbankUtils.web3.eth.getAccounts().then(function (_ref15) {
            var _ref16 = _slicedToArray__default['default'](_ref15, 1),
                account = _ref16[0];
            return Promise.all([_this13.instance.methods.updatedSupplyOf(from || account).call(), _this13.instance.methods.supplyOf(from || account).call()]);
          }).then(function (_ref17) {
            var _ref18 = _slicedToArray__default['default'](_ref17, 2),
                updatedSupplyOf = _ref18[0],
                supplyOf = _ref18[1];
            return Number(updatedSupplyOf - supplyOf);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "liquidateBorrow",
      value: function liquidateBorrow(borrower, amount, collateralMarket) {
        var _this14 = this;
        var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
        return new Promise(function (resolve, reject) {
          _this14.token.then(function (token) {
            return token.approve(_this14.instanceAddress, amount, from);
          }).then(function () {
            return rbankUtils.send(_this14.instance.methods.liquidateBorrow(borrower, amount, collateralMarket), from);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "address",
      get: function get() {
        return this.instanceAddress;
      }
    }, {
      key: "eventualDeployBlock",
      get: function get() {
        var _this15 = this;
        return new Promise(function (resolve, reject) {
          _this15.instance.methods.deployBlock().call().then(function (block) {
            return Number(block);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualController",
      get: function get() {
        var _this16 = this;
        return new Promise(function (resolve, reject) {
          _this16.instance.methods.controller().call().then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualBlocksPerYear",
      get: function get() {
        var _this17 = this;
        return new Promise(function (resolve, reject) {
          _this17.instance.methods.blocksPerYear().call().then(function (blocksPerYear) {
            return Number(blocksPerYear);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualBorrowRate",
      get: function get() {
        var _this18 = this;
        return new Promise(function (resolve, reject) {
          _this18.eventualFactor.then(function (factor) {
            return [factor, _this18.eventualBlocksPerYear, _this18.instance.methods.borrowRatePerBlock().call()];
          }).then(function (promises) {
            return Promise.all(promises);
          }).then(function (_ref19) {
            var _ref20 = _slicedToArray__default['default'](_ref19, 3),
                factor = _ref20[0],
                blocksPerYear = _ref20[1],
                borrowRatePerBlock = _ref20[2];
            return new rbankUtils.BN(borrowRatePerBlock).times(new rbankUtils.BN(100 * blocksPerYear)).div(new rbankUtils.BN(factor)).toNumber();
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualBaseBorrowRate",
      get: function get() {
        var _this19 = this;
        return new Promise(function (resolve, reject) {
          _this19.eventualFactor.then(function (factor) {
            return Promise.all([factor, _this19.eventualBlocksPerYear, _this19.instance.methods.baseBorrowRate().call()]);
          }).then(function (_ref21) {
            var _ref22 = _slicedToArray__default['default'](_ref21, 3),
                factor = _ref22[0],
                blocksPerYear = _ref22[1],
                baseBorrowRate = _ref22[2];
            return new rbankUtils.BN(baseBorrowRate).times(new rbankUtils.BN(100 * blocksPerYear)).div(new rbankUtils.BN(factor)).toNumber();
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualFactor",
      get: function get() {
        var _this20 = this;
        return new Promise(function (resolve, reject) {
          _this20.instance.methods.FACTOR().call().then(function (factor) {
            return Number(factor);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualUpdatedTotalSupply",
      get: function get() {
        var _this21 = this;
        return new Promise(function (resolve, reject) {
          _this21.instance.methods.getUpdatedTotalSupply().call().then(function (updatedTotalSupply) {
            return Number(updatedTotalSupply);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualUpdatedTotalBorrows",
      get: function get() {
        var _this22 = this;
        return new Promise(function (resolve, reject) {
          _this22.instance.methods.getUpdatedTotalBorrows().call().then(function (updatedTotalBorrows) {
            return Number(updatedTotalBorrows);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualCash",
      get: function get() {
        var _this23 = this;
        return new Promise(function (resolve, reject) {
          _this23.instance.methods.getCash().call().then(function (cash) {
            return Number(cash);
          }).then(resolve).catch(reject);
        });
      }
    }, {
      key: "eventualToken",
      get: function get() {
        return this.token;
      }
    }, {
      key: "eventualEvents",
      get: function get() {
        var _this24 = this;
        return new Promise(function (resolve, reject) {
          _this24.eventualWeb3WS.then(function (web3WS) {
            var ws = new web3WS.eth.Contract(MarketContract.abi, _this24.address);
            resolve({
              supply: function supply() {
                var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var fromBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
                var cb = arguments.length > 2 ? arguments[2] : undefined;
                return ws.events.Supply({
                  filter: filter,
                  fromBlock: fromBlock
                }, cb);
              },
              borrow: function borrow() {
                var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var fromBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
                var cb = arguments.length > 2 ? arguments[2] : undefined;
                return ws.events.Borrow({
                  filter: filter,
                  fromBlock: fromBlock
                }, cb);
              },
              redeem: function redeem() {
                var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var fromBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
                var cb = arguments.length > 2 ? arguments[2] : undefined;
                return ws.events.Redeem({
                  filter: filter,
                  fromBlock: fromBlock
                }, cb);
              },
              payBorrow: function payBorrow() {
                var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var fromBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
                var cb = arguments.length > 2 ? arguments[2] : undefined;
                return ws.events.PayBorrow({
                  filter: filter,
                  fromBlock: fromBlock
                }, cb);
              },
              liquidateBorrow: function liquidateBorrow() {
                var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var fromBlock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
                var cb = arguments.length > 2 ? arguments[2] : undefined;
                return ws.events.LiquidateBorrow({
                  filter: filter,
                  fromBlock: fromBlock
                }, cb);
              },
              allEvents: function allEvents(cb) {
                return ws.events.allEvents({
                  fromBlock: 'latest'
                }, cb);
              }
            });
          }).catch(reject);
        });
      }
    }], [{
      key: "create",
      value: function () {
        var _create = _asyncToGenerator__default['default']( _regeneratorRuntime__default['default'].mark(function _callee() {
          var tokenAddress,
              baseBorrowAnnualRate,
              blocksPerYear,
              utilizationRateFraction,
              _args = arguments;
          return _regeneratorRuntime__default['default'].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  tokenAddress = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
                  baseBorrowAnnualRate = _args.length > 1 ? _args[1] : undefined;
                  blocksPerYear = _args.length > 2 ? _args[2] : undefined;
                  utilizationRateFraction = _args.length > 3 ? _args[3] : undefined;
                  return _context.abrupt("return", new Promise(function (resolve, reject) {
                    var factor = 1e18;
                    if (!tokenAddress.match(/0x[a-fA-F0-9]{40}/) || baseBorrowAnnualRate === undefined || blocksPerYear === undefined || utilizationRateFraction === undefined) {
                      reject(new Error('Either the token address or the annual rate or the block per year or utilization rate are missing'));
                    }
                    var market = new rbankUtils.web3.eth.Contract(MarketContract.abi);
                    var deploy = market.deploy({
                      data: MarketContract.bytecode,
                      arguments: [tokenAddress.toLowerCase(), rbankUtils.web3.utils.toBN(new rbankUtils.BN(baseBorrowAnnualRate).div(new rbankUtils.BN(100)).times(new rbankUtils.BN(factor)).toNumber()), blocksPerYear, rbankUtils.web3.utils.toBN(new rbankUtils.BN(utilizationRateFraction).div(new rbankUtils.BN(100)).times(new rbankUtils.BN(factor)).toNumber())]
                    });
                    rbankUtils.web3.eth.getAccounts().then(function (_ref23) {
                      var _ref24 = _slicedToArray__default['default'](_ref23, 1),
                          from = _ref24[0];
                      return [from, deploy.estimateGas({
                        from: from
                      })];
                    }).then(function (result) {
                      return Promise.all(result);
                    }).then(function (_ref25) {
                      var _ref26 = _slicedToArray__default['default'](_ref25, 2),
                          from = _ref26[0],
                          gas = _ref26[1];
                      return deploy.send({
                        from: from,
                        gas: gas
                      });
                    })
                    .then(function (instance) {
                      return instance._address.toLowerCase();
                    }).then(resolve).catch(reject);
                  }));
                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        function create() {
          return _create.apply(this, arguments);
        }
        return create;
      }()
    }, {
      key: "Token",
      get: function get() {
        return Token;
      }
    }]);
    return Market;
  }();

  return Market;

})));
